webpackJsonp([1,14,16,19,23,24,25,27,28],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

var NavMazdaConstants = function() {

    this.MATRIX = {
        'sedan': __webpack_require__(63),
        'suv': __webpack_require__(64),
        'crossover': __webpack_require__(58),
        'minivan': __webpack_require__(62),
        'hatchback': __webpack_require__(60),
        'luxury': __webpack_require__(61),
        'convertible': __webpack_require__(57),
        'default': __webpack_require__(59)
    };

    this.MAKE = {
        name: 'Mazda',
        nicename: 'mazda',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885835&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885835&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037108/skeleton.gif'
    };

    this.IMG_HOST = '//static.ed.edmunds-media.com/unversioned';
    this.EVENT_TYPE_FIRE_IMPRESSION_TRACKING = 'fire_impression_tracking';
    this.NAV_ITEMS = ['nav_new_future_makes', 'nav_car_types', 'nav_research'];
    this.NAV_ITEMS_TYPES = ['newFuture', 'carTypes', 'researchMain', 'researchMake'];
    this.SLIDE_TRACKING_NUMBERS = [0, 1, 5];
};

module.exports = new NavMazdaConstants();

/***/ },
/* 3 */
/***/ function(module, exports) {

var NavFactory = function() {
    // consist of objects { niceName, name }
    var selected = {
        make: {},
        model: {},
        submodel: {},
        year: {}
    };

    this.resetSelected = function() {
        selected = {
            make: {},
            model: {},
            submodel: {},
            year: {}
        };
    };

    this.getSelected = function() {
        return selected;
    };

    this.setMake = function(value) {
        selected['make'] = value;
    };

    this.setModel = function(value) {
        selected['model'] = value;
    };

    this.setSubmodel = function(value) {
        selected['submodel'] = value;
    };

    this.setYear = function(value) {
        selected['year'] = value;
    };
};

module.exports = new NavFactory();

/***/ },
/* 4 */,
/* 5 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var validation = __webpack_require__(13);
var parseError = __webpack_require__(77);

var validators = {
    firstName: {test: validation.validateMinLength, errorText: 'First name can not be empty', minLength: 0},
    lastName: {test: validation.validateMinLength, errorText: 'Last name can not be empty', minLength: 0},
    email: {test: validation.validateEmail, errorText: 'Please enter your correct email address'},
    password: {test: validation.validateMinLength, errorText: 'Your password must be more than 6 characters long', minLength: 6},
    passwordConfirm : {test: validation.shouldMatch, errorText: 'Passwords do not match', shouldMatch: 'password'}
};

function validateField(form, input, errorBlock) {
    $(errorBlock).empty();
    var validator = validators[input.name];

    if (validator.shouldMatch) {
        var shouldMatchValue = $('input[name="' + validator.shouldMatch + '"]').val();
    }

    validator.test(input.value, validator.minLength, shouldMatchValue).done(function(result) {
        if (!result) {
            $(errorBlock).append('<li>' + validator.errorText + '</li>');
            highlightError(form.find('input[name="' + input.name + '"]'));
        } else {
            highlightSuccess(form.find('input[name="' + input.name + '"]'));
        }
    });
}

function isFormValid(form) {
    return form.find('.has-danger').length === 0;
}

function highlightError(element) {
    $(element).removeClass('form-control-success').addClass('form-control-danger')
              .parent().removeClass('has-success').addClass('has-danger');
}

function highlightSuccess(element) {
    $(element).removeClass('form-control-danger').addClass('form-control-success')
              .parent().removeClass('has-danger').addClass('has-success');
}

module.exports = {
    validateField: validateField,
    isFormValid: isFormValid,
    parseFirebaseError: parseError
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {module.exports = {
    /**
     * Main action entry generator, cannot be used directly since of predefined event types
     * Use action[eventType] methods instead, e.g. actionProgress
     *
     * @param {String} type
     * @param {String} actionName
     * @param {String} subActionName
     * @param overrides
     * @return {{event_type: *, event_data}}
     */
    action: function(type, actionName, subActionName, overrides) {
        var eventData = $.extend(true, {
            action_name: actionName,
            subaction_name: subActionName,
            action_category: 'user'
        }, overrides);

        return {
            event_type: type,
            event_data: eventData
        };
    },

    /**
     * Event type: action_completed
     *
     * @param {String} actionName
     * @param {String} subActionName
     * @param {{}} overrides
     * @return {*|{event_type, event_data}}
     */
    actionCompleted: function (actionName, subActionName, overrides) {
        return this.action('action_completed', actionName, subActionName, overrides);
    },

    /**
     * Event type: action_start
     *
     * @param {String} actionName
     * @param {String} subActionName
     * @param {{}} overrides
     * @return {*|{event_type, event_data}}
     */
    actionStart: function (actionName, subActionName, overrides) {
        return this.action('action_start', actionName, subActionName, overrides);
    },

    /**
     * Event type: action_progress
     *
     * @param {String} actionName
     * @param {String} subActionName
     * @param {{}} overrides
     * @return {*|{event_type, event_data}}
     */
    actionProgress: function (actionName, subActionName, overrides) {
        return this.action('action_progress', actionName, subActionName, overrides);
    },

    /**
     * Event type: action_end
     *
     * @param {String} actionName
     * @param {String} subActionName
     * @param {{}} overrides
     * @return {*|{event_type, event_data}}
     */
    actionEnd: function (actionName, subActionName, overrides) {
        return this.action('action_end', actionName, subActionName, overrides);
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 7 */,
/* 8 */
/***/ function(module, exports, __webpack_require__) {

var VehicleModels = __webpack_require__(49);

var NavDataAccess = function () {
    var dataObj = [];

    var sortDesc = function( a, b ) {
        return b - a;
    };

    var prettify = function(submodels) {
        var submodelMap = {};
        submodels.forEach(function(submodel) {
            if (typeof submodelMap[submodel.name] === 'object') {
                submodelMap[submodel.name].years.push(submodel.year);
            } else {
                submodelMap[submodel.name] = {};
                for(var k in submodel) {
                    switch(k) {
                    case 'year':
                        submodelMap[submodel.name]['years'] = [submodel[k]];
                        break;
                    default:
                        submodelMap[submodel.name][k] = submodel[k];
                        break;
                    }
                }
            }
        });

        // convert into array
        var arrayOfSubmodelsYears = [];
        for(var k in submodelMap) {
            submodelMap[k].years = submodelMap[k].years.sort(sortDesc);
            arrayOfSubmodelsYears.push(submodelMap[k]);
        }

        return arrayOfSubmodelsYears;
    };

    var getNewFutureModelYears = function(makeNiceName) {
        return VehicleModels.getSubmodelsYearsByMake(makeNiceName, 'name', 'PRE_PROD,NEW,NEW_USED')
            .then(prettify);
    };

    var getUsedModelYears = function(makeNiceName) {
        return VehicleModels.getSubmodelsYearsByMake(makeNiceName, 'name', 'NEW_USED,USED')
            .then(prettify);
    };

    var getNewModelYears = function(makeNiceName) {
        return VehicleModels.getSubmodelsYearsByMake(makeNiceName, 'name', 'NEW,NEW_USED')
            .then(prettify);
    };
    /* eslint-disable complexity */
    this.getModelYear = function(data, callback) {
        var makeNiceName = data.makeNiceName || '';
        var type = data.type || '';
        switch (type) {
        case 'newFuture':
            getNewFutureModelYears(makeNiceName).then(function(data){
                dataObj = data;
                callback(data);
            });
            break;
        case 'used':
            getUsedModelYears(makeNiceName).then(function(data){
                dataObj = data;
                callback(data);
            });
            break;
        case 'new':
            getNewModelYears(makeNiceName).then(function(data){
                dataObj = data;
                callback(data);
            });
            break;
        default:
            // do nothing
            break;
        }
    };
    /* eslint-enable complexity */

    this.getDataObj = function() {
        return dataObj;
    };
};

module.exports = new NavDataAccess();

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, global) {var firebase = null;

$(document).on('firebase.initialized', function() {
    firebase = window.firebase;
    _init();
});

var COOKIES = __webpack_require__(104);
var profileValidator = __webpack_require__(5);
var consoleWarn = global.console.warn;

var actionHadlers = {
    signIn: [],
    signOut: []
};

function on(action, cb) {
    var handlers = actionHadlers[action];

    if (!handlers) {
        handlers = [];
    }
    handlers.push(cb);
}

function onSignIn(user) {
    COOKIES.setItem('fb_accessToken', user._lat);
    COOKIES.setItem('fb_refreshToken', user.refreshToken);

    actionHadlers.signIn.forEach(function(cb) {
        cb(user);
    });
}

function onSignOut() {
    COOKIES.removeItem('fb_accessToken');
    COOKIES.removeItem('fb_refreshToken');

    actionHadlers.signOut.forEach(function(cb) {
        cb();
    });
}

function sendEmailVerification(user) {
    if (user && !user.emailVerified) {
        user.sendEmailVerification();
    }
}

function _init() {
    $(document).on('click', '.sign-drawer .google-button', function() {
        var provider = new firebase.auth.GoogleAuthProvider();
        provider.addScope('profile');
        provider.addScope('email');

        return firebase.auth().signInWithPopup(provider).then(function(result) {
            onSignIn(result.user);
        }).catch(function(error) {
            consoleWarn(profileValidator.parseFirebaseError(error));
        });
    });

    $(document).on('click', '.sign-drawer .facebook-button', function() {
        var provider = new firebase.auth.FacebookAuthProvider();
        provider.addScope('public_profile');
        provider.addScope('email');

        return firebase.auth().signInWithPopup(provider).then(function(result) {
            onSignIn(result.user);
        }).catch(function(error) {
            consoleWarn(profileValidator.parseFirebaseError(error));
        });
    });

    $(document).on('click', '[data-action="sign-out"]', function(e) {
        e.preventDefault();

        return firebase.auth().signOut().then(onSignOut).catch(function(error) {
            consoleWarn(profileValidator.parseFirebaseError(error));
        });
    });

    firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
            onSignIn(user);
        } else {
            onSignOut();
        }
    });
}

module.exports = {
    on: on,
    onSignIn: onSignIn,
    sendEmailVerification: sendEmailVerification
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(107)))

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(37);
/**
 * init function
 * @param $owlCarousels - owl carousel elements
 * i.e.
 * var owlCarousels = require('src/interlock/ui/owl-carousel/owl-carousel');
 * owlCarousels.init();
 * --- OR ---
 * var someModuleOwlCarousels = $('SOME_MODULE .owl-carousel');
 * var owlCarousels = require('src/interlock/ui/owl-carousel/owl-carousel');
 * owlCarousels.init(someModuleOwlCarousels);
 */
function init($owlCarousels) {
    var owlCarousel = $owlCarousels ? $owlCarousels : $('.owl-carousel'),
        constants = __webpack_require__(26),
        owlCarouselChanged = __webpack_require__(45),
        owlCarouselRefreshed = __webpack_require__(46),
        indexLabels = __webpack_require__(17),
        carouselDataOptions = __webpack_require__(39),
        arrowSwipers = __webpack_require__(38),
        refresh = __webpack_require__(43),
        /**
         * Timeout next/prev switch happens with
         * @type {number}
         */
        defaultTimeout = constants.DEFAULT_TIMEOUT,
        DEFAULT_OPTIONS = {
            items: 1,
            lazyLoad: false,
            owlLazy: true,
            loop: true,
            showArrows: true,
            autoplay: false,
            autoplayTimeout: 5000,
            autoplaySpeed: defaultTimeout,
            autoplayHoverPause: true
        };
    // Store a target event type (events below fire before an event 'changed')
    owlCarousel.on('drag.owl.carousel next.owl.carousel prev.owl.carousel to.owl.carousel', function (event) {
        $(this).data('event-type', event.type);
    });

    owlCarousel.on('initialized.owl.carousel', function (event) {
        var $element = $(this);
        // Store total count of slider items
        $element.data('total', event.item.count);

        // Init index labels if enabled
        if (indexLabels.isEnabled($element)) {
            indexLabels.set($element, 0);
        }
    });

    owlCarousel
        .on('translate.owl.carousel', function() {
            owlCarousel.parent().addClass('translating');
        })
        .on('translated.owl.carousel', function() {
            owlCarousel.parent().removeClass('translating');
        });

    owlCarouselRefreshed(owlCarousel);
    owlCarouselChanged(owlCarousel);

    function addOptionHacks(options) {
        // This hack used to solve owl-carousel bug on touch devices when we touch carousel and scroll page.
        // In this case carousel fire touchend event and
        // if autoplayHoverPause is true touchend event handler start autoplay w/o checking if autoplay is on
        if (!options.autoplay) {
            options.autoplayHoverPause = false;
        }
        if (options.pageCounter) {
            options.dots = true;
        }
    }

    function setUpOptions(options, $carousel) {
        addOptionHacks(options);
        if (options.alignArrows) {
            $carousel.siblings('.carousel-control').addClass(options.alignArrows + '-arrows-small');
        }
    }

    /**
     * In a case we have default navigation speed for carousel (defined by mapping in constants) we apply it
     * It can be overridden in atom configuration
     */
    function setUpNavigationSpeedOption(options) {
        if (!options.navigationSpeed) {
            options.navigationSpeed = constants.NAVIGATION_SPEEDS.hasOwnProperty(options.items) ?
                constants.NAVIGATION_SPEEDS[options.items] :
                defaultTimeout;
        }
    }

    var carouselsFontReady = [];
    owlCarousel.each(function(index, carousel) {
        var $carousel = $(carousel),
            carouselData = carouselDataOptions.getCarouselData($carousel),
            options = $.extend({}, DEFAULT_OPTIONS, carouselData);

        setUpOptions(options, $carousel);
        setUpNavigationSpeedOption(options);
        // For further use, e.g. in change events, etc.
        $carousel.data('options', options);

        if (carouselData.carouselType === 'ads') {
            $carousel.adsOwlCarousel(options);
        }
        else {
            $carousel.owlCarousel(options);
        }

        if (options.refreshWhenFontReady) {
            carouselsFontReady.push({carousel: $carousel, refreshWhenFontReady: options.refreshWhenFontReady});
        }
        arrowSwipers($carousel);
    });
    refresh.refreshWhenFontReady(carouselsFontReady);
    __webpack_require__(47)(owlCarousel);
}

init();

module.exports = {
    init: init
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 11 */
/***/ function(module, exports) {

/* name */
var RE_WRONG_CHARACTER = /[\d\*\^<>\\";:\[\]!@#\.]/,
    RE_THREE_SAME_CHARACTERS_CONSEQUENTLY = /(.)\1\1/i,
    RE_SEVEN_CONSONANTS_CONSEQUENTLY = /[bcdfghjklmnpqrstvwxz]{7,}/i,
    RE_VOWEL = /[aeiouy]/i;
/* email */
var RE_TWO_AT_SIGNS = /@.*@/,
    RE_HANDLER_HAS_NO_WRONG_CHARACTERS = /^[^\*\^<>\\";:\[\]!@#]+@/,
    RE_DOMAIN_HAS_NO_WRONG_CHARACTERS = /@[^\*\^<>\\";:\[\]!@#]+$/,
    RE_DOMAIN_HAS_PERIOD = /@([^\.]+\.)+[^\.]+$/;
/* phoneNumber */
var RE_TEN_DIGITS = /^\d{10}$/,
    RE_SEVEN_SAME_LAST_DIGITS = /(\d)\1{6}$/,
    RE_STARTS_NOT_WITH_01 = /^[^01]/,
    RE_WRONG_AREA_CODE = /^(222|333|411|444|456|500|555|666|777|911|900|999)/,
    RE_WRONG_PREFIX = /^\d{3}(411|555|611|911)/,
    TEN_NUMBER_PHONE_WITH_DASHES_BRACKETS = [
        /^\d{3}\s\d{3}\s\d{4}$/,
        /^\d{3}\s\d{3}-\d{4}$/,
        /^\d{3}-\d{3}-\d{4}$/,
        /^\(\d{3}\)\s\d{7}$/,
        /^\(\d{3}\)\s\d{3}-\d{4}$/,
        /^\(\d{3}\)\d{3}-\d{4}$/

    ],
    ELEVEN_NUMBER_PHONE_WITH_DASHES_BRACKETS = [
        /^1\d{10}$/,
        /^1-\d{3}-\d{3}-\d{4}$/,
        /^1\s\d{3}\s\d{3}\s\d{4}$/
    ];
/* zipCode */
var RE_FIVE_DIGITS = /^\d{5}$/;

function validateName(name) {
    if (!name) {
        return false;
    }
    name = name.trim();
    return name.length > 1 &&
        !RE_WRONG_CHARACTER.test(name) &&
        !RE_THREE_SAME_CHARACTERS_CONSEQUENTLY.test(name) &&
        !RE_SEVEN_CONSONANTS_CONSEQUENTLY.test(name) &&
        RE_VOWEL.test(name);
}

function validateEmail(email) {
    if (!email) {
        return false;
    }
    email = email.trim();
    return !RE_TWO_AT_SIGNS.test(email) &&
        RE_HANDLER_HAS_NO_WRONG_CHARACTERS.test(email) &&
        RE_DOMAIN_HAS_NO_WRONG_CHARACTERS.test(email) &&
        RE_DOMAIN_HAS_PERIOD.test(email);
}

function validatePhoneNumber(phone) {
    if (!phone) {
        return false;
    }
    phone = phone.trim();
    phone = getPhoneNumbers(phone); //use for case where we have dashes, brackets or start with 1
    return RE_TEN_DIGITS.test(phone) &&
        !RE_SEVEN_SAME_LAST_DIGITS.test(phone) &&
        RE_STARTS_NOT_WITH_01.test(phone) &&
        !RE_WRONG_AREA_CODE.test(phone) &&
        !RE_WRONG_PREFIX.test(phone);
}

function validateZipCode(zipCode) {
    if (!zipCode) {
        return false;
    }

    return RE_FIVE_DIGITS.test(zipCode);
}

function getPhoneNumbers (phone) {
    var hasElevenNumber = ELEVEN_NUMBER_PHONE_WITH_DASHES_BRACKETS.some(function (item) {
        return item.test(phone);
    });
    var hasTenNumber = TEN_NUMBER_PHONE_WITH_DASHES_BRACKETS.some(function (item) {
        return item.test(phone);
    });
    if(hasElevenNumber || hasTenNumber) {
        return getNumberWithoutDashes(phone, hasElevenNumber);
    }
    return phone;
}

function getNumberWithoutDashes (phone, hasElevenNumber) {
    var phoneNumbers = '';
    var currentPhoneSymbols = phone.split('');
    if(hasElevenNumber) {
        currentPhoneSymbols = currentPhoneSymbols.slice(1);
    }
    currentPhoneSymbols.forEach(function (symbol) {
        if(/\d/.test(symbol)) {
            phoneNumbers += symbol;
        }
    });
    return phoneNumbers;
}

function validateMinLength(field, minLength) {
    return field ? (field.length > minLength) : false;
}

module.exports = {
    getPhoneNumbers: getPhoneNumbers,
    validateName: validateName,
    validateEmail: validateEmail,
    validatePhoneNumber: validatePhoneNumber,
    validateZipCode: validateZipCode,
    validateMinLength: validateMinLength
};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var basicValidation = __webpack_require__(11);
var DEALER_LOCATOR = '1';
var pageValues = window.EDM.PageValues;

function fillUserInfo(formData) {
    return {
        'email': formData.email,
        'firstname': formData.firstname,
        'lastname': formData.lastname,
        'area': formData.phone.slice(0, 3),
        'phonePrefix': formData.phone.slice(3, 6),
        'phoneSuffix': formData.phone.slice(6)
    };
}

function fillData(formData, vehData, zipcode, leadOpportunityKey, timestamp){
    if(vehData.leadType === DEALER_LOCATOR){
        return fillDealerLocatorData(formData, vehData, zipcode, leadOpportunityKey, timestamp);
    }
    return fillNewCarLeadData(formData, vehData, zipcode, leadOpportunityKey, timestamp);
}

function fillDealerLocatorData(formData, selectedVehData, zip, leadOpportunityKey, timestamp) {
    return {
        'zipCode': zip,
        'userInfoDto': fillUserInfo(formData),
        'make': selectedVehData.make,
        'styleId': selectedVehData.styleId,
        'dealerId':selectedVehData.franchise,
//        'clientip': '10.32.221.21',
        'bannerCode': timestamp,
        'leadOpportunityKey': leadOpportunityKey,
        'referringurl': 'http://www.edmunds.com/inventory/lead_form_certificate.html',
        'tags': '#find'
    };
}

function fillNewCarLeadData(formData, selectedVehData, zip, leadOpportunityKey, timestamp) {
    return {
        'gpExpirationDate': selectedVehData.gpExpirationDate,
        'zipcode': zip,
        'userInfoDto': fillUserInfo(formData),
        'inventoryInfoDto': {
            'vin': selectedVehData.vin
        },
//        'clientip': '10.32.221.21',
        'bannerCode': timestamp,
        'leadOpportunityKey': leadOpportunityKey,
        'referringurl': 'http://www.edmunds.com/inventory/lead_form_certificate.html',
        'tags': '#find'
    };
}

function fillLeadOpportunityKey(vehData, index, totalPossibleLeads) {
    return {
        'leadNumber': index + 1,
        'totalSubmitted': index + 1,
        'position': vehData.position,
        'totalPossible': totalPossibleLeads
    };
}

var fillThankyouData = function(formData, selData){
    var submissions = [];
    selData.map(function (vehData) {
        var tempObj = {
            'vin':(vehData.vin ? vehData.vin : null),
            'dealer':(vehData.dealer ? vehData.dealer : null),
            'leadType': vehData.leadType
        };
        submissions.push(tempObj);
    });

    return {
        'firstName': formData.firstName.value,
        'lastName': formData.lastName.value,
        'submissions': submissions,
        'make': pageValues.vehicle.make.niceName || '',
        'model': pageValues.vehicle.model.niceName || '',
        'year': pageValues.vehicle.modelYear.year || ''
    };
};


function getFormData(form) {
    return {
        firstname: form.firstName.value,
        lastname: form.lastName.value,
        email: form.email.value,
        phone: basicValidation.getPhoneNumbers(form.phoneNumber.value)
    };
}

function reflect(promise) {
    return promise.then(function(v) {
        return { v:v, status: true };
    },  function (e) {
        return { e:e, status: false };
    });
}

function readyCollapse(){
    var pannelCollapse = $('.lead-form .panel-collapse');
    $('[data-toggle="popover"]').popover();

    pannelCollapse.on('show.bs.collapse hide.bs.collapse', function(e){
        $('.collapse-control', e.target.parentNode).addClass('hidden-xs-up');
    });
}

function switchToDrawer(fromSelector, toSelector) {
    $(fromSelector).modal('toggle');
    $(fromSelector).one('hidden.bs.modal', function() {
        $(toSelector).modal('toggle');
    });
}

function getThankYouPageUrl() {
    var tyUrl = '/groundwork/lead/thank-you/inventory/new/price-promise-multi-select/index.entry?entry-id=new-pp-multi-select-thank-you';

    return tyUrl;
}

module.exports = {
    fillThankyouData:fillThankyouData,
    fillNewCarLeadData: fillNewCarLeadData,
    fillLeadOpportunityKey: fillLeadOpportunityKey,
    fillDealerLocatorData:fillDealerLocatorData,
    getFormData:getFormData,
    fillData:fillData,
    reflect:reflect,
    readyCollapse:readyCollapse,
    switchToDrawer:switchToDrawer,
    getThankYouPageUrl:getThankYouPageUrl

};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var basic = __webpack_require__(11);
var verification = __webpack_require__(30);

// TODO: Add common validation messages
module.exports = {
    validateName: function(value) {
        // return new Promise(function(resolve, reject) {
        //     basic.validateName(value) ? resolve() : reject();
        // });
        return $.when(basic.validateName(value));
    },
    validateEmail: function(value) {
        // return new Promise(function(resolve, reject) {
        //     basic.validateEmail(value) ? resolve() : reject();
        // });
        return $.when(basic.validateEmail(value));
    },
    validatePhoneNumber: function(value) {
        // return new Promise(function(resolve, reject) {
        //     basic.validatePhoneNumber(value) ? resolve() : reject();
        // });
        return $.when(basic.validatePhoneNumber(value));
    },
    validateZipCode: function(value) {
        return $.when(basic.validateZipCode(value));
    },
    verifyEmail: function(value) {
        // return new Promise(function(resolve, reject) {
        //     verification.verifyEmail(value).then(function(data) {
        //         data.isValid ? resolve() : reject();
        //     }, reject);
        // });
        return verification.verifyEmail(value);
    },
    verifyPhoneNumber: function(value) {
        // return new Promise(function(resolve, reject) {
        //     verification.verifyPhoneNumber(value).then(function(data) {
        //         data.isValid ? resolve() : reject();
        //     }, reject);
        // });
        return verification.verifyPhoneNumber(value);
    },
    verifyZipCode: function(value) {
        return verification.verifyZipCode(value);
    },

    validateMinLength: function(value, minLength) {
        return $.when(basic.validateMinLength(value, minLength));
    },
    shouldMatch: function(value, skip, shouldMatchValue ) {
        return $.when( value == shouldMatchValue );
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 14 */,
/* 15 */
/***/ function(module, exports) {

/**
 * Helper to solve index issues with owl carousel
 *
 *
 *
 * Warning! Can be used only with single-item carousel as it does use page plugin to take index from
 *
 * @type {{getCorrectIndex: module.exports.getCorrectIndex}}
 */
module.exports = {

    /**
     * Calculates correct index for carousel events with the help of page plugin
     *
     * @param event
     * @return {number}
     */
    getCorrectIndex: function (event) {
        var pageIndex = event.page.index,
            index;

        // We should have separate logic for different page sizes
        if (event.page.size > 1) {
            index = event.item.index;
            if (index === null) {
                index = 0;
            }
        } else {
            index = pageIndex === -1 ? 0 : pageIndex;
        }
        return index;
    },

    /**
     * We need to know correct last item index when we achieve last slide page,
     * e.g. it's 2 (page num) for carousel with 5 items on page and 7 items in total (0 0 0 0 0 1 2)
     *
     * @param event
     * @return {number}
     */
    getCorrectLastIndexFromCarouselEvent: function (event) {
        var count = event.item.count,
            pageSize = event.page.size;

        // We have less items than item count on page option - it's always 0
        if (count < pageSize) {
            return 0;
        }

        // From whole number of items count we subtract page size, because currentIndex for any item on first page is 0
        return count - pageSize;
    }
};


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(31);

$(window).on('slide.bs.carousel', function (e) {
    var $carousel = $(e.target);
    var $carouselSlide = $(e.relatedTarget);
    var total = $carouselSlide.siblings().length + 1;
    var index = $carouselSlide.index();

    $carousel.find('.carousel-control.right').data('link-click', {
        carousel_total: total,
        carousel_index: (total + index + 1) % total,
        carousel_prev_index: index
    });
    $carousel.find('.carousel-control.left').data('link-click', {
        carousel_total: total,
        carousel_index: (total + index - 1) % total,
        carousel_prev_index: index
    });
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(36);

function setIndexLabels(carousel, currentIndex) {
    var INDEX_LABEL_CONTAINER_SELECTOR = '.carousel-index-label',
        PREV_INDEX_LABEL_CLASS = 'prev',
        NEXT_INDEX_LABEL_CLASS = 'next',
        INDEX_COUNTER_SELECTOR = '.index-count',
        TOTAL_COUNT_SELECTOR = '.total-count';

    var controls = carousel.siblings('.carousel-control').find(INDEX_LABEL_CONTAINER_SELECTOR),
        total = carousel.data('total'),
        currentSlideIndex = currentIndex + 1;


    controls.each(function(){
        var $control = $(this),
            $controlCounter = $control.find(INDEX_COUNTER_SELECTOR);

        $control.find(TOTAL_COUNT_SELECTOR).text(total);

        if ($control.hasClass(PREV_INDEX_LABEL_CLASS)){
            var previousSlideIndex = currentSlideIndex === 1? total : currentSlideIndex - 1;
            $controlCounter.text(previousSlideIndex);
        } else if ($control.hasClass(NEXT_INDEX_LABEL_CLASS)){
            var nextSlideIndex = currentSlideIndex === total? 1 : currentSlideIndex + 1;
            $controlCounter.text(nextSlideIndex);
        }
    });
}

function isLabelsEnabled(carousel) {
    return carousel.data('index-label') === true;
}

module.exports = {
    set: setIndexLabels,
    isEnabled: isLabelsEnabled
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 18 */
/***/ function(module, exports) {

/**
 * Module to handle first & last arrows disappearing if we reach first or last slide. It will track index
 * Does not to be applied to a loop carousels
 *
 * Usage:
 *
 *  var $carousel = $('.my-page-specific-carousel');
 *  var toggleArrowsVisibility = require('src/interlock/ui/owl-carousel/toggle-arrows-visibility');
 *  $carousel.on('changed.owl.carousel', function (event) {
 *      toggleArrowsVisibility($carousel, event.item.index, event.item.count);
 *  });
 */

/**
 * Shortcut for jquery toggleClass with class name predefined
 *
 * @param $target
 * @param flag
 * @return {undefined}
 */
function toggleInvisible($target, flag) {
    $target.toggleClass('invisible', flag);
}

/**
 * Get arrow element controls
 *
 * @param $carousel
 * @return {*}
 */
function getArrows($carousel) {
    return $carousel.siblings('.carousel-control');
}

/**
 * Hide/show arrows depending on current index and item count in carousel
 *
 * @param $carousel
 * @param index
 * @param lastIndex
 */
module.exports = function toggleArrowsVisibility($carousel, index, lastIndex) {
    var isFirstIndex = index === 0,
        isLastIndex = index === lastIndex,

        $arrows = getArrows($carousel),

        $leftArrow = $arrows.siblings('.left'),

        $rightArrow = $arrows.siblings('.right');

    toggleInvisible($leftArrow, isFirstIndex);
    toggleInvisible($rightArrow, isLastIndex);
};


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(51);
var REFRESH_ZONES = __webpack_require__(83);
var adManager = __webpack_require__(88).adManager;
var debounce = __webpack_require__(105);

var isUseUserScrollStart = false;
var isUseUserScrollEnd = false;

var isFirstScrollAfterLoadPage = true;
function userScrollHandler() {
    //skip first scroll, this may be programmatically scroll
    if (isFirstScrollAfterLoadPage) {
        isFirstScrollAfterLoadPage = false;
        return;
    }
    if (isUseUserScrollStart) {
        userScrollStarted();
    }
    else if (isUseUserScrollEnd) {
        userScrollFinished();
    }
    else {
        // anyway, if userScrollHandler was subscribed  by mistake
        $(window.document).off('scroll', userScrollHandler);
    }
}

var userScrollStarted = function() {
    userScrollFireEvent();
};

var userScrollFinished = debounce(500, function() {
    userScrollFireEvent();
});

function userScrollFireEvent() {
    $(window.document).off('scroll', userScrollHandler);
    var dataObj = {};
    dataObj.ts = (new Date()).getTime();
    adManager.refreshAdUnitsByZone(REFRESH_ZONES.USER_SCROLL,  dataObj);
}

var adhesionWrapper = $('.adhesion-wrapper');
isUseUserScrollStart = adhesionWrapper.data('user-scroll') === 'start';
isUseUserScrollEnd = adhesionWrapper.data('user-scroll') === 'end';

if (isUseUserScrollStart || isUseUserScrollEnd) {
    $(window.document).on('scroll', userScrollHandler);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(53);
__webpack_require__(52);
__webpack_require__(75);
__webpack_require__(70);
__webpack_require__(65);

__webpack_require__(76);

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(55);


/***/ },
/* 22 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 23 */
/***/ function(module, exports) {

var NavDrawerSlideStorage = function() {
    var slideNumQueue = [];
    
    this.addQueue = function(slideNum) {
        slideNumQueue.push(slideNum);
    };

    this.popQueue = function() {
        return slideNumQueue.pop();
    };

    this.getQueue = function() {
        return slideNumQueue;
    };

    this.clearQueue = function() {
        slideNumQueue = [];
    };
};

module.exports = new NavDrawerSlideStorage();

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var NavDomElements = function() {
    this.getMakeModelYearDom = function(parentId) {
        return {
            makesDiv: $( parentId + ' .makes'),
            modelsDiv: $( parentId + ' .models'),
            yearsDiv: $( parentId + ' .years'),
            modelsListDiv: $( parentId + ' .models .list'),
            yearsListDiv: $( parentId + ' .years .list')
        };
    };
};

module.exports = new NavDomElements();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

var NavTemplate = __webpack_require__(74);
var NavDrawerTemplate = __webpack_require__(71);
var NavDomElement = __webpack_require__(24);
var NavDrawerDomElement = __webpack_require__(69);
var NavDataAccess = __webpack_require__(8);
var NavFactory = __webpack_require__(3);
var NavLinkGenerator = __webpack_require__(73);
var trackingConst = __webpack_require__(4);

var NavPopulator = function() {

    this.populateModels = function(controller, parentId, publicationState, isDrawer) {
        var domElement = isDrawer ? NavDrawerDomElement : NavDomElement;
        var template = isDrawer ? NavDrawerTemplate : NavTemplate;
        var modelsListDiv = domElement.getMakeModelYearDom(parentId).modelsListDiv;
        modelsListDiv.empty();
        NavDataAccess.getDataObj().forEach(function (submodel) {
            var anchor = null;
            if(publicationState !== 'new') {
                anchor = template.modelAnchor(submodel);
                anchor.on('click', function (e) {
                    if(controller) {
                        controller.modelAnchorSelect(this, e);
                    }
                });
            } else {
                var url = NavLinkGenerator.getLinkOutUrl({
                    submodel: submodel,
                    publicationState: publicationState
                });
                anchor = template.linkOutAnchor(url, submodel.name);
            }
            anchor.attr('data-type', publicationState);
            anchor.attr('data-parent-id', parentId);
            anchor.attr(trackingConst.DATA_TRACKING_ID_ATTRIBUTE, 'nav_mmy_model_select');
            anchor.attr(trackingConst.DATA_TRACKING_VALUE_ATTRIBUTE, submodel.modelNiceId);
            modelsListDiv.append(anchor);
        });
        if(!isDrawer) {
            modelsListDiv.fadeIn(300);
        }
    };

    this.populateYears = function(controller, parentId, publicationState, isDrawer) {
        var domElement = isDrawer ? NavDrawerDomElement : NavDomElement;
        var template = isDrawer ? NavDrawerTemplate : NavTemplate;
        var yearsListDiv = domElement.getMakeModelYearDom(parentId).yearsListDiv;
        yearsListDiv.empty();
        var submodelYears = NavDataAccess.getDataObj().filter(function (submodel) {
            return submodel.name === NavFactory.getSelected().submodel.name;
        })[0].years;

        if(publicationState === 'used') {
            this.addSeeAllForSaleLink(yearsListDiv);
        }

        submodelYears.forEach(function (year) {
            var url = NavLinkGenerator.getLinkOutUrl({
                year: year,
                publicationState: publicationState
            });
            var anchor = template.linkOutAnchor(url, year);

            anchor.attr(trackingConst.DATA_TRACKING_ID_ATTRIBUTE, 'nav_mmy_year_select');
            anchor.attr(trackingConst.DATA_TRACKING_VALUE_ATTRIBUTE, year);
            yearsListDiv.append(anchor);
        });
        if(!isDrawer) {
            yearsListDiv.fadeIn(300);
        }
    };

    this.addSeeAllForSaleLink = function(yearsListDiv) {
        var seeAllForSaleLink = document.createElement('a'),
            selected = NavFactory.getSelected(),
            src = window.EDM.PageValues.page.timestamp;

        seeAllForSaleLink.href = '/used-cars-for-sale/i/' + selected.make.niceName + '/' + selected.model.niceName + '/?src=' + src;
        seeAllForSaleLink.classList.add('anchor', 'text-capitalize');
        seeAllForSaleLink.innerHTML = 'See All For Sale';

        yearsListDiv.append(seeAllForSaleLink);
    };
};

module.exports = new NavPopulator();


/***/ },
/* 26 */,
/* 27 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(56);
var setStickyTo = __webpack_require__(50);

var SELECTOR_NAV_BAR_ACTIVE_LINK = '.nav-link.active';
var $navBar = $('#subnav .navbar-nav');

/**
 * Offset 150 is far enough offset to cover global nav height + header height.
 */
$(document).ready(function() {
    $('body').scrollspy({offset: 150, target: '#subnav'});

    setStickyTo($('[data-toggle="sticky-on-scroll"]'));
});

/**
 * This handles for href with links for SEO purposes.
 * data-target is the id of the module where HREF is the link
 * i.e.
 * <a class="nav-link active" href="/groundwork/chevrolet/malibu/2017/safety/"
 *  data-target="#edm-entry-safety">
 *      safety
 * </a>
 */
$('#subnav .nav-link').on('click', function (e) {
    var target = $(this).data('target');
    if (target && !$(this).data('external-link')) {
        e.preventDefault();
        $(window).scrollTop($(target).offset().top);
    }
});

$(window).on('activate.bs.scrollspy', function(){
    var $activeCategory = $navBar.find(SELECTOR_NAV_BAR_ACTIVE_LINK);
    if($activeCategory.length){
        moveActiveCategoryToCenter($navBar, $navBar.find(SELECTOR_NAV_BAR_ACTIVE_LINK));
    }
});

function moveActiveCategoryToCenter($scrolledArea, $activeCategory){
    var scrollTo = $scrolledArea.scrollLeft()
        + $activeCategory.position().left
        - parseInt($scrolledArea.css('padding-left'))
        - $scrolledArea.width() / 2
        + $activeCategory.width() / 2;

    $scrolledArea.animate({
        scrollLeft: scrollTo,
        duration: 600
    });
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(85);


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var REQUEST_TIMEOUT = 5000;
var REQUEST_RETRY_COUNT = 2;

function _request(url, parameters, isPOST) {
    if(isPOST){
        return $.post({
            url: url,
            data: parameters
        });
    }
    return $.get({
        url: url,
        data: parameters,
        timeout: REQUEST_TIMEOUT
    });
}

function _retryRequest(url, parameters, resolve, reject, isPOST, retryNumber) {
    retryNumber = retryNumber || 0;

    _request(url, parameters, isPOST)
        .done(resolve)
        .fail(function(data) {
            if(retryNumber < REQUEST_RETRY_COUNT) {
                retryNumber++;
                _retryRequest(url, parameters, resolve, reject, retryNumber, isPOST);
            } else {
                reject(data);
            }
        });
}

/**
 * Make a reliable request
 * When it fails it is retried up to REQUEST_RETRY_COUNT times
 * @param  {String} url
 * @param  {Object} parameters
 * @param  {Boolean} isPOST
 * @return {Promise}
 */
function _reliableRequest(url, parameters, isPOST) {
    // return new Promise(function(resolve, reject) {
    //     _retryRequest(url, parameters, resolve, reject);
    // });
    var deferred = new $.Deferred();
    _retryRequest(url, parameters, deferred.resolve, deferred.reject, isPOST);
    return deferred;
}

module.exports = {
    reliableRequest: _reliableRequest
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

var validationUtils = __webpack_require__(29);
var usePOST = true;


/**
 * Verify an email address
 * @param  {String}     value
 * @return {Object}     data
 * @return {Boolean}    data.isValid
 * @return {Object}     data.options
 */
function _verifyEmailAddress(value) {
    var url = '/api/inventory/userinfoValidation/validateEmail';
    var parameters = {emailId: value};
    return validationUtils.reliableRequest(url, parameters, usePOST).then(function(data) {
        var isValid = !!(data.result.match(/^(verified|unknown)$/i));

        return {
            isValid: isValid,
            options: data
        };
    });
}

/**
 * Verify a phone number type
 * @param  {String}     value
 * @param  {Array}      types
 * @return {Object}     data
 * @return {Boolean}    data.isValid
 * @return {Object}     data.options
 */
function _verifyPhoneNumberType(value, types) {
    var url = '/api/inventory/userinfoValidation/validatePhoneNumber';
    var parameters = {number: value};

    return validationUtils.reliableRequest(url, parameters, usePOST).then(function(data) {
        var pattern = new RegExp('^(' + types.join('|') + ')$', 'i');
        var isValid = !!(data.phoneType.match(pattern));

        return {
            isValid: isValid,
            options: data
        };
    });
}

function _verifyZipCode(value) {
    var url = '/api/region/zip/validation/' + value;
    var parameters = { format: 'json' };

    return validationUtils.reliableRequest(url, parameters).then(function(data) {
        return {
            isValid: data[value] === 'true',
            options: data
        };
    });
}

function _verifyPhoneNumber(value) {
    return _verifyPhoneNumberType(value, ['LandLine', 'Mobile']);
}

function _verifyMobileNumber(value) {
    return _verifyPhoneNumberType(value, ['Mobile']);
}

function _verifyLandLineNumber(value) {
    return _verifyPhoneNumberType(value, ['LandLine']);
}

/**

 Example:

 var verificator = require('src/interlock/no-ui/validation/common/verification');

 verificator.verifyEmail('test@edmunds.com').then(function(data) {
    var isValid = data.isValid;
    var options = data.options;
});

 */

module.exports = {
    verifyEmail: _verifyEmailAddress,
    verifyLandLineNumber: _verifyLandLineNumber,
    verifyMobileNumber: _verifyMobileNumber,
    verifyPhoneNumber: _verifyPhoneNumber,
    verifyZipCode: _verifyZipCode
};


/***/ },
/* 31 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 32 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 33 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 34 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 35 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 36 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {(function($) {

    function AdsOwl(element, options) {
        if(element || options ) { true; } // this is here because of linting rules; remove at your own risk.
        $.fn.owlCarousel.Constructor.apply(this, arguments);
    }

    AdsOwl.prototype  = Object.create($.fn.owlCarousel.Constructor.prototype);
    AdsOwl.prototype.constructor = AdsOwl;

    //Override carousel navigation method 'to'
    var superOwlCarouselMethodTo = AdsOwl.prototype.to;
    AdsOwl.prototype.to = function(position, speed) {
        if (position < 0) {
            //reverse loop from first to last without using cloned node
            var items = this._items.length;
            var current = items + 2;

            position = items + 1;
            this.reset(current);

            this.speed(this.duration(current, position, speed));
            this.current(position);

            if (this.$element.is(':visible')) {
                this.update();
            }
        } else {
            superOwlCarouselMethodTo.apply(this, arguments);
        }
    };

    var superOwlCarouselMethodUpdate = AdsOwl.prototype.update;
    AdsOwl.prototype.update = function() {
        superOwlCarouselMethodUpdate.apply(this, arguments);

        var clonedItems = this.$element.find('.owl-item.cloned .item');

        $(clonedItems).remove();
    };

    $.fn.adsOwlCarousel = function(option) {
        var args = Array.prototype.slice.call(arguments, 1);
        var Owl = $.fn.owlCarousel.Constructor;

        return this.each(function() {
            var $this = $(this),
                data = $this.data('owl.carousel');

            if (!data) {
                data = new AdsOwl(this, typeof option == 'object' && option);
                $this.data('owl.carousel', data);

                $.each([
                    'next', 'prev', 'to', 'destroy', 'refresh', 'replace', 'add', 'remove'
                ], function(i, event) {
                    data.register({ type: Owl.Type.Event, name: event });
                    data.$element.on(event + '.owl.carousel.core', $.proxy(function(e) {
                        if (e.namespace && e.relatedTarget !== this) {
                            this.suppress([ event ]);
                            data[event].apply(this, [].slice.call(arguments, 1));
                            this.release([ event ]);
                        }
                    }, data));
                });
            }
            if (typeof option == 'string' && option.charAt(0) !== '_') {
                data[option].apply(data, args);
            }
        });
    };

})(__webpack_provided_window_dot_jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 38 */
/***/ function(module, exports) {

/**
 * Arrow swipers
 *
 * @param $carousel
 */
module.exports = function ($carousel) {
    var navigationSpeed = $carousel.data('options').navigationSpeed;
    $carousel
      .parent()
      .on('click', '.carousel-control.left .icon-prev', function() {
          $carousel.trigger('prev.owl.carousel', [navigationSpeed]);

      })
      .on('click', '.carousel-control.right .icon-next', function() {
          $carousel.trigger('next.owl.carousel', [navigationSpeed]);
      });
};


/***/ },
/* 39 */
/***/ function(module, exports) {

/**
 * Carousel data processor (set via data-carousel-options in ftl)
 *
 *
 * @type {{}}
 */
module.exports = {

    /**
     *
     * @param $carousel
     * @return {*}
     */
    getCarouselData: function getCarouselData($carousel) {
        var data = $carousel.data('carouselOptions');

        // If we have invalid JSON in ftl and cannot proceed or we don't have carousel options set at all (full default)
        if (typeof data === 'string') {
            return {};
        }
        return data || {};
    }
};


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(32);

module.exports = {
    hideArrows: function($carousel) {
        $carousel.addClass('hide-arrows');
    },
    showArrows: function($carousel) {
        $carousel.removeClass('hide-arrows');
    }
};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(33);

var DOT_CLASS = 'dots-enabled';

function enableDots($owlCarousel) {
    $owlCarousel.addClass(DOT_CLASS);
}

function disableDots($owlCarousel) {
    $owlCarousel.removeClass(DOT_CLASS);
}

module.exports = {
    enableDots: enableDots,
    disableDots: disableDots
};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(34);

var PAGE_COUNTER_CLASS = 'page-counter-enabled';

function enablePageCounter($owlCarousel) {
    $owlCarousel.addClass(PAGE_COUNTER_CLASS);
}

function disablePageCounter($owlCarousel) {
    $owlCarousel.removeClass(PAGE_COUNTER_CLASS);
}

module.exports = {
    enablePageCounter: enablePageCounter,
    disablePageCounter: disablePageCounter
};


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

var eventToolbox = __webpack_require__(1),
    responsiveToolkit = __webpack_require__(7);

function refresh(carousels) {
    carousels.forEach(function (obj) {
        if (responsiveToolkit.is(obj.refreshWhenFontReady)) {
            obj.carousel.trigger('refresh.owl.carousel');
        }
    });
}

function refreshWhenFontReady(carousels) {
    eventToolbox.subscribeCustomEvent('webfont.loaded', function () {
        refresh(carousels);
    });

    /**
     * TODO: find more appropriate solution to redraw only specified carousels,
     * TODO: not all carousels on every deferred css load
     */
    eventToolbox.subscribeCustomEvent('defer-css-loaded', function () {
        refresh(carousels);
    });
}

module.exports = {
    refreshWhenFontReady: refreshWhenFontReady
};


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(35);

module.exports = {
    removeLeftStagePadding: function ($carousel) {
        $carousel.addClass('stage-padding-right');
    }
};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * This is global owl carousel onChanged listener
 *
 */
var indexHelper = __webpack_require__(15),
    eventToolbox = __webpack_require__(1),
    indexLabels = __webpack_require__(17),
    constants = __webpack_require__(26),
    toggleArrowsVisibility = __webpack_require__(18),

    EVENT_TYPE_DATA_CAROUSEL_ATTRIBUTE = 'event-type',
    PREVIOUS_INDEX_DATA_CAROUSEL_ATTRIBUTE = 'prev-index';

/**
 * Finds a creative of the element and returns it's idenrifier
 * @param  {Object} $element
 * @return {String|undefined}
 */
function getElementCreativeId($element) {
    var $creative = $element.closest('.edm-entry');
    if ($creative && $creative.length > 0) {
        return $creative.attr('id');
    }
}

module.exports = function subscribeChangedEvent($carousel) {

    $carousel.on('changed.owl.carousel', function (event) {
        var $element = $(this);
        var prevIndex = $element.data(PREVIOUS_INDEX_DATA_CAROUSEL_ATTRIBUTE);
        var eventType = $element.data(EVENT_TYPE_DATA_CAROUSEL_ATTRIBUTE);
        var currentIndex = indexHelper.getCorrectIndex(event);
        var count = event.item.count;
        var carouselOptions = $element.data('options');

        if (indexLabels.isEnabled($element)) {
            indexLabels.set($element, currentIndex);
        }

        if (['drag', 'next', 'prev', 'to'].indexOf(eventType) !== -1) {
            //TODO [FIND-1623] Remove this logic for at-a-glance because we don't want it to fire when it appends photos from the ajax call
            if(getElementCreativeId($element) === 'edm-entry-at-a-glance'
                && window.EDMDataStorage.aagChangeSlideSkipPixelFire) {
                window.EDMDataStorage.aagChangeSlideSkipPixelFire = false;
            } else {
                eventToolbox.fireCustomEvent(constants.OWL_CAROUSEL_SWIPE_EVENT_NAME, [
                    getElementCreativeId($element),
                    {
                        carousel_index: currentIndex,
                        carousel_prev_index: prevIndex,
                        carousel_total: count
                    }
                ]);
            }

            $element.data(EVENT_TYPE_DATA_CAROUSEL_ATTRIBUTE, '');
        }
        $element.data(PREVIOUS_INDEX_DATA_CAROUSEL_ATTRIBUTE, currentIndex);

        if (carouselOptions && !carouselOptions.loop) {

            toggleArrowsVisibility(
                $element, currentIndex, indexHelper.getCorrectLastIndexFromCarouselEvent(event)
            );
        }
    });
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * This is global owl carousel onRefreshed listener
 *
 */

var indexHelper = __webpack_require__(15),
    toggleArrowsVisibility = __webpack_require__(18),
    pageCounter = __webpack_require__(42),
    dots = __webpack_require__(41),
    stagePadding = __webpack_require__(44),
    arrowsControl = __webpack_require__(40);

function showHidePageCounter(isPageCounterAvailable, $carousel) {
    if (typeof isPageCounterAvailable !== 'boolean') {
        return;
    }

    if (isPageCounterAvailable) {
        pageCounter.enablePageCounter($carousel);
    } else {
        pageCounter.disablePageCounter($carousel);
    }
}

function showHideDots(isPageDotsAvailable, $carousel) {
    if (typeof isPageDotsAvailable !== 'boolean') {
        return;
    }

    if (isPageDotsAvailable) {
        dots.enableDots($carousel);
    } else {
        dots.disableDots($carousel);
    }
}

function showHideArrows(isPageArrowsAvailable, $carousel) {
    if (typeof isPageArrowsAvailable !== 'boolean') {
        return;
    }

    if (isPageArrowsAvailable) {
        arrowsControl.showArrows($carousel);
    } else {
        arrowsControl.hideArrows($carousel);
    }

}

function setStagePaddingRight(isStagePaddingRightAvailable, $carousel) {
    if (typeof isStagePaddingRightAvailable !== 'boolean') {
        return;
    }

    if (isStagePaddingRightAvailable) {
        stagePadding.removeLeftStagePadding($carousel);
    }
}

module.exports = function subscribeRefreshedEvent($carousels) {
    /**
     * Needed for INITIAL toggle arrows, because only refreshed event knows how much items we have on initial
     * This event does not trigger on carousel changed/dragged/to events, only on carousel breakpoint change (resize)
     */
    $carousels.on('refreshed.owl.carousel', function (event) {
        var $element = $(this);
        var carouselOptions = $element.data('options');
        var currentIndex = indexHelper.getCorrectIndex(event);
        var isPageCounterAvailable,
            isDotsAvailable,
            isArrowsAvailable,
            isStagePaddingRightAvailable;

        if (carouselOptions && !carouselOptions.loop) {
            // From whole number of items count we subtract page size, because currentIndex is page first item index
            toggleArrowsVisibility(
                $element, currentIndex, indexHelper.getCorrectLastIndexFromCarouselEvent(event)
            );
        }

        if (event.relatedTarget && event.relatedTarget.settings) {
            isPageCounterAvailable = event.relatedTarget.settings.pageCounter;
            isDotsAvailable = event.relatedTarget.settings.showDots;
            isArrowsAvailable = event.relatedTarget.settings.showArrows;
            isStagePaddingRightAvailable = event.relatedTarget.settings.stagePaddingRight;
        }
        showHidePageCounter(isPageCounterAvailable, $element);
        showHideDots(isDotsAvailable, $element);
        showHideArrows(isArrowsAvailable, $element);
        setStagePaddingRight(isStagePaddingRightAvailable, $element);
    });
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * Lazy load handling for owl carousel
 */
function itemIndex(index, total) {
    return (index + total) % total;
}

function init(owlCarousel) {
    owlCarousel.on('translated.owl.carousel', function(event) {
        var $carousel = $(this),
            options = $carousel.data('options');

        if (options && !options.owlLazy) {
            return;
        }

        var totitem = event.item.count;
        var index = $(event.target).find('.owl-item.active .item').data('index');
        var nextitems = [
            itemIndex(index - 1, totitem),
            itemIndex(index, totitem),
            itemIndex(index + 1, totitem)

        ];
        nextitems.forEach(function(nextitem) {
            var items = $(event.target).find('[data-index="' + nextitem + '"]').find('[data-src]');
            for(var i=0; i<items.length; i++) {
                var item = $(items[i]);
                if (!item.data('cached') && item.data('src')) {
                    item.css({'background-image': 'url(' + item.data('src') + ')'})
                        .data('cached', true);
                }
            }
        });
    });
}

module.exports = init;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 48 */,
/* 49 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var
    /**
     *
     * @type {string[]}
     */
    GET_MODELS_FIELDS = [
        'id',
        'name',
        'niceId',
        'modelYears(id,year)'
    ],
    /**
     *
     * @type {string[]}
     */
    GET_SUBMODELS_FIELDS = [
        'id',
        'name',
        'niceId',
        'makeName',
        'makeNiceName',
        'modelName',
        'modelNiceId',
        'year',
        'publicationStates'
    ],

    /**
     *
     * @type {string}
     */
    DEFAULT_SORT_FIELD = 'name',

    /**
     *
     * @type {string}
     */
    DEFAULT_MODEL_STATES = 'NEW',

    /**
     * Page number for models / submodels request
     * @type {number}
     */
    PAGE_NUM = 1,

    /**
     * Page size for models / submodels request
     * @type {number}
     */
    PAGE_SIZE = 1500; // - why 1500? - more details you can have a look here: https://edmunds.atlassian.net/browse/FIND-2846


module.exports = {

    /**
     * Retrieves complete model list
     *
     * api/vehicle/v3/models?makeNiceId=aston-martin&fields=id,name,niceId,modelYears(id,year)&sortby=name&publicationStates=NEW,NEW_USED
     *
     * E.g. qa-11-www.edmunds.com/api/vehicle/v3/models?
     *   makeNiceId=aston-martin&
     *   fields=id,name,niceId,modelYears(id,year)&
     *   sortby=name&publicationStates=NEW,NEW_USED
     *
     * @param {string} makeNiceId
     * @param {string} sort
     * @param {string} states
     * @return {*}
     */
    getModelsYearsByMake: function (makeNiceId, sort, states) {
        return $.getJSON(
            '/api/vehicle/v3/models/',
            {
                makeNiceId: makeNiceId,
                fields: GET_MODELS_FIELDS.join(','),
                sortby: sort ? sort : DEFAULT_SORT_FIELD,
                publicationStates: states ? states : DEFAULT_MODEL_STATES,
                pagenum: PAGE_NUM,
                pagesize: PAGE_SIZE
            }
        ).then(function(response){
            //TODO: remove after the last changes of /api/vehicle/v3/models/ are on prod
            return Array.isArray(response)? response : response.results;
        }).then(function (modelsYearsList) {
            return modelsYearsList.map(function (modelYears) {
                modelYears.years = modelYears.modelYears.reduceRight(function (yearsList, yearObject) {
                    return yearsList.push(yearObject.year) && yearsList;
                }, []);
                return modelYears;
            });
        });
    },
    /**
     * Retrieves complete submodels list
     *
     * api/vehicle/v3/submodels?makeNiceName=acura&sortby=name&publicationStates=NEW
     *
     * E.g. qa-11-www.edmunds.com/api/vehicle/v3/submodels?makeNiceName=acura&sortby=name&publicationStates=NEW
     *
     * @param {string} make
     * @param {string} sort
     * @param {string} states
     * @return {*}
     */
    getSubmodelsYearsByMake: function (makeNiceId, sort, states) {
        return $.getJSON(
            '/api/vehicle/v3/submodels',
            {
                makeNiceId: makeNiceId,
                fields: GET_SUBMODELS_FIELDS.join(','),
                sortby: sort ? sort : DEFAULT_SORT_FIELD,
                publicationStates: states ? states : DEFAULT_MODEL_STATES,
                pagenum: PAGE_NUM,
                pagesize: PAGE_SIZE
            }
        ).then(function(response){
            //TODO: remove after the last changes of /api/vehicle/v3/models/ are on prod
            return Array.isArray(response)? response : response.results;
        });
    },

    /**
     * Getting price & detailed information for a specific style
     * E.G. //www.edmunds.com/api/vehicle/v3/styles?id=100812301
     *
     * @param {string} styleId
     * @param {string} publicationState
     * @param {string} year
     * @return {*}
     */

    getVehicleByStyleId: function(styleId,publicationState,year){return $.getJSON(
        '/api/vehicle/v3/styles',
        {
            id: styleId,
            publicationState:publicationState,
            year: year
        }
    ).then(function(response){
            //TODO: remove after the last changes of /api/vehicle/v3/models/ are on prod
        return Array.isArray(response)? response : response.results;
    });
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var stickyHelper = $('<div>').addClass('sticky-wrapper');

function _process($stickyTarget, scrollElement) {
    var scrollTop;
    if(scrollElement) {
        scrollTop = $(scrollElement).scrollTop();
    } else {
        scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    }

    var stickyHeight = $stickyTarget.outerHeight();
    var stickyTop = stickyHelper.offset().top;
    if (scrollTop >= stickyTop){
        stickyHelper.height(stickyHeight);
        $stickyTarget.addClass('pos-f-t');
    } else {
        $stickyTarget.removeClass('pos-f-t');
        stickyHelper.height('auto');
    }
}

function setStickyTo(target, scrollElement) {
    var $stickyTarget = $(target);
    $stickyTarget.before(stickyHelper);
    $stickyTarget.addClass('sticky');
    _process($stickyTarget, scrollElement);
    $(window).on('scroll.sticky-on-scroll', function() {
        _process($stickyTarget, scrollElement);
    });
}

module.exports = setStickyTo;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 51 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 52 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 53 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 54 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 55 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 56 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 57 */
/***/ function(module, exports) {

module.exports = [
    {
        name: 'MX-5 Miata',
        nicename: 'mx5miata',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885842&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885842&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037114/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885849&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037100/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885849&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2016_Mazda_MX5_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885871&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037218/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885871&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2016_Mazda_MX5_Miata_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885842&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885842&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037114/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885856&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885856&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037238/skeleton.gif'
            }
        }
    },
    {
        name: 'MX-5 Miata RF',
        nicename: 'mx5miatarf',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885750&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885750&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037116/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885751&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037098/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885751&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2017_Mazda_MX5_RF_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885754&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037226/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885754&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2017_Mazda_MX5_Miata_RF_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885750&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885750&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037116/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885752&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885752&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037240/skeleton.gif'
            }
        }
    }
];

/***/ },
/* 58 */
/***/ function(module, exports) {

module.exports = [
    {
        name: 'CX-3',
        nicename: 'cx3',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885839&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885839&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037124/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885846&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037104/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885846&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2017_Mazda_CX3_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885868&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037228/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885868&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2017_Mazda_CX3_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885839&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885839&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037124/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885839&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885839&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037124/skeleton.gif'
            }
        }
    },
    {
        name: 'CX-5',
        nicename: 'cx5',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885840&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885840&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037118/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885847&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037106/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885847&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2016_Mazda_CX5_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885869&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037216/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885869&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2016_Mazda_CX5_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885840&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885840&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037118/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885854&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885854&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037242/skeleton.gif'
            }
        }
    },
    {
        name: 'CX-9',
        nicename: 'cx9',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885841&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885841&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037112/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885848&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037096/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885848&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2016_Mazda_CX9_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885870&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037214/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885870&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2016_Mazda_CX9_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885841&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885841&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037112/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885855&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885855&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037244/skeleton.gif'
            }
        }
    }
];

/***/ },
/* 59 */
/***/ function(module, exports) {

module.exports = [
    {
        name: 'Mazda 3 Sedan',
        nicename: '3',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885836&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885836&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037110/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885843&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037092/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885843&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2017_Mazda3_4dr_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885865&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037224/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885865&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2017_Mazda3_4dr_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885836&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885836&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037110/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885850&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885850&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037234/skeleton.gif'
            }
        }
    }
];

/***/ },
/* 60 */
/***/ function(module, exports) {

module.exports = [
    {
        name: 'Mazda 3 Hatchback',
        nicename: '3',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885837&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885837&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037120/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885844&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037094/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885844&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2017_Mazda3_5dr_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885866&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037222/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885866&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2017_Mazda3_5dr_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885837&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885837&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037120/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885851&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885851&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037236/skeleton.gif'
            }
        }
    }
];

/***/ },
/* 61 */
/***/ function(module, exports) {

module.exports = [
    {
        name: 'CX-9',
        nicename: 'cx9',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885841&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885841&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037112/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885848&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037096/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885848&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2016_Mazda_CX9_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885870&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037214/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885870&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2016_Mazda_CX9_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885841&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885841&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037112/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885855&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885855&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037244/skeleton.gif'
            }
        }
    }
];

/***/ },
/* 62 */
/***/ function(module, exports) {

module.exports = [
    {
        name: 'CX-5',
        nicename: 'cx5',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885840&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885840&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037118/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885847&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037106/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885847&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2016_Mazda_CX5_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885869&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037216/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885869&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2016_Mazda_CX5_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885840&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885840&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037118/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885854&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885854&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037242/skeleton.gif'
            }
        }
    }
];

/***/ },
/* 63 */
/***/ function(module, exports) {

module.exports = [
    {
        name: 'Mazda 3 Sedan',
        nicename: '3',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885836&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885836&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037110/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885843&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037092/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885843&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2017_Mazda3_4dr_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885865&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037224/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885865&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2017_Mazda3_4dr_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885836&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885836&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037110/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885850&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885850&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037234/skeleton.gif'
            }
        }
    },
    {
        name: 'Mazda 6',
        nicename: '6',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885838&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885838&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037122/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885845&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037102/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885845&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2017_Mazda6_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885867&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037220/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885867&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2017_Mazda6_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885838&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885838&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037122/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885852&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885852&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037230/skeleton.gif'
            }
        }
    }
];

/***/ },
/* 64 */
/***/ function(module, exports) {

module.exports = [
    {
        name: 'CX-3',
        nicename: 'cx3',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885839&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885839&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037124/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885846&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037104/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885846&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2017_Mazda_CX3_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885868&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037228/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885868&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2017_Mazda_CX3_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885839&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885839&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037124/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885839&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885839&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037124/skeleton.gif'
            }
        }
    },
    {
        name: 'CX-5',
        nicename: 'cx5',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885840&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885840&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037118/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885847&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037106/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885847&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2016_Mazda_CX5_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885869&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037216/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885869&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2016_Mazda_CX5_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885840&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885840&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037118/skeleton.gif'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885869&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037216/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885869&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2016_Mazda_CX5_277x55.jpg'
            }
        }
    },
    {
        name: 'CX-9',
        nicename: 'cx9',
        modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885841&PluID=0&ord=[timestamp]',
        impressionTracker1:
            'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885841&PluID=0&ord=[timestamp]&rtu=-1',
        impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037112/skeleton.gif',
        img: {
            wired: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885848&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037096/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885848&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/170111_2016_Mazda_CX9_Wired.jpg'
            },
            mobile: {
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885870&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037214/skeleton.gif',
                clickTracker:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885870&PluID=0&ord=[timestamp]',
                imgURL: '/unit/nav-mazda-sponsorship/mobile/170111_2016_Mazda_CX9_277x55.jpg'
            }
        },
        link: {
            wired: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885841&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885841&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037112/skeleton.gif'
            },
            mobile: {
                modelURL: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885855&PluID=0&ord=[timestamp]',
                impressionTracker1:
                    'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=19&mc=imp&pli=19885855&PluID=0&ord=[timestamp]&rtu=-1',
                impressionTracker2: 'https://pixel.adsafeprotected.com/rfw/st/53466/12037244/skeleton.gif'
            }
        }
    }
];

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(54);
var helper = __webpack_require__(66);
var eventToolbox = __webpack_require__(1);
var sponsorshipConstants = __webpack_require__(2);
var responsiveToolkit = __webpack_require__(7);

var requestData = {
        'userId': window.EDM.visitor.id || '',
        'timeStamp': window.EDM.PageValues.page.timestamp || '',
        'pageName': window.EDM.PageValues.page.name || ''
    },
    vehicle,
    firstDropdown = true;
var darklaunch = __webpack_require__(14);

function attachEvent(vehicle) {
    eventToolbox.subscribeCustomEvent(sponsorshipConstants.EVENT_TYPE_FIRE_IMPRESSION_TRACKING, function(e, data) {
        var isMobile = responsiveToolkit.is('<=sm') ? true : false;
        helper.fireImpressionTracking(vehicle, isMobile, data);
    });
    eventToolbox.subscribeCustomEvent('small-mmy-drawer-opened', function() {
        window.EDMDataStorage['vehicle'] = vehicle;
    });
}

function setRandomVehicle(textStatus, types) {
    if (textStatus === 'success') {
        vehicle = types === null ? helper.getRandomVehicle('default') : helper.getRandomVehicle(types[0]);
    } else {
        vehicle = helper.getRandomVehicle('default');
    }
}

function processNavSponsorship(jqXHR, textStatus) {
    if(jqXHR.types && isEnabledSegment(jqXHR.types[0])){
        $('.sponsorship-item').each(function(){
            appendNavAdToContainer(this);
        });
        appendNavAdToContainer();//call for drawer
    } else {
        setRandomVehicle(textStatus, jqXHR.types);
        helper.appendImageToHeader(vehicle);

        attachEvent(vehicle);
        $('.navbar-menu').on('click', function () {
            if(darklaunch.storyEnabled('TMT-207')) {
                if(firstDropdown) {
                    firstDropdown = false;
                } else {
                    eventToolbox.fireCustomEvent(sponsorshipConstants.EVENT_TYPE_FIRE_IMPRESSION_TRACKING, {});
                }
            } else {
                eventToolbox.fireCustomEvent(sponsorshipConstants.EVENT_TYPE_FIRE_IMPRESSION_TRACKING, {});
            }
        });

        if (requestData.pageName === 'home_page') {
            helper.setSponsorshipExampleMakeHP();
            helper.setSponsorshipExampleModelHP(vehicle);

            if (!darklaunch.storyEnabled('TMT-207')) {
                eventToolbox.fireCustomEvent(sponsorshipConstants.EVENT_TYPE_FIRE_IMPRESSION_TRACKING,
                    {tabId: '#' + sponsorshipConstants.NAV_ITEMS[0]});
            }
        }

        if(darklaunch.storyEnabled('TMT-207')) {
            eventToolbox.fireCustomEvent(sponsorshipConstants.EVENT_TYPE_FIRE_IMPRESSION_TRACKING,
                {tabId: '#' + sponsorshipConstants.NAV_ITEMS[0]});
        }
    }
}

function appendNavAdToContainer(container) {
    container = container || '.sponsorship-item-small';
    $(container).find('.punit-wrapper > div').addClass('punit').asyncGptTag({});
}

function isEnabledSegment(type) {
    return (type === 'crossover' && $('.sponsorship-item').first().hasClass('wtf-nav-ad'));
}

if (requestData.userId && requestData.timeStamp && requestData.pageName && helper.hasSponsorshipData()) {
    $.ajax({
        type: 'POST',
        url: '//udm.edmunds.com/api/segment',
        contentType: 'application/json',
        data: JSON.stringify(requestData),
        dataType: 'json'
    }).always(processNavSponsorship);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var trackingConst = __webpack_require__(4);
var responsiveToolkit = __webpack_require__(7);
var docCookies = __webpack_require__(91);
var timestamp = window.EDM.PageValues.page.timestamp;
var NMConst = __webpack_require__(2);
var IMG_HOST = NMConst.IMG_HOST;
var GLOBAL_NAV_SPONSORSHIP_CONST;
var QUICK_LINKS_SPONSORSHIP_CONST;

function hasSponsorshipData() {
    QUICK_LINKS_SPONSORSHIP_CONST = window.EDMDataStorage['quickLinksSponsorshipData'] ?
        window.EDMDataStorage['quickLinksSponsorshipData'].MAKE : {};

    if (window.EDMDataStorage['globalNavSponsorshipData']) {
        GLOBAL_NAV_SPONSORSHIP_CONST = window.EDMDataStorage['globalNavSponsorshipData'].MATRIX;
        return true;
    } else {
        return false;
    }
}

function fireImpressionTracking(vehicle, isMobile, data){
    if(isMobile) {
        var sponsorshipWrapperMobile = data.sponsorshipWrapper ? data.sponsorshipWrapper : '.sponsorship-item-small';

        checkImpressionTracker($(sponsorshipWrapperMobile));
        initMobileImpressionTracker(vehicle, sponsorshipWrapperMobile);
    } else {
        if (!$.isEmptyObject(data)){
            var sponsorshipWrapperWired = $(data.tabId + ' .sponsorship-item');

            checkImpressionTracker(sponsorshipWrapperWired);
            initWiredTabImpressionTracker(vehicle, data.tabId);
        }
    }
}

function checkImpressionTracker(sponsorshipWrapper) {
    var impressionTrackers = sponsorshipWrapper.children('img');

    if(impressionTrackers.length !== 0) {
        impressionTrackers.detach();
    }
}

function refreshTimestamp() {
    return Date.now()+'';
}

function initWiredTabImpressionTracker(vehicle, tab_id) {
    if(docCookies.getItem('disableallthirdparty') || docCookies.getItem('disableallads')) { return; }
    var timestamp = refreshTimestamp();
    $('<img>', {src: vehicle.img.wired.impressionTracker1.replace('[timestamp]', timestamp), width: 1, height: 1})
        .appendTo(tab_id + ' .sponsorship-item');
    $('<img>', {src: vehicle.img.wired.impressionTracker2, width: 1, height: 1})
        .appendTo(tab_id + ' .sponsorship-item');
}

function initMobileImpressionTracker(vehicle, sponsorshipWrapper) {
    if(docCookies.getItem('disableallthirdparty') || docCookies.getItem('disableallads')) { return; }
    var timestamp = refreshTimestamp();
    $('<img>', {src: vehicle.img.mobile.impressionTracker1.replace('[timestamp]', timestamp), width: 1, height: 1})
        .appendTo(sponsorshipWrapper);
    $('<img>', {src: vehicle.img.mobile.impressionTracker2, width: 1, height: 1})
        .appendTo(sponsorshipWrapper);
}

function appendImageToHeader(vehicle) {
    var imgWiredContainer = $('<a>',
            {href: vehicle.img.wired.clickTracker.replace('[timestamp]', timestamp)}).appendTo('.sponsorship-item'),
        imgMobileContainer = $('<a>',
            {href: vehicle.img.mobile.clickTracker.replace('[timestamp]', timestamp)}).appendTo('.sponsorship-item-small');

    $('<img>', {src: IMG_HOST + vehicle.img.wired.imgURL, class: 'ad-img'}).appendTo(imgWiredContainer);
    $('<img>', {src: IMG_HOST + vehicle.img.mobile.imgURL, width: 277, height: 55})
        .appendTo(imgMobileContainer);
}

function getRandomVehicle(responseType) {
    var segmentedType = GLOBAL_NAV_SPONSORSHIP_CONST[responseType] ? responseType : 'default';
    var segmentedVehicles = GLOBAL_NAV_SPONSORSHIP_CONST[segmentedType];

    return segmentedVehicles[Math.floor(Math.random()*segmentedVehicles.length)];
}

function setSponsorshipExampleModelHP(vehicle) {
    var container, elem;
    var link;
    if (responsiveToolkit.is('<=sm')) {
        container = $('.xsmall.sponsorship-model-example-hp');
        link = vehicle['link']['mobile'];
    }
    else {
        container = $('.sponsorship-model-example-hp:not(.xsmall)');
        link = vehicle['link']['wired'];
    }
    elem = container.find('a');

    if(!docCookies.getItem('disableallthirdparty') && !docCookies.getItem('disableallads')) {
        $('<img>', {src: link.impressionTracker1.replace('[timestamp]', timestamp), width: 1, height: 1})
            .appendTo(container);
        $('<img>', {src: link.impressionTracker2, width: 1, height: 1})
            .appendTo(container);
    }

    elem.attr('href', link.modelURL.replace('[timestamp]', timestamp)).text(vehicle.name);
    elem.attr(trackingConst.DATA_TRACKING_VALUE_ATTRIBUTE, vehicle.nicename);
    container.show();
}

function setSponsorshipExampleMakeHP() {
    if (responsiveToolkit.is('<=sm')) {
        return;
    }
    var container = $('.sponsorship-make-example-hp'),
        elem = container.find('a');

    if(!docCookies.getItem('disableallthirdparty') && !docCookies.getItem('disableallads')) {
        $('<img>', {src: QUICK_LINKS_SPONSORSHIP_CONST.impressionTracker1.replace('[timestamp]', timestamp), width: 1, height: 1})
            .appendTo(container);
        $('<img>', {src: QUICK_LINKS_SPONSORSHIP_CONST.impressionTracker2, width: 1, height: 1})
            .appendTo(container);
    }

    elem.attr('href', QUICK_LINKS_SPONSORSHIP_CONST.modelURL.replace('[timestamp]', timestamp)).text(QUICK_LINKS_SPONSORSHIP_CONST.name);
    elem.attr(trackingConst.DATA_TRACKING_VALUE_ATTRIBUTE, QUICK_LINKS_SPONSORSHIP_CONST.nicename);
    container.show();
}

module.exports = {
    fireImpressionTracking: fireImpressionTracking,
    initWiredTabImpressionTracker: initWiredTabImpressionTracker,
    initMobileImpressionTracker: initMobileImpressionTracker,
    appendImageToHeader: appendImageToHeader,
    getRandomVehicle: getRandomVehicle,
    setSponsorshipExampleModelHP: setSponsorshipExampleModelHP,
    setSponsorshipExampleMakeHP: setSponsorshipExampleMakeHP,
    hasSponsorshipData: hasSponsorshipData
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 67 */
/***/ function(module, exports) {

var NavDrawerConstants = function() {

    this.SLIDE_NUMBER = {
        MAIN: 0,
        CAR_TYPES_MAIN: 3,
        CAR_FS_MAIN: 4,
        RESEARCH_MAIN: 5,
        RESEARCH_TOOLS: 6,
        RESEARCH_ARTICLE: 7,
        RESEARCH_MANU_DETAILS: 8,
        CAR_FS_TYPE: 9,
        CAR_FS_MAKE: 10,
        MODEL: 11,
        YEAR: 12,
        RESEARCH_TIPS: 13
    };

    this.DRAWER_HEADERS = {
        MAKE: 'Select Make',
        MODEL: 'Select Model',
        YEAR: 'Select Year',
        CAR_TYPES_MAIN: 'Select Car Type',
        CAR_FS_MAIN: 'Cars For Sale',
        CAR_FS_TYPE: 'Select Car Type',
        CAR_FS_MAKE: 'Select Make',
        RESEARCH_MAIN: 'Research',
        RESEARCH_TOOLS: 'Pricing & Calc.',
        RESEARCH_TIPS: 'Tips & Advice',
        RESEARCH_ARTICLE: 'Articles',
        RESEARCH_MANU_DETAILS: 'Car Makes'
    };
};

module.exports = new NavDrawerConstants();

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var NDConst = __webpack_require__(67);
var NavDataAccess = __webpack_require__(8);
var NavFactory = __webpack_require__(3);
var NavPopulator = __webpack_require__(25);
var NDSlideStorage = __webpack_require__(23);
var carouselId = '#nav-drawer-carousel';
var arrayFind = __webpack_require__(100);

var SponsorshipConst = __webpack_require__(2);
var eventToolbox = __webpack_require__(1);

var slideNameArray = ['MAIN', 'CAR_TYPES_MAIN', 'CAR_FS_MAIN', 'RESEARCH_MAIN', 'RESEARCH_TOOLS', 'RESEARCH_TIPS',
    'RESEARCH_ARTICLE', 'RESEARCH_MANU_DETAILS', 'CAR_FS_TYPE', 'CAR_FS_MAKE', 'MODEL', 'YEAR'];

var NavDrawerController = function () {
    var drawerHeaderSelect = $('#nav-drawer .modal-header .select');
    var drawerHeaderText = $('#nav-drawer .modal-header .header');
    var drawerHeaderSearchForm = $('#nav-drawer .modal-header .search-form-wrap');
    var _self = this;

    var headerChange = function (isMain, text) {
        if (isMain) {
            drawerHeaderSelect.hide();
            drawerHeaderSearchForm.show();
        } else {
            drawerHeaderSelect.show();
            drawerHeaderSearchForm.hide();
        }
        if (text) {
            drawerHeaderText.text(text);
        }
    };

    this.headerState = function (slideNum) {
        var currentSlideNumName = arrayFind(slideNameArray, function (slideNumName) {
            return NDConst.SLIDE_NUMBER[slideNumName] === slideNum;
        });
        if(slideNum === NDConst.SLIDE_NUMBER.MAIN) {
            headerChange(true);
        } else if(currentSlideNumName) {
            headerChange(false, NDConst.DRAWER_HEADERS[currentSlideNumName]);
        } else {
            headerChange(false, NDConst.DRAWER_HEADERS.MAKE);
        }
    };

    this.listGroupItemSelect = function (dom) {
        var currentSlide = $(dom).data('currentSlide');
        var niceName = $(dom).data('niceName');
        var name = $(dom).data('name');
        var type = $(dom).data('type');
        var slideTo = $(dom).data('slideTo');

        if (type) {
            NavFactory.setMake({
                niceName: niceName,
                name: name
            });
            NavDataAccess.getModelYear({
                makeNiceName: niceName,
                type: type
            }, function() {
                NavPopulator.populateModels( _self, '', type, true );
            });

            this.fireGlobalNavImpressionTracking(type);
        } else {
            this.fireGlobalNavImpressionTracking($(dom).data('show'));
        }

        NDSlideStorage.addQueue(currentSlide);
        _self.headerState(slideTo);
        $(carouselId).carousel(slideTo);
    };

    this.modelAnchorSelect = function (dom, e) {
        e.preventDefault();
        var type = $( dom ).data('type');
        NavFactory.setModel({
            niceName: $( dom ).data('modelNiceId'),
            name: $( dom ).data('modelName')
        });
        NavFactory.setSubmodel({
            niceName: $( dom ).data('submodelNiceName'),
            name: $( dom ).data('submodelName')
        });
        NDSlideStorage.addQueue(NDConst.SLIDE_NUMBER.MODEL);
        NavPopulator.populateYears( _self, '', type, true );
        _self.headerState(NDConst.SLIDE_NUMBER.YEAR);
        $(carouselId).carousel(NDConst.SLIDE_NUMBER.YEAR);

        this.fireGlobalNavImpressionTracking(type);
    };

    this.fireGlobalNavImpressionTracking = function (navItem) {
        if(SponsorshipConst.NAV_ITEMS.indexOf(navItem) > -1 || SponsorshipConst.NAV_ITEMS_TYPES.indexOf(navItem) > -1) {
            eventToolbox.fireCustomEvent(SponsorshipConst.EVENT_TYPE_FIRE_IMPRESSION_TRACKING, {});
        }
    };

};

module.exports = NavDrawerController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var NavDrawerDomElements = function() {
    this.getMakeModelYearDom = function() {
        return {
            modelsListDiv: $('#nav-drawer-carousel .model-slide .list-group'),
            yearsListDiv: $('#nav-drawer-carousel .year-slide .list-group')
        };
    };
};

module.exports = new NavDrawerDomElements();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var NavDrawerController = __webpack_require__(68);
var NavDrawerSlideStorage = __webpack_require__(23);
var carouselId = '#nav-drawer-carousel';
var navDrawerCtrl = new NavDrawerController();

var SponsorshipConst = __webpack_require__(2);
var eventToolbox = __webpack_require__(1);

$('#nav-drawer').on('hidden.bs.modal', function() {
    $(carouselId).carousel(0);
    navDrawerCtrl.headerState(0);
    NavDrawerSlideStorage.clearQueue();
});

$('#nav-drawer .slide-back').on('click', function(e) {
    e.preventDefault();
    var popQueue = NavDrawerSlideStorage.popQueue() || 0;

    if(SponsorshipConst.SLIDE_TRACKING_NUMBERS.indexOf(popQueue) > -1) {
        eventToolbox.fireCustomEvent(SponsorshipConst.EVENT_TYPE_FIRE_IMPRESSION_TRACKING, {});
    }
    navDrawerCtrl.headerState(popQueue);
    $(carouselId).carousel(popQueue);
});

$('#nav-drawer-carousel .carousel-item .list-group > a').on('click', function(e) {
    var href = $(this).attr('href');
    if(!href) {
        e.preventDefault();
        navDrawerCtrl.listGroupItemSelect(this);
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var NavDrawerTemplate = function() {
    var createAnchorRow = function(text) {
        var row = $('<div></div>').addClass('row');
        var spanText = $('<span></span>').addClass('col-xs-11')
            .text(text);
        var arrow = $('<span></span>').addClass('col-xs-1')
            .addClass('p-a-0');
        var icon = $('<i></i>').addClass('icon-arrow-right5');
        arrow.append(icon);
        row.append(spanText);
        row.append(arrow);
        return row;
    };

    this.modelAnchor = function(submodel) {
        var anchor = $('<a></a>')
            .attr('data-model-nice-name', submodel.modelNiceName)
            .attr('data-model-nice-id', submodel.modelNiceId)
            .attr('data-model-name', submodel.modelName)
            .attr('data-submodel-nice-name', submodel.niceId)
            .attr('data-submodel-name', submodel.name);
        var row = createAnchorRow(submodel.name);
        anchor.append(row);
        return anchor;
    };

    this.linkOutAnchor = function(url, text) {
        var anchor = $('<a></a>')
            .attr('href', url);
        var row = createAnchorRow(text);
        anchor.append(row);
        return anchor;
    };

};

module.exports = new NavDrawerTemplate();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var NavFactory = __webpack_require__(3);
var NavDataAccess = __webpack_require__(8);
var NavPopulator = __webpack_require__(25);
var NavDomElements = __webpack_require__(24);

var SponsorshipConst = __webpack_require__(2);
var eventToolbox = __webpack_require__(1);
var darklaunch = __webpack_require__(14);

var NavController = function() {
    var _self = this;

    this.makeAnchorSelect = function(dom, e) {
        e.preventDefault();
        var parentId = $( dom ).data('parentId');
        var makeNiceName = $( dom ).data('makeNiceName');
        var type = $( dom ).data('type');
        var makeName = $( dom ).data('makeName');
        var mmyDivs = NavDomElements.getMakeModelYearDom(parentId);
        NavFactory.setMake({
            niceName: makeNiceName,
            name: makeName
        });
        var headerMake = mmyDivs.modelsDiv.find('.nav-header .selected.make');
        headerMake.html(makeName);
        mmyDivs.makesDiv.addClass('hidden');
        mmyDivs.modelsDiv.find('.list').empty().hide();
        mmyDivs.modelsDiv.removeClass('hidden');
        NavDataAccess.getModelYear({
            makeNiceName: makeNiceName,
            type: type
        }, function() {
            NavPopulator.populateModels( _self, parentId, type );
        });
    };
    
    this.modelAnchorSelect = function(dom, e) {
        e.preventDefault();
        var parentId = $( dom ).data('parentId');
        var type = $( dom ).data('type');
        var mmyDivs = NavDomElements.getMakeModelYearDom(parentId);
        NavFactory.setModel({
            niceName: $( dom ).data('modelNiceId'),
            name: $( dom ).data('modelName')
        });
        NavFactory.setSubmodel({
            niceName: $( dom ).data('submodelNiceName'),
            name: $( dom ).data('submodelName')
        });
        var headerMake = mmyDivs.yearsDiv.find('.nav-header .selected.make');
        var headerModel = mmyDivs.yearsDiv.find('.nav-header .selected.model');
        headerMake.html(NavFactory.getSelected().make.name);
        headerModel.html(NavFactory.getSelected().submodel.name);
        mmyDivs.makesDiv.addClass('hidden');
        mmyDivs.modelsDiv.addClass('hidden');
        mmyDivs.yearsDiv.find('.list').empty();
        mmyDivs.yearsDiv.removeClass('hidden');
        NavPopulator.populateYears( _self, parentId, type );

        this.fireGlobalNavImpressionTracking(parentId);
    };

    this.makeHeaderSelect = function(dom, e) {
        e.preventDefault();
        var parentId = $( dom ).data('parentId');
        NavFactory.resetSelected();
        var mmyDivs = NavDomElements.getMakeModelYearDom(parentId);
        mmyDivs.makesDiv.removeClass('hidden');
        mmyDivs.modelsDiv.find('.list').empty().hide();
        mmyDivs.modelsDiv.addClass('hidden');
        mmyDivs.yearsDiv.find('.list').empty().hide();
        mmyDivs.yearsDiv.addClass('hidden');

    };

    this.modelHeaderSelect = function(dom, e) {
        e.preventDefault();
        var parentId = $( dom ).data('parentId');
        var mmyDivs = NavDomElements.getMakeModelYearDom(parentId);
        NavFactory.setModel({});
        NavFactory.setYear({});
        mmyDivs.modelsDiv.removeClass('hidden');
        mmyDivs.yearsDiv.find('.list').empty().hide();
        mmyDivs.yearsDiv.addClass('hidden');
    };

    this.fireGlobalNavImpressionTracking = function (tabId) {
        var tab_id = tabId.slice(1);

        if(SponsorshipConst.NAV_ITEMS.indexOf(tab_id) > -1) {
            if(darklaunch.storyEnabled('TMT-207')) {
                eventToolbox.fireCustomEvent(SponsorshipConst.EVENT_TYPE_FIRE_IMPRESSION_TRACKING, {tabId: '#' + tab_id});
            } else {
                eventToolbox.fireCustomEvent(SponsorshipConst.EVENT_TYPE_FIRE_IMPRESSION_TRACKING, {tabId: tab_id});
            }
        }
    };
};


module.exports = new NavController();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

var NavFactory = __webpack_require__(3);

function linkOutUrlFactory(publicationState, selected, submodel, year) {
    var linkFormatsbyPublicationState = {
        newFuture: '/' +
        [selected.make.niceName, selected.model.niceName, year, selected.submodel.niceName].join('/') +
        '/',
        used: '/' + [selected.make.niceName, selected.model.niceName, year, selected.submodel.niceName].join('/') +
        '/?ps=used',
        new: '/inventory/srp.html?radius=50&' +
        ['make=' + selected.make.name, 'model=' + submodel.modelName, 'sub=' + submodel.name].join('&')
    };
    return linkFormatsbyPublicationState[publicationState] || '#';
}

var NavLinkGenerator = function() {
    this.getLinkOutUrl = function (data) {
        var selected = NavFactory.getSelected();
        var submodel = data.submodel || {};
        var year = data.year || '';
        var publicationState = data.publicationState || '';

        return linkOutUrlFactory(publicationState, selected, submodel, year);
    };
};

module.exports = new NavLinkGenerator();

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var NavTemplates = function() {
    var createAnchor = function() {
        return $('<a></a>')
            .addClass('anchor')
            .addClass('text-white');
    };

    this.modelAnchor = function(submodel) {
        return createAnchor()
            .attr('data-model-nice-name', submodel.modelNiceName)
            .attr('data-model-nice-id', submodel.modelNiceId)
            .attr('data-model-name', submodel.modelName)
            .attr('data-submodel-nice-name', submodel.niceId)
            .attr('data-submodel-name', submodel.name)
            .text(submodel.name);
    };
    
    this.linkOutAnchor = function(url, text) {
        return createAnchor()
            .attr('href', url)
            .text(text);
    };
};

module.exports = new NavTemplates();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {
var NavController = __webpack_require__(72);
var NavFactory = __webpack_require__(3);
var ProfileHelper = __webpack_require__(9);
var darklaunch = __webpack_require__(14);
var firstDropdown = true;

$('#nav .nav-link:not(.linkout)').on('click', function(e) {

    e.preventDefault();
    var isActive = $(this).hasClass('active');
    var show = $(this).data('show');
    $('#nav .nav-link').removeClass('active');
    if(!isActive && show) {
        $('.nav-container .content').addClass('hidden');
        $(show).removeClass('hidden');
        $(this).addClass('active');
        $('.nav-container.collapse').collapse('show');
        if(darklaunch.storyEnabled('TMT-207')) {
            if(firstDropdown) {
                firstDropdown = false;
            } else {
                NavController.fireGlobalNavImpressionTracking($(this).data('show'));
            }
        } else {
            NavController.fireGlobalNavImpressionTracking($(this).data('show'));
        }
    } else {
        $('.nav-container.collapse').collapse('hide');
    }
    NavFactory.resetSelected();
    $('#nav_container .makes').removeClass('hidden');
    $('#nav_container .models').addClass('hidden');
    $('#nav_container .years').addClass('hidden');
});

// make anchor clicks
$('#nav_container .makes .list a').on('click', function (e) {
    NavController.makeAnchorSelect(this, e);

    NavController.fireGlobalNavImpressionTracking($(this).data('parentId'));

});

// nav container header...
$('#nav_container .nav-header .selected.make').on('click', function (e) {
    NavController.makeHeaderSelect(this, e);

    NavController.fireGlobalNavImpressionTracking($(this).data('parentId'));
});

$('#nav_container .nav-header .selected.model').on('click', function (e) {
    NavController.modelHeaderSelect(this, e);

    NavController.fireGlobalNavImpressionTracking($(this).data('parentId'));
});

// cars for sale...

$('#nav_cars_for_sale .togglable .show').on('click', function(e) {
    e.preventDefault();
    var togglableId = $( this ).data('togglableId');
    $(this).addClass('hidden');
    $(this).siblings('.hidden').removeClass('hidden');
    if($(this).hasClass('less')) {
        // toggle show less
        $(togglableId).find('.col-xs-3:odd').hide();
        $(togglableId).removeClass('col-xs-10').addClass('col-xs-5');
        $(togglableId).find('.col-xs-3').removeClass('col-xs-3').addClass('col-xs-6');
        $('#nav_cars_for_sale .togglable-column:not('+togglableId+')').delay(150).show(0);
    } else {
        // toggle show all
        $('#nav_cars_for_sale .togglable-column:not('+togglableId+')').delay(100).hide();
        $(togglableId).removeClass('col-xs-5').addClass('col-xs-10');
        $(togglableId).find('.col-xs-6').removeClass('col-xs-6').addClass('col-xs-3').delay(100).fadeIn();
    }
});

// research carousel
$('#nav_research .nav-research-carousel-arrow').on('click', function(e) {
    e.preventDefault();
    var navResearchCarousel = $('#nav-research-carousel');
    $(this).hide();
    if($(this).hasClass('left')) {
        $(this).siblings('.nav-research-carousel-arrow.right').show();
        navResearchCarousel.carousel(0);
    } else {
        $(this).siblings('.nav-research-carousel-arrow.left').show();
        navResearchCarousel.carousel(1);
    }
});

ProfileHelper.on('signIn', function(user) {
    var nav = $('#nav');
    nav.find('a[data-target="#sign-in-drawer"]').css('display', 'none');
    nav.find('#user-menu-email').text(user.email);
    nav.find('#user-menu').css('display', 'inline-block');
});

ProfileHelper.on('signOut', function() {
    var nav = $('#nav');
    nav.find('#user-menu').css('display', 'none');
    nav.find('a[data-target="#sign-in-drawer"]').css('display', 'inline-block');
});


$('#sign-in-drawer, #sign-up-drawer, #forgot-password-drawer').
find('.close-drawer, a[data-target="#forgot-password-drawer"], a[data-target="#sign-in-drawer"], a[data-target="#sign-up-drawer"]')
    .on('click', function() {
        var form = $('#sign-in-drawer, #sign-up-drawer, #forgot-password-drawer');
        var email = $('#sign-in-form input[name=email]').val();
        form.find('form').find('input').val('');
        form.find('.has-success, .has-danger').removeClass('has-danger').removeClass('has-success');
        form.find('.form-control-danger, .form-control-success').removeClass('form-control-danger').removeClass('form-control-success');
        form.find('.text-danger').text('');
        $('#forgot-password-form input[name=email]').val(email);
    });

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var signUpDrawer = __webpack_require__(81);
var signInDrawer = __webpack_require__(80);
var forgotPasswordDrawer = __webpack_require__(78);

$(document).on('firebase.initialized', function() {
    var firebase = window.firebase;

    signUpDrawer.init(firebase);
    signInDrawer.init(firebase);
    forgotPasswordDrawer.init(firebase);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {function errorParser(error, errorBlock) {
    var errorsMap = {
        'auth/wrong-password'        : 'Login failed. Please make sure you have entered the correct email and password.',
        'auth/weak-password'         : 'Your password must be more than 6 characters long.',
        'auth/email-already-in-use'  : 'An account has already been created with this email. Please sign in or click <a href="#" ' +
        'data-dismiss="modal" data-toggle="modal" data-target="#forgot-password-drawer"> ' +
        'Forgot your password?</a>',
        'auth/operation-not-allowed' : 'Internal login error. Please try again later.',
        'auth/user-not-found'        : 'There is no account associated with this email. Please click ' +
        '<a href="#" data-dismiss="modal" data-toggle="modal" data-target="#sign-up-drawer">Sign up</a>',
        'auth/invalid-email'         : 'email address is not valid',
        'auth/popup-closed-by-user'  : 'The popup has been closed by the user before finalizing the operation'
    };

    var errorText = errorsMap[error.code] ? errorsMap[error.code] : error.message;

    if(errorBlock) {
        $(errorBlock).empty();
        $(errorBlock).append('<li>' + errorText + '</li>');
    }

    return errorText;
}

module.exports = errorParser;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var profileValidator = __webpack_require__(5);
var utils = __webpack_require__(12);

function init(firebase) {
    var forgotPasswordDrawerSelector = '#forgot-password-drawer';
    var forgotPasswordDrawer = $(forgotPasswordDrawerSelector);
    var forgotPasswordForm = forgotPasswordDrawer.find('#forgot-password-form');
    var formErrorSelector = '#forgot-password-form-error';
    var forgotPasswordDrawerDone = $('#forgot-password-drawer-done');

    forgotPasswordForm.on('submit', function(e) {
        e.preventDefault();
        var form = e.target;
        if (profileValidator.isFormValid(forgotPasswordForm)) {
            return firebase.auth().sendPasswordResetEmail(form.email.value).then(function() {
                forgotPasswordDrawerDone.find('#email-reset-info').text(form.email.value);
                utils.switchToDrawer(forgotPasswordDrawerSelector, '#forgot-password-drawer-done');
            }).catch(function(error) {
                profileValidator.parseFirebaseError(error, formErrorSelector);
            });
        }
    });

    forgotPasswordForm.on('blur', 'input', function(e) {
        var input = e.target;
        profileValidator.validateField(forgotPasswordForm, input, formErrorSelector);
    });
}

module.exports = {
    init: init
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var idmApiUrl = 'https://rn9tusj2i9.execute-api.us-east-1.amazonaws.com/test';

module.exports = {
    updateProfile: function(formData, accessToken) {
        var data = {
            identifiers: {
                email: [formData.email.value]
            },
            person: {
                firstName: formData.firstName.value
            },
            pii: {
                lastName: formData.lastName.value
            },
            sync: {
                clientTs: new Date().toISOString()
            },
            recordType: 'Aggregate'
        };

        return $.ajax({
            type: 'PUT',
            cache: false,
            url: idmApiUrl,
            contentType: 'application/json',
            data: JSON.stringify(data),
            dataType: 'json',
            beforeSend: function(req) {
                req.setRequestHeader('Authorization', accessToken);
            }
        });
    },

    getProfile: function(accessToken) {
        return $.ajax({
            type: 'GET',
            url: idmApiUrl,
            contentType: 'application/json',
            beforeSend: function(req) {
                req.setRequestHeader('Authorization', accessToken);
            }
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(22);

var profileValidator = __webpack_require__(5);
var helper = __webpack_require__(9);

function init(firebase) {
    var signInDrawerSelector = '#sign-in-drawer';
    var signInDrawer = $(signInDrawerSelector);
    var signInForm = signInDrawer.find('#sign-in-form');
    var formErrorSelector = '#sign-in-form-error';
    var forgotPasswordEmailSelector = '#forgot-password-email';

    signInForm.on('submit', function(e) {
        e.preventDefault();

        var form = e.target;
        if (profileValidator.isFormValid(signInForm)) {
            return firebase.auth().signInWithEmailAndPassword(form.email.value, form.password.value).then(function(user) {
                helper.onSignIn(user);
            }).catch(function(error) {
                profileValidator.parseFirebaseError(error, formErrorSelector);
            });
        }
    });

    signInForm.on('blur', 'input', function(e) {
        var input = e.target;
        if (input.name === 'email') {
            $(forgotPasswordEmailSelector).val(input.value);
        }
        profileValidator.validateField(signInForm, input, formErrorSelector);
    });

    helper.on('signIn', function() {
        signInDrawer.modal('hide');
    });
}

module.exports = {
    init: init
};


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(22);
var IDM = __webpack_require__(79);
var helper = __webpack_require__(9);
var utils = __webpack_require__(12);
var profileValidator = __webpack_require__(5);

function init(firebase) {
    var signUpDrawerSelector = '#sign-up-drawer';
    var signUpForm = $('#sign-up-form');
    var formErrorSelector = '#sign-up-form-error';

    signUpForm.on('submit', function(e) {
        e.preventDefault();

        var form = e.target;
        if (profileValidator.isFormValid(signUpForm)) {
            return firebase.auth().createUserWithEmailAndPassword(form.email.value, form.password.value).then(function(user) {
                helper.sendEmailVerification(user);
                return IDM.updateProfile(form, user._lat)
                    .always(function(data) {
                        if(data.statusText === 'Created') {
                            utils.switchToDrawer(signUpDrawerSelector, '#sign-up-welcome-drawer');
                        }
                    });
            }).catch(function(error) {
                return profileValidator.parseFirebaseError(error, formErrorSelector);
            });
        }
    });

    signUpForm.on('blur', 'input', function(e) {
        var input = e.target;
        profileValidator.validateField(signUpForm, input, formErrorSelector);
    });
}

module.exports = {
    init: init
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var trackingEvent = __webpack_require__(6);
var constant = __webpack_require__(4);

var toolMap = __webpack_require__(87),
    navMap = __webpack_require__(86);

var map = {

    provide_zip_code: trackingEvent.actionCompleted(
        constant.ACTION_PROVIDE_ZIP_CODE, constant.ACTION_PROVIDE_ZIP_CODE),

    view_search_result: trackingEvent.actionCompleted(
        constant.VIEW_SEARCH_RESULT, constant.VIEW_SEARCH_RESULT),

    view_content: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, constant.ACTION_VIEW_CONTENT),

    view_content_search_result: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, constant.VIEW_SEARCH_RESULT),

    view_content_summary: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, constant.VIEW_SUMMARY),

    view_pricing_details: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_PRICING_DETAILS, constant.VIEW_PRICING_DETAILS),

    view_edmunds_review: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_REVIEW, constant.VIEW_EDMUNDS_REVIEW),

    mmy_select_submit: trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.SUBMIT_MMY),

    mmy_select_submit_make: trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.SUBMIT_MAKE),

    mmy_select_submit_model: trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.SUBMIT_MODEL),

    seo_footer_mmy_submit_make: trackingEvent.actionEnd(
        constant.ACTION_MMY_SELECT, constant.SUBMIT_MAKE),

    seo_footer_mmy_submit_model: trackingEvent.actionEnd(
        constant.ACTION_MMY_SELECT, constant.SUBMIT_MODEL),

    seo_footer_mmy_submit: trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.SUBMIT_MMY)
};

// For unit testing purposes
module.exports = $.extend({}, toolMap, navMap, map);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 83 */,
/* 84 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 85 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

var trackingEvent = __webpack_require__(6);
var constant = __webpack_require__(4);

module.exports = {
    homepage_click: trackingEvent.actionCompleted(
        constant.ACTION_RESET_NAVIGATION, constant.ACTION_RESET_NAVIGATION),

    nav_mmy_select_new_car: trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.NEW_CAR_SELECT),

    nav_mmy_select_used_car: trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.USED_CAR_SELECT),

    nav_mmy_select_new_car_start: trackingEvent.actionStart(
        constant.ACTION_MMY_SELECT, constant.NEW_CAR_SELECT),

    nav_mmy_select_used_car_start: trackingEvent.actionStart(
        constant.ACTION_MMY_SELECT, constant.USED_CAR_SELECT),

    nav_mmy_select_make: trackingEvent.actionProgress(
        constant.ACTION_MMY_SELECT, constant.MAKE_SELECT),

    nav_mmy_model_select: trackingEvent.actionProgress(
        constant.ACTION_MMY_SELECT, constant.MODEL_SELECT),

    nav_mmy_year_select: trackingEvent.actionEnd(
        constant.ACTION_MMY_SELECT, constant.YEAR_SELECT),

    nav_mmy_select_submit_make: trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.SUBMIT_MAKE),

    nav_mmy_select_car_types : trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.CAR_TYPES),

    nav_mmy_select_cars_for_sale : trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.CARS_FOR_SALE),

    nav_mmy_select_research : trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.RESEARCH),

    nav_type_select: trackingEvent.actionCompleted(
        constant.ACTION_TYPE_SELECT, constant.ACTION_TYPE_SELECT),

    nav_inventory_select_new_used: trackingEvent.actionCompleted(
        constant.ACTION_INVENTORY_SELECT, constant.NEW_USED_CAR_SELECT),

    nav_inventory_select_type: trackingEvent.actionCompleted(
        constant.ACTION_INVENTORY_SELECT, constant.ACTION_TYPE_SELECT),

    nav_inventory_select_make: trackingEvent.actionCompleted(
        constant.ACTION_INVENTORY_SELECT, constant.MAKE_SELECT)
};


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

var trackingEvent = __webpack_require__(6);
var constant = __webpack_require__(4);

module.exports = {
    tool_select_car_reviews_and_road_tests: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_reviews_and_road_tests'),

    tool_select_car_reviews: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_reviews'),

    tool_select_tips_advice: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'tips_advice'),

    tool_select_long_term_road_tests: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'long-term_road_tests'),

    tool_select_car_videos: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_videos'),

    tool_select_dealer_ratings_and_reviews: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'dealer_ratings_and_reviews'),

    tool_select_maintenance: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'maintenance'),

    tool_select_new_cars: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'new_cars'),

    tool_select_calculators: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'calculators'),

    tool_select_car_loan_calculators: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_loan_calculators'),

    tool_select_car_finder: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_finder'),

    tool_select_compare_cars: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'compare_cars'),

    tool_select_find_a_dealer: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'find_a_dealer'),

    tool_select_get_monthly_payment: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'get_monthly_payment'),

    tool_select_incentives_rebates: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'incentives_rebates'),

    tool_select_true_cost_to_own: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'true_cost_to_own'),

    tool_select_used_cars: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'used_cars'),

    tool_select_appraise_your_car: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'appraise_your_car'),

    tool_select_certified_cars: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'certified_cars'),

    tool_select_selling_tips: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'selling_tips'),

    tool_select_configure_vehicle: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'configure_vehicle'),

    tool_select_car_news: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_news'),

    tool_select_automobile_forums: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'automobile_forums'),

    tool_select_car_dealerships: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_dealerships'),

    tool_select_car_financing: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_financing'),

    tool_select_car_leasing: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_leasing'),

    tool_select_buy_a_car: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'buy_a_car'),

    tool_select_sell_my_car: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'sell_my_car'),

    tool_select_car_valuation: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'car_valuation'),

    tool_select_research: trackingEvent.actionCompleted(
        constant.ACTION_TOOL_SELECT, 'research')
};


/***/ },
/* 88 */,
/* 89 */
/***/ function(module, exports, __webpack_require__) {

var carouselConstants = __webpack_require__(26);

function indexIsValid(index) {
    return typeof index === 'number' && index >= 0;
}

module.exports = {
    /**
     *
     * @param {jQuery} $carousel - owl carousel instance
     * @param {number} index - jump to
     * @param {number} speed - in ms for carousel to perform slide jump
     */
    changeSlide: function ($carousel, index, speed) {
        if (!indexIsValid(index)) { // Only positive numbers
            return;
        }
        $carousel.trigger('to.owl.carousel', [index, speed || carouselConstants.DEFAULT_TIMEOUT]);
    },
    /**
     *
     * @param {jQuery} $carousel - owl carousel instance
     * @param {number} index - index of slide to remove
     */
    removeSlide: function($carousel, index) {
        if (!indexIsValid(index)) { // Only positive numbers
            return;
        }
        $carousel.trigger('remove.owl.carousel', index);
    },
    /**
     *
     * @param {jQuery} $carousel - owl carousel instance
     * @param {number} slide - blob of what you want to append to carousel
     * @param {number} index - optional, if included, will append to this slot in carousel otherwise at the end
     */
    addSlide: function($carousel, slide, index) {
        if(typeof index == 'number') {
            $carousel.trigger('add.owl.carousel', [slide, index]);
        } else {
            $carousel.trigger('add.owl.carousel', [slide]);
        }
    },
    /**
     *
     * @param {jQuery} $carousel - owl carousel instance
     */
    refresh: function($carousel) {
        $carousel.trigger('refresh.owl.carousel');
    }


};


/***/ },
/* 90 */,
/* 91 */,
/* 92 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(117);
var eventToolbox = __webpack_require__(1);

// Constants, yup
var EVENT_SUBMODEL_CHANGED = 'submodel-changed';
// Dom Objects, check
var subSelector, ssButton, ssDropDown, ssSubmodelLabel;

//
// Helper Functions
//
function init() {
    // Do some some finding work.
    subSelector = document.querySelector('.submodel-selector');
    ssButton = subSelector.querySelector('.change-selector');
    ssDropDown = subSelector.querySelector('.submodel-dropdown');
    ssSubmodelLabel = subSelector.querySelector('.submodel-label');

    // Remove interactivty if only one submodel.
    if (ssDropDown) { // Remove Submodel Selector Dropdown button if only one submodel is available
        var allListElements = ssDropDown.querySelectorAll('ul li');
        if (allListElements.length < 2) {
            ssButton.style.display = 'none';
        }
    }

    // Add Event Handlers
    addEventHandlers();

}

// Update location with core page url appended with submodel
function pushURL(url) {
    if (url) {
        //window.history.pushState(null, null, url);
        window.location.href = url;
    }
}

// Update DOM elements after submodel change
function handleSubmodelChange(e, data) {
    if (e && data.submodelType) {
        if (ssSubmodelLabel) {
            ssSubmodelLabel.innerHTML = data.submodelDisplayName;
        }
    }
}

// Yes, I am reinventing the wheel. Don't hate
Element.prototype.findClosest = function(findElement) {
    var goodElement = this;
    while (goodElement.nodeName !== findElement.toUpperCase()) {
        if (goodElement.nodeName === 'HTML') {
            return false;
        }
        goodElement = goodElement.parentNode;
    }
    return goodElement;
};

//
// Event Handlers
//
function addEventHandlers() {
    // Listen for submodel-changed event and do something
    eventToolbox.subscribeCustomEvent(EVENT_SUBMODEL_CHANGED, handleSubmodelChange);

    // Handle opening and closing Submodel Selector Drop down
    if (ssButton) {
        ssButton.addEventListener('click', function() {
            ssButton.classList.toggle('open');
            if (ssDropDown) {
                ssDropDown.classList.toggle('open');
            }
        });
    }

    // Handle submodel selection
    if (ssDropDown) {
        ssDropDown.addEventListener('click', function(e) {
            e.preventDefault();
            //retrieve the submodel type of vehicle selected
            var data = e.target.findClosest('li').getAttribute('data-submodel-type').split(':');
            var url = e.target.findClosest('a').href;
            var submodelType = data[0];
            var submodelDisplayName = data[1];

            // Collapse dropdown and fire "submodel-changed" event
            if (submodelType && submodelDisplayName) {
                ssDropDown.classList.toggle('open');
                eventToolbox.fireCustomEvent(EVENT_SUBMODEL_CHANGED, {
                    submodelType: submodelType,
                    submodelDisplayName: submodelDisplayName
                });
                pushURL(url);
            }
        });
    }

}

init();


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var corePageTitles = window.EDMDataStorage.corePageTitles;

$(window).on('activate.bs.scrollspy', function (ev, data) {
    if (data && data.relatedTarget) {
        var creativeId = data.relatedTarget.replace('#', '');
        var headingText = corePageTitles[creativeId] ? corePageTitles[creativeId] : corePageTitles['DEFAULT'];
        // should only exist one h1 on a page.
        var $h1Text = $('h1');
        if($h1Text.text().trim() != headingText) {
            $h1Text.text(headingText);
        }
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var moduleAnchor = window.EDMDataStorage.moduleAnchor;

if(moduleAnchor.anchor) {
    var entryId = '#' + moduleAnchor.anchor;
    $(window).scrollTop($(entryId).offset().top);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(118);
var owlCarousel = __webpack_require__(10);
var drawerScrollEngagement = __webpack_require__(134);
var $drawerList = $('[data-drawer-list]');
var ads = __webpack_require__(88);
var drawerRemoveRenderContent = __webpack_require__(108);
var deferUrlEntries = {};
var eventToolbox = __webpack_require__(1);
var REFRESH_ZONES = __webpack_require__(83);

function prepareDeferUrlEntries(component, storage) {
    var deferEntryId = component.data('cmsentry');
    var deferEntryUrl = component.data('url') || component.data('cmsfeed');
    var deferCmsFeedReqParams = component.data('r');

    if(deferCmsFeedReqParams && deferEntryUrl) {
        deferEntryUrl += '?' + deferCmsFeedReqParams;
    }

    if(deferEntryUrl) {
        if(storage[deferEntryUrl]) {
            storage[deferEntryUrl].push(deferEntryId);
        } else {
            storage[deferEntryUrl] = [deferEntryId];
        }
    }
}

$('[data-cmsfeed]').each(function(index, component) {
    var $deferComponent = $(component);

    if(!$deferComponent.data('scrolldefer')) {
        prepareDeferUrlEntries($deferComponent, deferUrlEntries);
    }
});

for(var k in deferUrlEntries) {
    var deferUrl = k + '&entry-id=' + deferUrlEntries[k].join(',');
    $.get(deferUrl)
        .then(function (data) {
            for (var entryId in data.htmls) {
                renderDeferHtml(entryId, data.htmls[entryId]);
            }

            renderDrawerHtml(data.drawerHtml);
            if (data.dataStorage && Object.keys(data.dataStorage).length > 0) {
                $.extend(window.EDMDataStorage, data.dataStorage);
            }
            ads.adManager.renderAds();
            appendFiles(data.files);
            // TODO: need to handle data.scripts injection.

            // debug code to log when a deferred feed is called.
            if (window.location.search.indexOf('debug=true') > -1) {
                window.console.log('POST-LOAD URL CALLED: ', deferUrl);
            }
        });
}

//WEB17-116 -- Please clean up this file if we go with this solution.
function renderDeferredModule() {
    var deferredModuleUrlEntry = {};
    var visibleQueue = [];


    $('[data-scrolldefer]').each(function(index, component) {

        var $w = $(window);
        var $e = $(component);
        var th = 0;
        var wt = $w.scrollTop(),
            wb = wt + $w.height(),
            et = $e.offset().top,
            eb = et + $e.height();
        if((eb >= wt - th && et <= wb + th) && !$e.attr('data-loaded')){
            $e.attr('data-loaded',true);
            visibleQueue.push($e);
        }

    });

    $.each(visibleQueue,function(index, component) {
        var $deferComponent = $(component);
        prepareDeferUrlEntries($deferComponent, deferredModuleUrlEntry);
    });

    for(var k in deferredModuleUrlEntry) {
        var deferUrl = k + '&entry-id=' + deferredModuleUrlEntry[k].join(',');
        var deferEntry;
        $.get(deferUrl)
            .then(function(data) {
                for(var entryId in data.htmls) {
                    renderDeferHtml(entryId, data.htmls[entryId]);
                }

                renderDrawerHtml(data.drawerHtml);
                if(data.dataStorage && Object.keys(data.dataStorage).length > 0) {
                    $.extend(window.EDMDataStorage, data.dataStorage);
                }
                ads.adManager.renderAds();
                appendFiles(data.files);
                // TODO: need to handle data.scripts injection.

                deferEntry = $('.'+entryId).children();
                deferEntry.removeClass('loading');
                // debug code to log when a deferred feed is called.
                if(window.location.search.indexOf('debug=true') > -1) {
                    window.console.log('POST-LOAD URL CALLED: ', deferUrl);
                }

            });
    }
}


function renderDeferHtml(entryId, html) {
    if($(html).hasClass('edm-entry')) {
        html = $(html)[0].innerHTML;
    }
    var $deferComponent = $('[data-cmsentry="'+entryId+'"]');
    $deferComponent.html(html);
    initDeferredOwlCarousel($deferComponent);
    $deferComponent.find('.punit').asyncGptTag({});
}

function renderDrawerHtml(html) {
    if(html) {
        var drawerId = $(html).attr('id');
        $drawerList.append(html);
        drawerRemoveRenderContent.init();
        drawerScrollEngagement.init();
        initDeferredOwlCarousel($('#' + drawerId));
    }
}

function appendFiles(files) {
    files.css.forEach(function(cssUrl) {
        loadCss(cssUrl);
    });
    files.js.forEach(function(jsUrl) {
        loadJs(jsUrl);
    });
}

function initDeferredOwlCarousel($content) {
    var deferredOwlCarousel = $content.find('.owl-carousel');
    if(deferredOwlCarousel.length > 0) {
        owlCarousel.init(deferredOwlCarousel);
    }
}

function loadJs(url) {
    $.getScript(url, function() {});
}

function loadCss(url) {
    var link = $('<link/>', {
        rel: 'stylesheet',
        type: 'text/css',
        href: url
    });
    link.on('load', function () {
        eventToolbox.fireCustomEvent('defer-css-loaded', [ url ]);
    });
    link.appendTo('head');
}



$(window.document).on(REFRESH_ZONES.ENGAGEMENT, function(){
    renderDeferredModule();
});

module.exports = {
    renderDeferredModule: renderDeferredModule
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var pushStateUrls = window.EDMDataStorage.pushStateUrls;
var isPopstate = false;
var subNavLinkMapping = {};

function onPopstate(event) {
    isPopstate = true;
    if(event.state && event.state.scrollTop) {
        $(window).scrollTop(event.state.scrollTop);
    }
}

function urlQueryParams() {
    var retLocationSearch = [];
    var locSearchList = window.location.search.replace('?', '').split('&');
    locSearchList.forEach(function(val) {
        if(val.indexOf('tab-id') < 0) {
            retLocationSearch.push(val);
        }
    });
    return '?' + retLocationSearch.join('&');
}

function isValid(data) {
    return !pushStateUrls || !(data && data.relatedTarget);
}

/**
 * Should initialize this code after document loads.
 */
$(document).ready(function() {
    var url = window.location.pathname;
    if(window.location.search) {
        url += window.location.search;
    }
    url += window.location.hash;
    window.history.replaceState({ scrollTop: 0 }, null, url);
    history.scrollRestoration = 'manual';

    var subavLinks = $('.nav-link[data-external-link="true"]');
    subavLinks.each(function (i, subnavLink) {
        var $subnavLink = $(subnavLink);
        subNavLinkMapping[$subnavLink.attr('href')] = $subnavLink.data('original-link');
    });
});

function mapUrl(pushStateUrl) {
    if (subNavLinkMapping.hasOwnProperty(pushStateUrl)) {
        return subNavLinkMapping[pushStateUrl];
    } else {
        return pushStateUrl;
    }
}

$(window).on('activate.bs.scrollspy', function (ev, data) {
    if(isValid(data)) {
        return false;
    }
    var creativeId = data.relatedTarget.replace('#', '');
    var pushStateUrl = pushStateUrls[creativeId].href;
    pushStateUrl = mapUrl(pushStateUrl);
    var pushStateUrlHash = pushStateUrls[creativeId].hash;
    if(window.location.search) {
        pushStateUrl += urlQueryParams();
    }
    if(pushStateUrlHash) {
        pushStateUrl += pushStateUrlHash;
    }
    var currentState = {
        'creativeId': creativeId,
        'scrollTop': $(data.relatedTarget).offset().top
    };
    if(!isPopstate) {
        window.history.replaceState(currentState, null, pushStateUrl);
        window.history.pushState(currentState, null, pushStateUrl);
    }
    isPopstate = false;
});

window.addEventListener('popstate', onPopstate, false);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var trackingEvent = __webpack_require__(6);
var commonMap = __webpack_require__(82);
var constant = __webpack_require__(4);

var map = {
    core_page_website_clickout: trackingEvent.actionCompleted(
        constant.ACTION_WEBSITE_CLICKOUT, 'oem_site_clickout'),

    core_page_view_consumer_review: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_REVIEW, 'view_consumer_review'),

    core_page_go_to_review_form: trackingEvent.actionCompleted(
        constant.ACTION_WRITE_REVIEW, 'go_to_review_form'),

    core_page_view_content_pricing_details: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, constant.VIEW_PRICING_DETAILS),

    core_page_view_content_edmunds_review: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, constant.VIEW_EDMUNDS_REVIEW),

    core_page_view_content_specs: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, 'view_specs'),

    core_page_view_content_incentives: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, 'view_incentives_deals'),

    core_page_view_content_features: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, 'view_features'),

    core_page_view_content_safety_features: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, 'view_safety_features'),

    sign_in: trackingEvent.actionCompleted(
        'sign_in', constant.VIEW_PRICING_DETAILS)
};

module.exports = $.extend({}, commonMap, map);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(103);

var pannelCollapse = $('.panel-collapse');

pannelCollapse.on('show.bs.collapse hide.bs.collapse', function(e){
    $('.collapse-control', e.target.parentNode).toggle();
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 100 */,
/* 101 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(116);

/***/ },
/* 102 */,
/* 103 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 104 */,
/* 105 */,
/* 106 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(110);

/***/ },
/* 107 */,
/* 108 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(111);
function init(){
    $('.fade.modal-drawer').removeClass('render-content');
}

init();

module.exports = {
    init:init
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 109 */,
/* 110 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 111 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 112 */,
/* 113 */
/***/ function(module, exports) {

/**
 * Formats the given number into a price in US currency
 *
 * @param {Number} price the number to be formatted as a price string
 * @param {String} defaultValue value to be returned if the given number can not be formatted as a US price.
 *
 * @return {String} A string representing a US price
 */
function formatAsUsPrice(price, defaultValue) {
    var toReturn = '';
    if(typeof(price) == 'number' && !isNaN(price)) {
        if(price > 999999) {
            price = Math.ceil(price / 10000) / 100;
            toReturn = '$' + price + 'M';
        } else if(price > 999) {
            price = Math.floor(price * 100) / 100;
            price = /(\d+)(\d{3})/.exec(price);
            price.shift();
            toReturn = '$' + price.join(',');
        } else {
            toReturn = '$' + price;
        }
    } else {
        toReturn = defaultValue || '$NA';
    }

    return toReturn;
}

/**
 * numberWithCommas - Format number to number with commas
 * @param num
 * @param defaultValue
 * @returns {string}
 */
function numberWithCommas(num, defaultValue) {
    var toReturn = '';
    if(typeof(num) == 'number' && !isNaN(num)) {
        var parts = num.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        toReturn = parts.join('.');
    } else {
        toReturn = defaultValue || 'NA';
    }

    return toReturn;
}

function urlFriendlySpaces(str){
    return str.replace(/\s/g,'%20');
}

module.exports = {
    formatAsUsPrice: formatAsUsPrice,
    numberWithCommas: numberWithCommas,
    urlFriendlySpaces: urlFriendlySpaces
};

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(132);

var zcEventHandler = __webpack_require__(139);

var zipcodeChangerForm = $('form[name="zipcode-changer-form"]');
var zipcodeChanger = $('.gw-zipcode-changer .zipcode-toggle');

zipcodeChangerForm.each(function(index, zipcodeForm) {
    var $zipcodeForm = $(zipcodeForm),
        $geolocation = $zipcodeForm.siblings('.zipcode-changer-geolocation'),
        $input = $zipcodeForm.find('input[name="zip"]');
    $geolocation.on('click', function(e) {
        e.preventDefault();
        zcEventHandler.geolocation($zipcodeForm, $input);
    });

    $zipcodeForm.on('submit', zcEventHandler.submit);
});

zipcodeChanger.on('click', zcEventHandler.zipToggler);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 115 */,
/* 116 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 117 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 118 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 119 */,
/* 120 */,
/* 121 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {function loadEntry(entryId, url, cssClsName) {
    var $entry = $('#edm-entry-' + entryId);
    var loadingCssCls = cssClsName || 'loading';

    $entry.addClass(loadingCssCls);

    return $.get(url, {
        'entry-id': entryId
    }).done(function(data) {
        $entry.replaceWith(data.htmls[Object.keys(data.htmls)[0]]);
        runScripts(data.scripts);
        if(data.dataStorage && Object.keys(data.dataStorage).length > 0) {
            $.extend(window.EDMDataStorage, data.dataStorage);
        }
    }).always(function(){
        $entry.removeClass(loadingCssCls);
    });
}


function loadEntryWithPost(entryId, url, payload, cssClsName){
    var $entry = $('#edm-entry-' + entryId);
    var loadingCssCls = cssClsName || 'loading';
    var load = payload||{};

    $entry.addClass(loadingCssCls);

    return $.ajax({
        type: 'POST',
        url: url,
        contentType: 'application/json',
        data: JSON.stringify(load),
        dataType: 'json'
    }).done(function(data) {
        $entry.replaceWith(data.htmls[Object.keys(data.htmls)[0]]);
        runScripts(data.scripts);
        if(data.dataStorage && Object.keys(data.dataStorage).length > 0) {
            $.extend(window.EDMDataStorage, data.dataStorage);
        }
    }).always(function(){
        $entry.removeClass(loadingCssCls);
    });
}

function runScripts(scripts) {
    if(scripts && Object.keys(scripts).length > 0) {
        for(var k in scripts) {
            scripts[k].forEach(function (script) {
                $.globalEval(decodeURIComponent(script)
                    .replace(/\\n/g, '')
                    .replace(/\\/g, ''));
            });
        }
    }
}

module.exports = {
    loadEntry: loadEntry,
    loadEntryWithPost: loadEntryWithPost
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 122 */,
/* 123 */
/***/ function(module, exports, __webpack_require__) {

var commonValidator = __webpack_require__(13);
// var blackListValidator = require('./blacklist');

var FIELDS_VALIDATORS = {
    firstName: {
        basic: commonValidator.validateName
        // blacklist: blackListValidator.validateName
    },
    lastName: {
        basic: commonValidator.validateName
        // blacklist: blackListValidator.validateName
    },
    phoneNumber: {
        basic: commonValidator.validatePhoneNumber,
        verification: commonValidator.verifyPhoneNumber
        // blacklist: blackListValidator.validatePhoneNumber
    },
    // LOP-47 AB Test removes verification step
    email: {
        basic: commonValidator.validateEmail
        //verification: commonValidator.verifyEmail
        // blacklist: blackListValidator.validateEmail
    }
};

module.exports = {
    'BASIC_VALIDATOR': 'basic',
    'VERIFICATION_VALIDATOR': 'verification',
    'BLACK_LIST': 'blacklist',
    'FIELDS_VALIDATORS': FIELDS_VALIDATORS
};

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

var commonValidator = __webpack_require__(13);
// var blackListValidator = require('./blacklist');

var FIELDS_VALIDATORS = {
    firstName: {
        basic: commonValidator.validateName
        // blacklist: blackListValidator.validateName
    },
    lastName: {
        basic: commonValidator.validateName
        // blacklist: blackListValidator.validateName
    },
    phoneNumber: {
        basic: commonValidator.validatePhoneNumber,
        verification: commonValidator.verifyPhoneNumber
        // blacklist: blackListValidator.validatePhoneNumber
    },
    email: {
        basic: commonValidator.validateEmail,
        verification: commonValidator.verifyEmail
        // blacklist: blackListValidator.validateEmail
    }
};

module.exports = {
    'BASIC_VALIDATOR': 'basic',
    'VERIFICATION_VALIDATOR': 'verification',
    'BLACK_LIST': 'blacklist',
    'FIELDS_VALIDATORS': FIELDS_VALIDATORS
};

/***/ },
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ function(module, exports) {

module.exports = {
    TRACKING: {
        mazda: {
            'cx-3': {
                'suv': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885902&PluID=0&ord=[timestamp]'
                }
            },
            'cx-5': {
                'suv': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885886&PluID=0&ord=[timestamp]'
                }
            },
            'cx-9': {
                'suv': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885967&PluID=0&ord=[timestamp]'
                }
            },
            '3': {
                'hatchback': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885934&PluID=0&ord=[timestamp]'
                },
                'sedan': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885951&PluID=0&ord=[timestamp]'
                }
            },
            'mx-5-miata': {
                'convertible': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19886009&PluID=0&ord=[timestamp]'
                }
            },
            'mx-5-miata-rf': {
                'convertible': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19886026&PluID=0&ord=[timestamp]'
                }
            },
            '5': {
                'minivan': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885918&PluID=0&ord=[timestamp]'
                }
            },
            '6': {
                'sedan': {
                    link: 'https://bs.serving-sys.com/BurstingPipe/adServer.bs?cn=tf&c=20&mc=click&pli=19885983&PluID=0&ord=[timestamp]'
                }
            }
        },
        lexus: {
            'ct-200h': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450567;dc_trk_aid=313775970;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'es-300h': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449579;dc_trk_aid=313777287;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            } ,
            'es-350': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450558;dc_trk_aid=313777079;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'gs-200': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449532;dc_trk_aid=313775468;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'gs-350':{
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140448536;dc_trk_aid=313775468;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'gs-450h': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449551;dc_trk_aid=313777270;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'gx-460': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450564;dc_trk_aid=313778186;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'is-200t': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449597;dc_trk_aid=313774596;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'is-250-c': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450511;dc_trk_aid=313774596;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'is-250': {
                link:'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140448544;dc_trk_aid=313774596;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'is-350-c': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450521;dc_trk_aid=313774596;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'is-350': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449561;dc_trk_aid=313774596;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'is-300': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449566;dc_trk_aid=313774596;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'lc-500': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450506;dc_trk_aid=313776540;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ls-460': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449593;dc_trk_aid=313776245;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ls-600h-l': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140448547;dc_trk_aid=313776245;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'lx-570': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140448586;dc_trk_aid=313776055;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'nx-200t': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449548;dc_trk_aid=313778104;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'nx-300h': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450560;dc_trk_aid=313777228;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'rc-200t': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449569;dc_trk_aid=313776637;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'rc-300': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140449510;dc_trk_aid=313776637;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'rc-350': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140448563;dc_trk_aid=313776637;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'rx-350': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140450539;dc_trk_aid=313775667;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'rx-450h': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N3753.Edmunds/B10529353.140448566;dc_trk_aid=313775494;' +
                'dc_trk_cid=76333520;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            }
        },
        cadillac: {
            'cts': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142989230;dc_trk_aid=315098176;' +
                'dc_trk_cid=75702429;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'escalade': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142996915;dc_trk_aid=315098175;' +
                'dc_trk_cid=75704170;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'xt5': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142989228;dc_trk_aid=315098174;' +
                'dc_trk_cid=75704153;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ats-coupe': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142996914;dc_trk_aid=315098182;' +
                'dc_trk_cid=75704276;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ats': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142988345;dc_trk_aid=315098181;' +
                'dc_trk_cid=76151917;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ct6': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142999520;dc_trk_aid=315098177;' +
                'dc_trk_cid=75704718;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'cts-v': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142999519;dc_trk_aid=315098178;' +
                'dc_trk_cid=75702415;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'escalade-esv': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142989536;dc_trk_aid=315098175;' +
                'dc_trk_cid=75704170;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ats-v': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142989537;dc_trk_aid=315098179;' +
                'dc_trk_cid=75698379;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'xts': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10720206.142992617;dc_trk_aid=315098180;' +
                'dc_trk_cid=75699158;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            }
        }
    }
};

/***/ },
/* 129 */
/***/ function(module, exports) {

module.exports = {
    TRACKING: {
        kia: {
            'k900': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297609;dc_trk_aid=315576573;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'optima-hybrid': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297613;dc_trk_aid=315576569;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'soul': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297606;dc_trk_aid=315576576;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'cadenza': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297612;dc_trk_aid=315576570;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'sedona': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297608;dc_trk_aid=315576574;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'niro': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297614;dc_trk_aid=315576568;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'sorento': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297617;dc_trk_aid=315576565;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'soul-ev': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297615;dc_trk_aid=315576567;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'rio': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297611;dc_trk_aid=315576571;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'optima': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297610;dc_trk_aid=315576572;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'forte': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297607;dc_trk_aid=315576575;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'sportage': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297616;dc_trk_aid=315576566;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            }
        },
        fiat: {
            '500x': {
                link: 'https://ad.doubleclick.net/ddm/clk/315637829;143205475;k'
            }
        },
        honda: {
            'odyssey': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142310484;dc_trk_aid=314374213;' +
                'dc_trk_cid=69915957;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'pilot': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142310485;dc_trk_aid=313784735;' +
                'dc_trk_cid=69916207;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ridgeline': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142310486;dc_trk_aid=306749191;' +
                'dc_trk_cid=70025724;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'accord': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142315323;dc_trk_aid=308370781;' +
                'dc_trk_cid=67552343;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'cr-v': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142315324;dc_trk_aid=307148826;' +
                'dc_trk_cid=64109368;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'clarity': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142317090;dc_trk_aid=311019571;' +
                'dc_trk_cid=67847940;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'hr-v': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142318904;dc_trk_aid=311697448;' +
                'dc_trk_cid=70028662;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'accord-hybrid': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142319861;dc_trk_aid=308370781;' +
                'dc_trk_cid=67552343;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'fit': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142320405;dc_trk_aid=311699492;' +
                'dc_trk_cid=69958122;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'cr-z': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142320801;dc_trk_aid=303483314;' +
                'dc_trk_cid=70027648;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'civic': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142321718;dc_trk_aid=311019571;' +
                'dc_trk_cid=67847940;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            }
        },
        dodge: {
            'challenger': {
                link: 'https://ad.doubleclick.net/ddm/clk/315765945;143191769;v'
            },
            'durango': {
                link: 'https://ad.doubleclick.net/ddm/clk/315765916;143191772;n'
            },
            'charger': {
                link: 'https://ad.doubleclick.net/ddm/clk/315765953;143195222;i'
            },
            'journey': {
                link: 'https://ad.doubleclick.net/ddm/clk/315765939;143197044;q'
            }

        },
        chrysler: {
            'pacifica': {
                link: 'https://ad.doubleclick.net/ddm/clk/315678727;143187837;x'
            },
            'conquest': {
                'dodge':{
                    'grand-caravan': {
                        link: 'https://ad.doubleclick.net/ddm/clk/315678727;143187838;y'
                    }
                }
            }
        }
    }
};

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var NO_ADHESION_OVERLAP = 'no-adhesion-overlap';
var $body = $('body');

$('.modal-drawer.no-adhesion-overlap').on('shown.bs.modal', function () {
    if(!$body.hasClass(NO_ADHESION_OVERLAP)) {
        $body.addClass(NO_ADHESION_OVERLAP);
    }
});

$('.modal-drawer.no-adhesion-overlap').on('hidden.bs.modal', function () {
    if($body.hasClass(NO_ADHESION_OVERLAP)) {
        $body.removeClass(NO_ADHESION_OVERLAP);
    }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var consts = __webpack_require__(124);
var leadFormField = __webpack_require__(138);
var eventToolbox = __webpack_require__(1);

// Challenger LOP-47 Definitions
var constsChal = __webpack_require__(123);
var leadFormFieldChal = __webpack_require__(137);


function LeadForm($form, options) {
    this.$form = $form;
    this.$submitBtn = $form.find('[type="submit"]');
    this.submitCallbacks = $.Callbacks();

    // Redefining consts and leadFormFeild for AB Testing
    if(options && options.abtest && options.abtest === 'lop-47') {
        consts = constsChal;
        leadFormField = leadFormFieldChal;
    }

    this.init();
    this.attachEvents();
}

LeadForm.prototype.init = function() {
    var validators = this.$form.data('validators') || [consts.BASIC_VALIDATOR];
    var fieldsNames = Object.keys(consts.FIELDS_VALIDATORS);
    var fieldsSelectors = fieldsNames.map(function(name) {
        return '[name="' + name + '"]';
    }).join();

    this.fields = this.$form.find(fieldsSelectors).map(function(index, el) {
        return leadFormField($(el), validators);
    });
};

/**
 * Add form events listeners
 */
LeadForm.prototype.attachEvents = function() {
    // this.$form.on('change', this.onChange.bind(this));
    this.$form.on('submit', this.onSubmit.bind(this));
};

/**
 * Add OnSubmit Callback
 */
LeadForm.prototype.addOnSubmitCallback = function(cb) {
    this.submitCallbacks.add(cb);
};

/**
 * Check if the form is valid
 * @return {Promise} returns resolved/rejected promise when the form is valid/invalid
 */
LeadForm.prototype.isValid = function() {
    var promises = this.fields.map(function() {
        return this.isValid();
    });

    return $.when.apply($, promises);
};

/**
 * Validate the form and send a lead
 * @param  {Object} event
 * @return {Boolean}
 */
LeadForm.prototype.onSubmit = function(e) {
    this.$submitBtn.attr('disabled', true);
    var self = this;
    var creativeId = self.$submitBtn.closest('.edm-entry')[0].id;

    this.isValid().then(function() {
        var isValid = Array.prototype.every.call(arguments, function(val) { return val; });
        var fillFieldsErrorEl = self.$form.find('.fill-fields-error');
        fillFieldsErrorEl.toggleClass('hidden-xs-up', isValid);
        if(!isValid) {
            self.$submitBtn.attr('disabled', false);
            return false;
        }
        eventToolbox.fireAction({
            'event_type': 'action_progress',
            'ads': {
                'disable_refresh': true
            },
            'event_data': {
                'action_category': 'user',
                'action_name': 'lead_submission',
                'subaction_name': 'attempt_submit',
                'action_cause': 'button_click',
                'valid':'y',
                'error':'',
                'total':$('input[type=checkbox]:checked').length,
                'creative_id': creativeId
            }
        });
        self.submitCallbacks.fire(e);
    }).catch(function() {
        var err = $('.form-control-danger').map(function(index,value){
            return value.name;
        }).get().join(',');
        self.$submitBtn.attr('disabled', false);
        eventToolbox.fireAction({
            'event_type': 'action_progress',
            'ads': {
                'disable_refresh': true
            },
            'event_data': {
                'action_category': 'user',
                'action_name': 'lead_submission',
                'subaction_name': 'attempt_submit',
                'action_cause': 'button_click',
                'valid': 'n',
                'error': err,
                'total':$('input[type=checkbox]:checked').length,
                'creative_id': creativeId
            }
        });
    });

    return false;
};

/**
 * Clear
 */
LeadForm.prototype.clear = function() {
    this.submitCallbacks.empty();
    this.$form.off();
    this.$submitBtn = null;
    this.fields = null;
    this.$form = null;
};

/**
 * @example
 * require('src/interlock/no-ui/validation/lead').createLeadForm($('#vdp-lead'));
 */
module.exports = {
    createLeadForm: function($form, options) {
        return new LeadForm($form, options);
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 132 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 133 */,
/* 134 */,
/* 135 */
/***/ function(module, exports) {

/**
 * Geolocation
 * @typedef  {Object} Geolocation
 * @property {Object} coords
 * @property {String} coords.latitude
 * @property {String} coords.longitude
 */

/**
 * Get geolocation
 * @return {Object}
 * @return {Promise.<Geolocation>}
 */
function _getLocation() {
    return new Promise(function(resolve, reject) {
        if (window.navigator && window.navigator.geolocation) {
            window.navigator.geolocation.getCurrentPosition(resolve, reject);
        } else {
            reject('Geolocation is not supported.');
        }
    });
}

module.exports = {
    getLocation: _getLocation
};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/**
 * Client's location
 * @typedef {Object} Location
 * @property {string} zipCode
 * @property {string} dma
 */

var geoLocationApi = __webpack_require__(135);

function _transformResponse(data) {
    return Array.isArray(data) ? data[0] : data;
}

/**
 * Get location details by a client's IP
 * @return {Promise.<Location>}
 */
function _getLocationByClientIP() {
    var request = $.get('/api/zip/v2/fromclientip');
    
    return $.when(request).then(_transformResponse);
}

/**
 * Get location details by a client's coordinates
 * @param  {Object}    coords
 * @param  {String}    coords.latitude
 * @param  {String}    coords.longitude
 * @return {Promise.<Location>}
 */
function _getLocationByCoords(coords) {
    var request = $.get('/api/zip/v2', {
        latitude: coords.latitude,
        longitude: coords.longitude
    });

    return $.when(request).then(_transformResponse);
}

/**
 * Get location details by a client's coordinates
 * Coordinates are defined by using geolocation API
 * @return {Promise.<Location>}
 */
function _getLocationByGeoApi() {
    return geoLocationApi.getLocation().then(function(loc) {
        if(loc && loc.coords) {
            return _getLocationByCoords(loc.coords);
        } else {
            return Promise.reject('Geolocation is not found.');
        }
    });
}


module.exports = {
    getLocationByClientIP: _getLocationByClientIP,
    getLocationByCoords: _getLocationByCoords,
    getLocationByGeoApi: _getLocationByGeoApi
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {// Using AB Test version for constants
var consts = __webpack_require__(123);
var eventToolbox = __webpack_require__(1);


function LeadFormField($field, enabledValidators) {
    this.enabledValidators = enabledValidators;
    this.$field = $field;
    this.$container = $field.parent('.form-group');
    this.$feedback = this.$container.find('.form-control-feedback');
    this.lastValidationPromise;

    this.attachEvents();
}

/**
 * Add field events listeners
 */
LeadFormField.prototype.attachEvents = function() {
    this.$field.on('change', this.validate.bind(this));
};

/**
 * Get the specified validator of the field
 * @param  {String} vaidatorName
 * @return {Function}
 */
LeadFormField.prototype.getValidator = function(vaidatorName) {
    var fieldName = this.$field.attr('name');
    var fieldValidators = consts.FIELDS_VALIDATORS[fieldName];

    if(fieldValidators && fieldValidators[vaidatorName]) {
        return fieldValidators[vaidatorName];
    }
};

/**
 * Check is the validator enabled for the field
 * @param  {String}  vaidatorName
 * @return {Boolean}
 */
LeadFormField.prototype.isValidatorEnabled = function(vaidatorName) {
    return this.enabledValidators.indexOf(vaidatorName) !== -1;
};

/**
 * Validate the field using the specified validator of supported validators
 * @param  {String} vaidatorName
 * @param  {String} value
 * @return {Promise}
 */
LeadFormField.prototype.validateBy = function(vaidatorName, value) {
    var validator = this.getValidator(vaidatorName);
    if(validator && this.isValidatorEnabled(vaidatorName)) {
        return validator(value);
    }

    return $.when(true);//Promise.resolve();
};

/**
 * Validate the field using enabled of supported validators
 * It goes through validators,
 * if a validator passes the next validator is called,
 * otherwise it returns rejected promise
 * @return {Promise}
 */
LeadFormField.prototype.validate = function() {
    var value = this.$field.val();
    var self = this;

    this.lastValidationPromise = self.validateBy(consts.BASIC_VALIDATOR, value).then(function(val) {
        return val && self.validateBy(consts.VERIFICATION_VALIDATOR, value);
    }).then(function(val) {
        var valid = val;
        if(typeof val === 'object'){
            valid = val.isValid;
        }
        return valid && self.validateBy(consts.BLACK_LIST, value);
    }).then(function(val) {
        self.setValid(val);
        eventToolbox.fireCustomEvent('validation', {
            'field':self.$field,
            'value': val
        });
        return val;
    }, function() {
        console.log(self.$field, false);
        self.setValid(false);
        eventToolbox.fireCustomEvent('validation', {
            'field':self.$field,
            'value': false
        });
        return false;
    });


    return this.lastValidationPromise;
};

/**
 * Check if the field is valid
 * @return {Promise}
 */
LeadFormField.prototype.isValid = function() {
    if(!this.lastValidationPromise) {
        this.validate();
    }

    return this.lastValidationPromise;
};

/**
 * Mark the field as valid or invalid
 * @param {Boolean} isValid
 */
LeadFormField.prototype.setValid = function(isValid) {
    this.$field.toggleClass('form-control-danger', !isValid);
    this.$field.toggleClass('form-control-success', isValid);
    this.$container.toggleClass('has-danger', !isValid);
    this.$container.toggleClass('has-success', isValid);
};

module.exports = function($field, enabledValidators) {
    return new LeadFormField($field, enabledValidators);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var consts = __webpack_require__(124);
var eventToolbox = __webpack_require__(1);


function LeadFormField($field, enabledValidators) {
    this.enabledValidators = enabledValidators;
    this.$field = $field;
    this.$container = $field.parent('.form-group');
    this.$feedback = this.$container.find('.form-control-feedback');
    this.lastValidationPromise;

    this.attachEvents();
}

/**
 * Add field events listeners
 */
LeadFormField.prototype.attachEvents = function() {
    this.$field.on('change', this.validate.bind(this));
};

/**
 * Get the specified validator of the field
 * @param  {String} vaidatorName
 * @return {Function}
 */
LeadFormField.prototype.getValidator = function(vaidatorName) {
    var fieldName = this.$field.attr('name');
    var fieldValidators = consts.FIELDS_VALIDATORS[fieldName];

    if(fieldValidators && fieldValidators[vaidatorName]) {
        return fieldValidators[vaidatorName];
    }
};

/**
 * Check is the validator enabled for the field
 * @param  {String}  vaidatorName
 * @return {Boolean}
 */
LeadFormField.prototype.isValidatorEnabled = function(vaidatorName) {
    return this.enabledValidators.indexOf(vaidatorName) !== -1;
};

/**
 * Validate the field using the specified validator of supported validators
 * @param  {String} vaidatorName
 * @param  {String} value
 * @return {Promise}
 */
LeadFormField.prototype.validateBy = function(vaidatorName, value) {
    var validator = this.getValidator(vaidatorName);
    if(validator && this.isValidatorEnabled(vaidatorName)) {
        return validator(value);
    }

    return $.when(true);//Promise.resolve();
};

/**
 * Validate the field using enabled of supported validators
 * It goes through validators,
 * if a validator passes the next validator is called,
 * otherwise it returns rejected promise
 * @return {Promise}
 */
LeadFormField.prototype.validate = function() {
    var value = this.$field.val();
    var self = this;

    this.lastValidationPromise = self.validateBy(consts.BASIC_VALIDATOR, value).then(function(val) {
        return val && self.validateBy(consts.VERIFICATION_VALIDATOR, value);
    }).then(function(val) {
        var valid = val;
        if(typeof val === 'object'){
            valid = val.isValid;
        }
        return valid && self.validateBy(consts.BLACK_LIST, value);
    }).then(function(val) {
        self.setValid(val);
        eventToolbox.fireCustomEvent('validation', {
            'field':self.$field,
            'value': val
        });
        return val;
    }, function() {
        self.setValid(false);
        eventToolbox.fireCustomEvent('validation', {
            'field':self.$field,
            'value': false
        });
        return false;
    });


    return this.lastValidationPromise;
};

/**
 * Check if the field is valid
 * @return {Promise}
 */
LeadFormField.prototype.isValid = function() {
    if(!this.lastValidationPromise) {
        this.validate();
    }

    return this.lastValidationPromise;
};

/**
 * Mark the field as valid or invalid
 * @param {Boolean} isValid
 */
LeadFormField.prototype.setValid = function(isValid) {
    this.$field.toggleClass('form-control-danger', !isValid);
    this.$field.toggleClass('form-control-success', isValid);
    this.$container.toggleClass('has-danger', !isValid);
    this.$container.toggleClass('has-success', isValid);
};

module.exports = function($field, enabledValidators) {
    return new LeadFormField($field, enabledValidators);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var geolocation = __webpack_require__(136);
var commonValidator = __webpack_require__(13);
var zcUtils = __webpack_require__(140);


var GW_ZIPCODE_CHANGER_CLASS = '.gw-zipcode-changer';
var GW_ZIPCODE_ERROR_MESSAGE_CLASS = '.error-message';
var GW_ERROR = 'error';
var GW_LOADING = 'loading';
var GW_OPEN = 'open';
var ZIP_ERROR_MESSAGES = {
    DEFAULT: 'We don\'t recognize this zip code. Please try again.',
    DIGITS: 'Please enter a 5 digit zip code.'
};

function error($formParent, message) {
    var $errorMessage = $formParent.find(GW_ZIPCODE_ERROR_MESSAGE_CLASS);
    $errorMessage.text(message);
    $formParent.addClass(GW_ERROR);
}

/**
 * Adds event listener to window object with callback which calls _zipCloser function.
 * @private
 */
function _addCloseZipListener() {
    $(document).one('click', function(e) {
        _zipCloser(e);
    });
}

/**
 * This function is to toggle the class open for the zip code changer
 * @param e - event
 * @private
 */
function _zipToggler(e) {
    e.preventDefault();
    e.stopPropagation();
    var $parent = $(e.target).parents(GW_ZIPCODE_CHANGER_CLASS);
    if($parent.hasClass(GW_OPEN)) {
        $parent.removeClass(GW_OPEN);
    } else {
        $parent.addClass(GW_OPEN);
        _addCloseZipListener();
    }
}

/**
 * This function is to remove the class open for the zip code changer.
 * @param e - event
 * @private
 */
function _zipCloser(e) {
    var $zipCodeChangers = $(GW_ZIPCODE_CHANGER_CLASS);
    var $parent = $(e.target).parents(GW_ZIPCODE_CHANGER_CLASS);
    if(!$parent.length) {
        $zipCodeChangers.removeClass(GW_OPEN);
    } else {
        _addCloseZipListener();
    }
}

/**
 * To call geolocation to get the zipcode then populate it in the input field
 * @param $zipInput - jquery dom input field
 * @private
 */
function _geolocation($zipcodeForm, $zipInput) {
    var $formParent = $zipcodeForm.parent();
    $formParent.removeClass(GW_ERROR);
    $formParent.addClass(GW_LOADING);
    var geolocationTimeout;
    geolocationTimeout = setTimeout(function() {
        $formParent.removeClass(GW_LOADING);
    }, 5000);
    geolocation.getLocationByGeoApi()
        .then(function(data) {
            $zipInput.val(data.zipCode);
            clearTimeout(geolocationTimeout);
            $formParent.removeClass(GW_LOADING);
        })
        .catch(function(err) {
            error($zipcodeForm.parent(), err.message);
            clearTimeout(geolocationTimeout);
            $formParent.removeClass(GW_LOADING);
        });
}

/**
 * The submit handler that validates and redirects.
 * @param e - event
 * @private
 */
function _submit(e) {
    e.preventDefault();
    var $formParent = $(e.target).parent();
    var zipInput = e.target.elements['zip'];
    var zipValue = zipInput.value;
    var $zipUpdateButton = $(e.target).find('button');
    $(e.target).data('tracking-value', zipValue);

    $zipUpdateButton.prop('disabled', true);
    $formParent.removeClass(GW_ERROR);

    if(!zipValue) {
        error($formParent, ZIP_ERROR_MESSAGES.DEFAULT);
        $zipUpdateButton.prop('disabled', false);
        return;
    }

    commonValidator.validateZipCode(zipValue)
        .then(function(valid) {
            if(!valid) {
                $zipUpdateButton.prop('disabled', false);
                error($formParent, ZIP_ERROR_MESSAGES.DIGITS);
                return;
            }
            commonValidator.verifyZipCode(zipValue)
                .then(function(data) {
                    $zipUpdateButton.prop('disabled', false);
                    if(!data.isValid) {
                        error($formParent, ZIP_ERROR_MESSAGES.DEFAULT);
                        return;
                    }
                    var url = window.location.pathname + zcUtils.parseSearchWithZip(zipValue);
                    if(window.location.hash) {
                        url += window.location.hash;
                    }
                    window.location = url;
                })
                .catch(function() {
                    $zipUpdateButton.prop('disabled', false);
                    error($formParent, ZIP_ERROR_MESSAGES.DEFAULT);
                    return;
                });
        });
}

module.exports = {
    zipToggler: _zipToggler,
    submit: _submit,
    geolocation: _geolocation,
    zipCloser: _zipCloser
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 140 */
/***/ function(module, exports) {

/**
 * This changes the appends/updates zip in the window.location.search
 * @param zipValue
 * @returns {string}
 * @private
 */
function _parseSearchWithZip(zipValue) {
    var newSearches = [];
    var hasZipParam = false;
    if(window.location.search) {
        var searches = window.location.search.substr(1, window.location.search.length);
        searches.split('&').forEach(function(search) {
            var searchSplit = search.split('=');
            var key = searchSplit[0];
            var value = searchSplit[1] || '';
            if(key === 'zip') {
                value = zipValue;
                hasZipParam = true;
            }
            newSearches.push(key+ '=' +value);
        });
    }
    if(!hasZipParam) {
        newSearches.push('zip='+zipValue);
    }

    return '?' + newSearches.join('&');
}

module.exports = {
    parseSearchWithZip: _parseSearchWithZip
};

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * isMobile.js v0.4.0
 *
 * A simple library to detect Apple phones and tablets,
 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
 * and any kind of seven inch device, via user agent sniffing.
 *
 * @author: Kai Mallea (kmallea@gmail.com)
 *
 * @license: http://creativecommons.org/publicdomain/zero/1.0/
 */
(function (global) {

    var apple_phone         = /iPhone/i,
        apple_ipod          = /iPod/i,
        apple_tablet        = /iPad/i,
        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
        android_tablet      = /Android/i,
        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
        windows_phone       = /IEMobile/i,
        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
        other_blackberry    = /BlackBerry/i,
        other_blackberry_10 = /BB10/i,
        other_opera         = /Opera Mini/i,
        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
        seven_inch = new RegExp(
            '(?:' +         // Non-capturing group

            'Nexus 7' +     // Nexus 7

            '|' +           // OR

            'BNTV250' +     // B&N Nook Tablet 7 inch

            '|' +           // OR

            'Kindle Fire' + // Kindle Fire

            '|' +           // OR

            'Silk' +        // Kindle Fire, Silk Accelerated

            '|' +           // OR

            'GT-P1000' +    // Galaxy Tab 7 inch

            ')',            // End non-capturing group

            'i');           // Case-insensitive matching

    var match = function(regex, userAgent) {
        return regex.test(userAgent);
    };

    var IsMobileClass = function(userAgent) {
        var ua = userAgent || navigator.userAgent;

        // Facebook mobile app's integrated browser adds a bunch of strings that
        // match everything. Strip it out if it exists.
        var tmp = ua.split('[FBAN');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        // Twitter mobile app's integrated browser on iPad adds a "Twitter for
        // iPhone" string. Same probable happens on other tablet platforms.
        // This will confuse detection so strip it out if it exists.
        tmp = ua.split('Twitter');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        this.apple = {
            phone:  match(apple_phone, ua),
            ipod:   match(apple_ipod, ua),
            tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
            device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
        };
        this.amazon = {
            phone:  match(amazon_phone, ua),
            tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua)
        };
        this.android = {
            phone:  match(amazon_phone, ua) || match(android_phone, ua),
            tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
        };
        this.windows = {
            phone:  match(windows_phone, ua),
            tablet: match(windows_tablet, ua),
            device: match(windows_phone, ua) || match(windows_tablet, ua)
        };
        this.other = {
            blackberry:   match(other_blackberry, ua),
            blackberry10: match(other_blackberry_10, ua),
            opera:        match(other_opera, ua),
            firefox:      match(other_firefox, ua),
            chrome:       match(other_chrome, ua),
            device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
        };
        this.seven_inch = match(seven_inch, ua);
        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

        // excludes 'other' devices and ipods, targeting touchscreen phones
        this.phone = this.apple.phone || this.android.phone || this.windows.phone;

        // excludes 7 inch devices, classifying as phone or tablet is left to the user
        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

        if (typeof window === 'undefined') {
            return this;
        }
    };

    var instantiate = function() {
        var IM = new IsMobileClass();
        IM.Class = IsMobileClass;
        return IM;
    };

    if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
        //node
        module.exports = IsMobileClass;
    } else if (typeof module !== 'undefined' && module.exports && typeof window !== 'undefined') {
        //browserify
        module.exports = instantiate();
    } else if (true) {
        //AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (global.isMobile = instantiate()), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {
        global.isMobile = instantiate();
    }

})(this);


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var carouselEvents = __webpack_require__(89);
var responsiveToolkit = __webpack_require__(7);

var $carousel = $('.at-a-glance-carousel-wrapper .owl-carousel');
var slides = {};
// move to constants
var defaultOffset = 5;

module.exports = {
    isSmall: function() {
        return responsiveToolkit.is('<=sm');
    },
    getCurrentSlideIndex: function() {
        return $carousel.find('.owl-item.active').index('.owl-item:not(.cloned)') - defaultOffset + 1;
    },
    getItems: function() {
        return $carousel.find('.owl-item:not(.cloned) .item');
    },
    backup: function(key) {
        slides[key] = this.getItems().clone();
    },
    restore: function(key) {
        var items = slides[key];
        if(items) {
            this.clear();
            items.map(function(index, item) {
                carouselEvents.addSlide($carousel, item);
            });
            carouselEvents.refresh($carousel);
            carouselEvents.changeSlide($carousel, defaultOffset, 85);
        }
    },
    clear: function() {
        this.getItems().map(function() {
            carouselEvents.removeSlide($carousel, 0);
        });
        carouselEvents.refresh($carousel);
    }
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var responsiveToolkit = __webpack_require__(7),
    constant = __webpack_require__(146);

var SPONSORED_AD_TEMPLATE = {
    WIRED: 'aag-ad-wired',
    MOBILE: 'aag-ad-mobile'
};

var EventHandlersHelper = function() {
    var aagCarousel = document.querySelector('.at-a-glance-carousel-wrapper');
    var web503 = ($('.image-type-selector').data('abtest') === 'web-503');

    return {
        getCurrentDataIndex: function(cb) {
            // Yeah, I have to make a setTimeout because the changed.owl.carousel happens after the fact.
            // So yeah. If you can think of a better way, lets try
            setTimeout(function() {
                var currentIndex, activeItem;
                //var allItemsLength = getLength(aagCarousel.querySelectorAll('.owl-item'));
                if (aagCarousel) {
                    activeItem = aagCarousel.querySelector('.owl-item.active');
                }
                if (activeItem) {
                    currentIndex = parseInt(activeItem.querySelector('.item').getAttribute('data-index'), 10);
                }
                cb(currentIndex);
            }, 10);
        },

        createSlide: function(photoObj, useImageService, slotIndex) {
            var photoSizes = photoObj.photoSizes,
                elItem = document.createElement('div'),
                elCarouselItem = document.createElement('div'),
                photoToUse,
                sizeWeNeed = photoSizes.reduce(function (photoIndexToUse, photoSize, index) {
                    if (photoSize == photoObj.originalWidth || photoSize === constant.DEFAULT_PHOTO_SIZE) {
                        photoIndexToUse = index;
                    }
                    return photoIndexToUse;
                }, 0);

            photoToUse = photoObj.photoSrcs[sizeWeNeed];
            if (useImageService) {
                photoToUse = 'https://services.edmunds-media.com/image-service/media-ed/sharp/' +
                    '?crop=16x7&quality=70&format=jpg:progressive&image=' + photoToUse;
            }
            elItem.classList.add('item');
            elItem.setAttribute('data-index', slotIndex);
            elCarouselItem.classList.add('carousel-image');
            elCarouselItem.setAttribute('data-selenium', slotIndex);
            elCarouselItem.setAttribute('data-alt', photoObj.captionTranscript);
            elCarouselItem.style.backgroundImage = 'url(' + photoToUse + ')';
            elItem.appendChild(elCarouselItem);
            if (aagCarousel.querySelector('.sponsored-ad-templates').children.length) {
                elItem.appendChild(this.createRandomAdUnit());
            }
            $(elItem).append(constant.ARROW_HANDLER.join(''));
            $(elItem).find('.punit').asyncGptTag({});
            return elItem;
        },

        createRandomAdUnit: function() {
            var lengthOfSponsoredAds = $('.sponsored-ad-templates .dub-ad-wrapper').length || 0;
            // divides by 2 because it appends both mobile and wired ad.
            var randomSlot = Math.floor(Math.random() * (lengthOfSponsoredAds / 2) + 0);
            var selector = '.sponsored-ad-templates .spon-ad-' + randomSlot;
            if(responsiveToolkit.is('<=sm')) {
                selector += '.' + SPONSORED_AD_TEMPLATE.MOBILE;
            } else {
                selector += '.' + SPONSORED_AD_TEMPLATE.WIRED;
            }
            var dubAdWrapper = document.createElement('div');
            dubAdWrapper.classList.add('dub-ad-wrapper', 'p-a-0_5');
            var adElement = aagCarousel.querySelector(selector).cloneNode(true);
            if (adElement) {
                dubAdWrapper.appendChild(adElement);
            }
            return dubAdWrapper;
        },

        createFilterLink: function(data, count) {
            var anchor = document.createElement('a');
            anchor.setAttribute('data-image-type', data);
            anchor.href = '#';
            if(web503) {
                var div = document.createElement('div');
                div.appendChild(anchor);
                var imgDiv = document.createElement('div');
                imgDiv.classList.add('dark-over');
                imgDiv.classList.add(data);
                var span = document.createElement('span');
                span.innerHTML = data;
                span.classList.add(data+'-span');
                span.classList.add('filter-text');
                span.innerHTML = data + ' ('+count+')';
                anchor.appendChild(imgDiv);
                anchor.appendChild(span);
                anchor.classList.add(data+'-wrapper');
                return div;
            }
            anchor.innerHTML = data;

            return anchor;
        },

        addAllLink: function(cats, count){
            if(web503){
                cats.appendChild(this.createFilterLink('all', count));
            }
        },

        web503Helper: function(aagcData, cats, data){
            if(!web503){
                cats.appendChild(this.createFilterLink(aagcData.CATEGORY_HOME));
            }
            var count = 0;
            for(var cat in data) {
                if(data[cat]) {
                    count += data[cat];
                    if(web503 && cat === 'interior'){
                        $(cats).prepend(this.createFilterLink(cat, data[cat]));
                    } else {
                        cats.appendChild(this.createFilterLink(cat, data[cat]));
                    }
                }
            }
            this.addAllLink(cats, count);
        },

        populateTypeFilter: function(aagcData, cats, data) {
            if(cats) {
                this.web503Helper(aagcData, cats, data);
            }
        }
    };
};
module.exports = new EventHandlersHelper();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var eventToolbox = __webpack_require__(1);
var cookies = __webpack_require__(91);

var aagc, typeSelector, cats, captionText, filterBtn;
var OPEN_CLASS = 'open';
var ICON_PLUS_CIRCLE = 'icon-plus-circle2';
var ICON_MINUS_CIRCLE = 'icon-minus-circle2';

var initDom = function() {
    aagc = document.querySelector('.at-a-glance-carousel-wrapper');
    if (aagc) {
        typeSelector = aagc.querySelector('.image-type-selector');
        cats = aagc.querySelector('.categories');
        captionText = aagc.querySelector('.caption-text');
        filterBtn = typeSelector.querySelector('.filter-btn');
    }
};

var changeFilterBtnClass = function() {
    var web503 = ($('.image-type-selector').data('abtest') === 'web-503');
    if(!web503) {

        if (typeSelector.classList.contains(OPEN_CLASS)) {
            filterBtn.classList.remove(ICON_PLUS_CIRCLE);
            filterBtn.classList.add(ICON_MINUS_CIRCLE);
        } else {
            filterBtn.classList.remove(ICON_MINUS_CIRCLE);
            filterBtn.classList.add(ICON_PLUS_CIRCLE);
        }
    } else {
        var filterBtnIcon = typeSelector.querySelector('.filter-btn .icon');
        var filterBtnText = typeSelector.querySelector('.filter-btn .filter-text');

        if (typeSelector.classList.contains(OPEN_CLASS)) {
            filterBtnIcon.classList.add('icon-cross2');
            filterBtnText.innerHTML = 'close';
        } else {
            filterBtnIcon.classList.remove('icon-cross2');
            filterBtnText.innerHTML = 'filter';
        }
    }
};

var _toggleFilter = function(isButtonClick, isOpened) {
    initDom();
    if(isOpened) {
        typeSelector.classList.toggle(OPEN_CLASS, isOpened);
        if(cats) { cats.classList.toggle(OPEN_CLASS, isOpened); }
        captionText.classList.toggle(OPEN_CLASS, isOpened);
    } else {
        // Safari cannot handle situations where second argument to toggle() is undefined; it seems to evaluate to false.
        // We do not want to force a value in all cases; we want toggle() to handle what to do based on existence of passed class.
        typeSelector.classList.toggle(OPEN_CLASS);
        if(cats) { cats.classList.toggle(OPEN_CLASS); }
        captionText.classList.toggle(OPEN_CLASS);
    }
    _fireViewFilter(isButtonClick);
    changeFilterBtnClass();
};

var _closeFilter = function(e) {
    var $parent = $(e.target).parents('.image-type-selector');
    if($parent.length > 0) {
        return;
    }
    initDom();

    if(typeSelector.classList.contains(OPEN_CLASS)) {
        typeSelector.classList.remove(OPEN_CLASS);
    }
    if(cats && cats.classList.contains(OPEN_CLASS)) {
        cats.classList.remove(OPEN_CLASS);
    }
    if(captionText.classList.contains(OPEN_CLASS)) {
        captionText.classList.remove(OPEN_CLASS);
    }
    changeFilterBtnClass();
};

var fireChangeContent = function (cat) {
    var val = cat;
    if(cat === 'all'){
        val = 'home';
    }
    eventToolbox.fireAction({
        'event_type': 'action_completed',
        'ads': {
            'disable_refresh': true
        },
        'event_data': {
            'action_category': 'user',
            'action_name':'view_content',
            'subaction_name':'view_filter_content',
            'action_cause': 'link_click',
            'creative_id': 'edm-entry-at-a-glance',
            'value':val
        }
    });
};
var fireToggleFilter = function () {
    initDom();
    var subAction = (typeSelector.classList.contains(OPEN_CLASS)) ? 'close_filter_panel' : 'open_filter_panel';
    eventToolbox.fireAction({
        'event_type': 'action_completed',
        'ads': {
            'disable_refresh': true
        },
        'event_data': {
            'action_category': 'user',
            'action_name': 'view_content',
            'subaction_name': subAction,
            'action_cause': 'button_click',
            'creative_id': 'edm-entry-at-a-glance'
        }
    });
};

var _fireViewFilter = function (isButtonClick) {
    if (typeSelector.classList.contains(OPEN_CLASS)) {
        cookies.setItem('aagFilter','open',null,'/');
        var action = isButtonClick ? 'button_click' : 'page_load';
        eventToolbox.fireAction({
            'event_type': 'action_completed',
            'ads': {
                'disable_refresh': true
            },
            'event_data': {
                'action_category': 'user',
                'action_name': 'view_content',
                'subaction_name': 'view_filter_panel',
                'action_cause': action,
                'creative_id': 'edm-entry-at-a-glance'
            }
        });
    }
};

module.exports = {
    toggleFilter: _toggleFilter,
    closeFilter: _closeFilter,
    fireChangeContent: fireChangeContent,
    fireToggleFilter: fireToggleFilter
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 145 */,
/* 146 */
/***/ function(module, exports) {

/**
 * At a glance common constant values
 *
 * @type {{}}
 */

module.exports = {


    /**
     * Default size of photo loaded to at a glance
     */
    DEFAULT_PHOTO_SIZE: 1280,
    USED_PHOTO_SIZE: 500,
    ARROW_HANDLER:[
        '<span class="left carousel-control " role="button">',
        '<span class="icon-prev" aria-hidden="true"></span>',
        '</span>',
        '<span class="right carousel-control " role="button">',
        '<span class="icon-next" aria-hidden="true"></span>',
        '</span>']
};


/***/ },
/* 147 */
/***/ function(module, exports) {

module.exports = {
    TRACKING: {
        acura: {
            'rlx': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9584106.142314486;dc_trk_aid=315415113;' +
                'dc_trk_cid=62062043;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'tlx': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9584106.142320656;dc_trk_aid=315409667;' +
                'dc_trk_cid=62013615;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'mdx': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9584106.142320770;dc_trk_aid=315552644;' +
                'dc_trk_cid=62060969;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ilx': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9584106.142321031;dc_trk_aid=315410895;' +
                'dc_trk_cid=62061818;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'rdx': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9584106.142321032;dc_trk_aid=315414617;' +
                'dc_trk_cid=62011569;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            }
        },
        'alfa-romeo': {
            'giulia': {
                link: 'https://ad.doubleclick.net/ddm/clk/315603817;143547838;m'
            },
            '4c': {
                link: 'https://ad.doubleclick.net/ddm/clk/315603817;143547842;h'
            },
            '4c-spider': {
                link: 'https://ad.doubleclick.net/ddm/clk/315596479;143547903;u'
            }
        },
        nissan: {
            'altima': {
                link: 'https://ad.doubleclick.net/ddm/clk/315392379;142244366;j'
            },
            'armada': {
                link: 'https://ad.doubleclick.net/ddm/clk/315399968;142244363;r'
            },
            'frontier': {
                link: 'https://ad.doubleclick.net/ddm/clk/315406423;142244369;y'
            },
            'juke': {
                link: 'https://ad.doubleclick.net/ddm/clk/315410992;142244372;y'
            },
            'leaf': {
                link: 'https://ad.doubleclick.net/ddm/clk/315464281;142244375;b'
            },
            'maxima': {
                link: 'https://ad.doubleclick.net/ddm/clk/315467769;142244381;m'
            },
            'murano': {
                link: 'https://ad.doubleclick.net/ddm/clk/315477360;142244378;g'
            },
            'pathfinder': {
                link: 'https://ad.doubleclick.net/ddm/clk/315482225;142244385;a'
            },
            'quest': {
                link: 'https://ad.doubleclick.net/ddm/clk/315469129;142244388;l'
            },
            'rogue': {
                link: 'https://ad.doubleclick.net/ddm/clk/315467387;142244392;k'
            },
            'sentra': {
                link: 'https://ad.doubleclick.net/ddm/clk/315467895;142244395;r'
            },
            'titan': {
                link: 'https://ad.doubleclick.net/ddm/clk/315476219;142244399;l'
            },
            'titan-xd': {
                link: 'https://ad.doubleclick.net/ddm/clk/315477353;142247209;e'
            },
            'versa-note': {
                link: 'https://ad.doubleclick.net/ddm/clk/315478224;142247203;w'
            },
            'versa': {
                link: 'https://ad.doubleclick.net/ddm/clk/315477361;142247206;a'
            },
            'nv200': {
                link: 'https://ad.doubleclick.net/ddm/clk/315623635;142705437;c'
            },
            'nv-passenger': {
                link: 'https://ad.doubleclick.net/ddm/clk/315327971;142705018;b'
            },
            'nv-cargo': {
                link: 'https://ad.doubleclick.net/ddm/clk/315623190;142705017;s'
            }
        },
        chevrolet: {
            'cruze-limited': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142593465;dc_trk_aid=314940101;' +
                'dc_trk_cid=76158335;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'cruze': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142592288;dc_trk_aid=314940101;' +
                'dc_trk_cid=76158335;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'equinox': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142594236;dc_trk_aid=314931392;' +
                'dc_trk_cid=76159178;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'malibu-limited': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142591878;dc_trk_aid=314931399;' +
                'dc_trk_cid=76202823;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'malibu': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142592589;dc_trk_aid=314931399;' +
                'dc_trk_cid=76202823;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'silverado-1500': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142592592;dc_trk_aid=314931389;' +
                'dc_trk_cid=76198236;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'silverado-2500hd': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142592591;dc_trk_aid=314940102;' +
                'dc_trk_cid=75717642;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'silverado-3500hd': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142594428;dc_trk_aid=314931387;' +
                'dc_trk_cid=75711590;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'spark-ev': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142592593;dc_trk_aid=314940105;' +
                'dc_trk_cid=75706056;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'spark': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142593467;dc_trk_aid=314940103;' +
                'dc_trk_cid=75704753;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'suburban': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142593279;dc_trk_aid=314931397;' +
                'dc_trk_cid=75716665;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'traverse': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142593075;dc_trk_aid=314931396;' +
                'dc_trk_cid=76205207;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'volt': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8334.2990.EDMUNDS.COMINC1/B10691783.142593466;dc_trk_aid=314940106;' +
                'dc_trk_cid=76205220;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            }
        },
        jeep: {
            '': {
                link: 'https://ad.doubleclick.net/ddm/clk/315741805;143890323;c'
            },
            'compass': {
                link: 'https://ad.doubleclick.net/ddm/clk/315748242;143909053;f'
            },
            'cherokee': {
                link: 'https://ad.doubleclick.net/ddm/clk/315748231;143908951;j'
            },
            'grand-cherokee': {
                link: 'https://ad.doubleclick.net/ddm/clk/315748236;143909051;g'
            },
            'patriot': {
                link: 'https://ad.doubleclick.net/ddm/clk/315747237;143908949;v'
            },
            'renegade': {
                link: 'https://ad.doubleclick.net/ddm/clk/315748238;143890322;i'
            },
            'wrangler': {
                link: 'https://ad.doubleclick.net/ddm/clk/315747239;143910239;i'
            }
        }
    }
};

/***/ },
/* 148 */
/***/ function(module, exports) {

var model = {
    'chevrolet': [
        {'niceName': 'Spark', 'id': 'spark-fuel-efficient-car'},
        {'niceName': 'Spark EV', 'id': 'spark-fuel-efficient-car'},
        {'niceName': 'Sonic', 'id': 'sonic-small-car'},
        {'niceName': 'Cruze', 'id': 'cruze-compact-car'},
        {'niceName': 'Cruze Limited', 'id': 'cruze-compact-car'},
        {'niceName': 'Colorado', 'id': 'colorado-mid-size-truck'},
        {'niceName': 'Trax', 'id': 'trax-small-suv'},
        {'niceName': 'Malibu', 'id': 'malibu-mid-size-car'},
        {'niceName': 'City Express', 'id': 'city-express-small-cargo-van'},
        {'niceName': 'Malibu Limited', 'id': 'malibu-limited'},
        {'niceName': 'Equinox', 'id': 'equinox-fuel-efficient-suv'},
        {'niceName': 'Camaro', 'id': 'camaro-sports-car'},
        {'niceName': 'Camaro ZL1', 'id': 'camaro-zl1'},
        {'niceName': 'Impala', 'id': 'impala-full-size-cars'},
        {'niceName': 'Silverado 1500HD', 'id': 'silverado-1500-pickup-truck'},
        {'niceName': 'Silverado 2500HD', 'id': 'silverado-2500hd-heavy-duty-trucks'},
        {'niceName': 'Silverado 3500HD', 'id': 'silverado-3500hd-diesel-trucks'},
        {'niceName': 'Traverse', 'id': 'traverse-mid-size-suv'},
        {'niceName': 'Express Cargo', 'id': 'express/cargo'},
        {'niceName': 'Express Passenger', 'id': 'express/passenger'},
        {'niceName': 'Volt', 'id': 'volt-electric-car'},
        {'niceName': 'SS', 'id': 'ss-sports-sedan'},
        {'niceName': 'Tahoe', 'id': 'tahoe-full-size-suv'},
        {'niceName': 'Suburban', 'id': 'suburban-suv'},
        {'niceName': 'Corvette Stingray', 'id': 'corvette-stingray'},
        {'niceName': 'Corvette Grand Sport', 'id': 'corvette-grand-sport'},
        {'niceName': 'Corvette Z06', 'id': 'corvette-z06-supercar'}
    ],
    'maserati': [
        {'niceName': 'GHIBLI',                 'trim': 'Base',          'id': 'GHIBLI_350'},
        {'niceName': 'GHIBLI',                 'trim': 'S',             'id': 'GHIBLI_410'},
        {'niceName': 'GHIBLI',                 'trim': 'S Q4',          'id': 'GHIBLI_410A'},
        {'niceName': 'LEVANTE',                'trim': 'Base',          'id': 'LV_350A'},
        {'niceName': 'LEVANTE',                'trim': 'S',             'id': 'LV_430A'},
        {'niceName': 'QUATTROPORTE',           'trim': 'S',             'id': 'QPV6_410R'},
        {'niceName': 'QUATTROPORTE',           'trim': 'S GranLusso',   'id': 'QPV6_410R'},
        {'niceName': 'QUATTROPORTE',           'trim': 'S Q4',          'id': 'QPV6_410A'},
        {'niceName': 'QUATTROPORTE',           'trim': 'GTS',           'id': 'QPV8_530'},
        {'niceName': 'GRANTURISMO',            'trim': 'Sport',         'id': 'GTSPauto'},
        {'niceName': 'GRANTURISMO',            'trim': 'MC',            'id': 'GTMC'},
        {'niceName': 'GRANTURISMO',            'trim': 'MC Centennial', 'id': 'GTMC100'},
        {'niceName': 'GRANTURISMO CONVERTIBLE','trim': 'Base',          'id': 'GC'},
        {'niceName': 'GRANTURISMO CONVERTIBLE','trim': 'Sport',         'id': 'GCS'},
        {'niceName': 'GRANTURISMO CONVERTIBLE','trim': 'MC',            'id': 'GCMC'},
        {'niceName': 'GRANTURISMO CONVERTIBLE','trim': 'MC Centennial', 'id': 'GCMC100'}
    ],
    'nissan': [
        { 'niceName': 'VERSA',               'submodel': 'sedan',        'id':'VSD' },
        { 'niceName': 'VERSA',               'submodel': 'note',        'id':'VER' },
        { 'niceName': 'VERSA NOTE',          'submodel': 'hatchback',        'id':'VER' },
        { 'niceName': 'SENTRA',              'submodel': 'sedan',        'id':'SEN' },
        { 'niceName': 'ALTIMA',              'submodel': 'sedan',               'id':'ALT' },
        { 'niceName': 'MAXIMA',              'submodel': 'sedan',        'id':'MAX' },
        { 'niceName': '370Z',                'submodel': 'coupe',          'id':'Z' },
        { 'niceName': '370Z',                'submodel': 'nismo',          'id':'Z' },
        { 'niceName': '370Z',                'submodel': 'nismo-tech',          'id':'Z' },
        { 'niceName': '370Z',                'submodel': 'convertible',        'id':'Z' },
        { 'niceName': '370Z',                'submodel': 'roadster',        'id':'ZRD' },
        { 'niceName': 'GT-R',                'submodel': 'coupe',        'id':'GTR' },
        { 'niceName': 'GT-R',                'submodel': 'nismo',        'id':'GTR' },
        { 'niceName': 'JUKE',                'submodel': 'hatchback',        'id':'JKE' },
        { 'niceName': 'JUKE',                'submodel': 'nismo-rs',        'id':'JKE' },
        { 'niceName': 'LEAF',                'submodel': 'hatchback',        'id':'LEF' },
        { 'niceName': 'ROGUE',               'submodel': 'suv',        'id':'RGE' },
        { 'niceName': 'ROGUE SELECT',        'submodel': 'suv',        'id':'RGE' },
        { 'niceName': 'MURANO',              'submodel': 'hybrid',        'id':'MUR' },
        { 'niceName': 'MURANO',              'submodel': 'suv',        'id':'MUR' },
        { 'niceName': 'PATHFINDER',          'submodel': 'suv',        'id':'PTH' },
        { 'niceName': 'ARMADA',              'submodel': 'suv',     'id':'ARM' },
        { 'niceName': 'QUEST',               'submodel': 'minivan',        'id':'QST' },
        { 'niceName': 'NV PASSENGER',        'submodel': 'van',        'id':'NV Passenger' },
        { 'niceName': 'FRONTIER',            'submodel': 'crew-cab',        'id':'' },
        { 'niceName': 'FRONTIER',            'submodel': 'king-cab',        'id':'720' },
        { 'niceName': 'TITAN',               'submodel': 'crew-cab',        'id':'TTN' },
        { 'niceName': 'TITAN',               'submodel': 'regular-cab',        'id':'TTN' },
        { 'niceName': 'TITAN XD',            'submodel': 'crew-cab',        'id':'TXD' },
        { 'niceName': 'TITAN XD',            'submodel': 'diesel',        'id':'TXD' },
        { 'niceName': 'TITAN XD',            'submodel': 'regular-cab',        'id':'TXD' },
        { 'niceName': 'NV200 COMPACT CARGO', 'submodel': '',        'id':'NV200' },
        { 'niceName': 'NV200',               'submodel': 'minivan',        'id':'NV200' },
        { 'niceName': 'NV CARGO',            'submodel': 'van',        'id':'NV1500' },
        { 'niceName': 'NV200 TAXI',          'submodel': '',        'id':'nv200-taxi' }
    ]
};

module.exports = {
    model: model
};

/***/ },
/* 149 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

var eventToolbox = __webpack_require__(1);

function readyListTracking(){
    var savingRetrieval = window.EDMDataStorage.leadformTracking; //NOTE THAT THIS MATCHES THE KEY IN FTL.
    if(savingRetrieval) {
        savingRetrieval.ads = {
            disable_refresh: true
        };
        eventToolbox.fireAction(savingRetrieval); //pixel gets fired here
    }
}
function fireOpenWidgetTracking(){
    eventToolbox.fireAction({
        'event_type': 'action_start',
        'ads': {
            'disable_refresh': true
        },
        'event_data': {
            'action_category': 'user',
            'action_name':'lead_submission',
            'subaction_name':'display_lead_form',
            'action_cause': 'page_load',
            'creative_id': 'edm-entry-pricing-lead-form'
        }
    });
}

function fireSuccessfulSubmit(typeStr, blended, count){
    eventToolbox.fireAction({
        'event_type': 'action_completed',
        'ads': {
            'disable_refresh': true
        },
        'event_data': {
            'action_category': 'system',
            'action_name': 'lead_submit_validation',
            'subaction_name': 'processed_submit',
            'action_cause': 'button_click',
            'type':typeStr,
            'isBlended':blended,
            'total':count,
            'creative_id': 'edm-entry-pricing-lead-form'
        }
    });
}

module.exports = {
    fireOpenWidgetTracking:fireOpenWidgetTracking,
    fireSuccessfulSubmit:fireSuccessfulSubmit,
    readyListTracking:readyListTracking

};

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var stringUtils = __webpack_require__(113);

function getSelectedData() {
    var selectedVins = $('.lead-form-pricing .custom-control.inventory-checkbox')
        .filter(function (index, el) {
            return $(el).find('input:checked').length === 1;
        })
        .find('.suggestion')
        .get()
        .map(function (el) {
            return  {
                vin: el.dataset.vin,
                gpExpirationDate: el.dataset['expiration'],
                dealer:el.dataset.rooftopId,
                franchise:el.dataset.franchiseId,
                position: el.dataset.position,
                leadType: el.dataset.leadType,
                make:el.dataset.make,
                styleId:el.dataset.styleId
            };
        });

    return selectedVins;
}

function getInventoryCount() {
    return $('.lead-form-pricing:visible .custom-control.inventory-checkbox .suggestion').length;
}

function claimAllSelectedDealersQuotes() {
    var formWrap = $('.lead-form-pricing');
    var allCards = formWrap.find('.suggestions .gray-bottom');
    var defaultElem = formWrap.find('.default');
    var backupElem = formWrap.find('.backup');
    var largestSavings = 0;
    var totalPP = 0;

    allCards.each(function() {
        if ($( this ).find('.invCheckbox').prop('checked')) {
            var savings = 0;
            var msrp = $( this ).find('.suggestion').data('msrp');
            var pp = $( this ).find('.suggestion').data('pp');
            if (msrp && pp) {
                totalPP++;
                savings = msrp - pp;
                if (savings > largestSavings) {
                    largestSavings = parseInt(savings, 10);
                }
            }
        }
    });

    if (defaultElem) {
        if (largestSavings && totalPP >= 2) {
            $('.lead-form-pricing').find('.savingsMsg').html(stringUtils.formatAsUsPrice(largestSavings, 'N/A'));
            defaultElem.css('display', 'block');
            backupElem.css('display', 'none');
        } else {
            defaultElem.css('display', 'none');
            backupElem.css('display', 'block');
        }
    }
}

function addCheckboxHandler(form) {
    var leadForm = form.closest('.lead-form-pricing');

    leadForm.on('change', '.suggestions .custom-checkbox', function () {
        var selectDealerErrorEl = form.find('.select-dealer-error');
        var seePricesButton = form.find('.btn-success');
        var selData = getSelectedData();
        if(selData.length) {
            selectDealerErrorEl.addClass('hidden-xs-up');
            seePricesButton.prop('disabled', false);
        }
    });
}

function calcSavings() {
    claimAllSelectedDealersQuotes();
    var inventoryWrap = document.querySelector('.suggestions');
    inventoryWrap.addEventListener('click', function (e) {
        if (e.target.classList.contains('invCheckbox')) {
            claimAllSelectedDealersQuotes();
        }
    });
}

module.exports = {
    getSelectedData: getSelectedData,
    getInventoryCount: getInventoryCount,
    addCheckboxHandler: addCheckboxHandler,
    calcSavings: calcSavings
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(154);
__webpack_require__(99);
__webpack_require__(106);

//var ppCertificate = require('src/interlock/lead/certificate/inventory/new/price-promise');
var eventToolbox = __webpack_require__(1);


var queryString = __webpack_require__(120);
//var deferredLoader = require('src/interlock/no-ui/defer/loader');


var $leadFormPPThankYouDrawer = $('.lead-form-price-promise-thank-you.modal-drawer');
//var $leadFormPPCertificateDrawer = $('.lead-form-price-promise-certificate.modal-drawer');


function closePrint () {
    document.body.removeChild(this.__container__);
}

function setPrint () {
    this.contentWindow.__container__ = this;
    this.contentWindow.onbeforeunload = closePrint;
    this.contentWindow.onafterprint = closePrint;
    this.contentWindow.focus(); // Required for IE
    this.contentWindow.print();
}

function printPage (sURL) {
    var oHiddFrame = document.createElement('iframe');
    oHiddFrame.onload = setPrint;
    oHiddFrame.style.visibility = 'hidden';
    oHiddFrame.style.position = 'fixed';
    oHiddFrame.style.right = '0';
    oHiddFrame.style.bottom = '0';
    oHiddFrame.src = sURL;
    document.body.appendChild(oHiddFrame);
}

$leadFormPPThankYouDrawer.on('click', '.print-price-promise', function() {
    var url = '/groundwork/lead/certificate/inventory/new/price-promise/?';
    var $el = $(this);
    var vin = $el.data('vin');
    url = url + '&vin='+vin;
    printPage(url);
});

function makeParamsStr(params) {
    return queryString.stringify(params, {
        strict: true,
        encode: true
    });
}

function fireThankyouTracking(){
    var matchObj = window.EDMDataStorage.thankyouMatches;
    var savingRetrieval = JSON.parse($('input[name="thankyouTrack"]')[0].value);
    if(savingRetrieval) {
        var matchingDealers = savingRetrieval.event_data.loc_id_list.split(',');
        var matchingMatches = '';
        matchingDealers.forEach(function(el){
            matchingMatches += matchObj[el]+',';
        });
        savingRetrieval.event_data.match_type_list = matchingMatches.substring(0, (matchingMatches.length - 1));
        savingRetrieval.event_data.action_category = 'system';
        savingRetrieval.ads = {
            disable_refresh: true
        };
        eventToolbox.fireAction(savingRetrieval); //pixel gets fired here
    }
    eventToolbox.fireAction({
        'event_type': 'action_end',
        'ads': {
            'disable_refresh': true
        },
        'event_data': {
            'action_category': 'user',
            'action_name': 'lead_submission',
            'subaction_name': 'submit',
            'action_cause': 'button_click',
            'creative_id': 'edm-entry-pricing-lead-form-thank-you'
        }
    });
}


module.exports = {
    loadThankyouPage: function (params) {
        fireThankyouTracking();
        makeParamsStr(params);
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(149);
var validateLeadForm = __webpack_require__(131);
var thankyouPage = __webpack_require__(152);
var tracking = __webpack_require__(150);
var deferredLoader = __webpack_require__(121);
var queryString = __webpack_require__(120);
var utils = __webpack_require__(12);
var leadformDrawer ='.lead-form-pricing-drawer.modal-drawer';
var thankyouDrawer ='.lead-form-price-promise-thank-you.modal-drawer';
var pricingLeadFormHelper = __webpack_require__(151);
var forms = {};
var timestamp = 0;

var leadTypeUrls = {
    '1':'/api/lead/v1/dealerlocator/',
    '2':'/api/lead/v1/new/',
    '4':'/api/lead/v1/newpricepromise/'
};

function makeParamsStr(params) {
    return queryString.stringify(params, {
        strict: true,
        encode: true
    });
}

function createLeadForm() {
    timestamp = Date.now();
    var leadFormEl = $('.lead-form-pricing .lead-form:visible');
    var options = $('.lead-form-pricing').data('options');
    return validateLeadForm.createLeadForm((leadFormEl), options);
}

function clearSameForm(name) {
    var theForm = forms[name];
    if (theForm) {
        theForm.clear();
        theForm = null;
    }
}

function onSubmit(e, params) {

    var theForm = e.target;
    var selectDealerErrorEl = $(theForm).find('.select-dealer-error');
    var selData = pricingLeadFormHelper.getSelectedData();
    selectDealerErrorEl.toggleClass('hidden-xs-up', selData.length > 0);
    if(!selData.length) {
        return;
    }
    var formData = utils.getFormData(theForm);
    var totalPossibleLeads = pricingLeadFormHelper.getInventoryCount();
    var thankYouObj = utils.fillThankyouData(theForm, selData);
    var idea = {'2':'NCI','4':'PP'};
    var typeStr = '';
    var blended = 'n';

    $.ajax({
        type: 'POST',
        url: utils.getThankYouPageUrl(),
        contentType: 'application/json',
        data: JSON.stringify(thankYouObj),
        dataType: 'json'
    }).then(function(result){
        $('#edm-entry-new-pp-multi-select-thank-you').html(result.htmls[Object.keys(result.htmls)[0]]);
    }).then(function(){
        thankyouPage.loadThankyouPage(params);
    });

    var promiseArr = selData.map(function (vehData, index) {
        var leadOpportunityKey = utils.fillLeadOpportunityKey(vehData, index, totalPossibleLeads);
        var data = utils.fillData(formData, vehData, params.zipcode, leadOpportunityKey, timestamp);

        if(typeStr.length > 0 && idea[vehData.leadType]){
            typeStr += (','+idea[vehData.leadType]);
            blended='y';
        } else if(typeStr.length === 0 && idea[vehData.leadType]){
            typeStr = idea[vehData.leadType];
        }
        idea[vehData.leadType] = '';
        return $.ajax({
            type: 'POST',
            url: leadTypeUrls[vehData.leadType],
            contentType: 'application/json',
            data: JSON.stringify(data),
            dataType: 'json'
        }).promise();
    });

    Promise.all(promiseArr.map(utils.reflect)).then(function(results) {
        var success = results.filter(function (x) {
            return x.status === true;
        });

        // if any lead has successfully submitted
        if (success.length) {
            tracking.fireSuccessfulSubmit(typeStr, blended, selData.length);

            utils.switchToDrawer(leadformDrawer, thankyouDrawer);
        }
    });
}

module.exports = {
    createLeadForm: createLeadForm,
    loadLeadForm: function (payLoad, params) {
        tracking.fireOpenWidgetTracking();
        var paramsStr = makeParamsStr(params);
        clearSameForm(paramsStr);
        $('#edm-entry-pricing-lead-form').html('');
        return deferredLoader.loadEntryWithPost('pricing-lead-form',
                '/groundwork/lead/form/pricing/index.entry?'+paramsStr+'&entry-id=pricing-lead-form', payLoad).
            done(function () {
                tracking.readyListTracking();
                forms[paramsStr] = createLeadForm();
                utils.readyCollapse();
                pricingLeadFormHelper.addCheckboxHandler(forms[paramsStr].$form);
                forms[paramsStr].addOnSubmitCallback(function (e) {
                    onSubmit(e, params);
                });
                pricingLeadFormHelper.calcSavings();
            });
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 154 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 155 */,
/* 156 */,
/* 157 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(164);
var ehh = __webpack_require__(143);
var eventHandler = __webpack_require__(170);
var filterEvents = __webpack_require__(144);
var gptSlotIniter = __webpack_require__(122);
var dependedOnViewportAd = __webpack_require__(126);
var eventToolbox = __webpack_require__(1);
var aagCarouselContent = __webpack_require__(142);
var isMobile = __webpack_require__(141);
var cookies = __webpack_require__(91);


var aagCarousel, carouselOwl;
var EVENT_SUBMODEL_CHANGED = 'submodel-changed';
var categoriesLoaded = false;
var OPEN_FILTERS_SLIDE_INDEX = 7;
var web503 = ($('.image-type-selector').data('abtest') === 'web-503');
var opened503 = false;
var triggerToggle;
var closeToggle;
var IS_BTN_CLICK = true;



function init() {
    aagCarousel = document.querySelector('.at-a-glance-carousel-wrapper');
    if (aagCarousel) {
        carouselOwl = aagCarousel.querySelector('.owl-carousel');
        addEventHandlers();
    }
    if(!categoriesLoaded) {
        loadCategories();
    }
    // Back up if 'loaded' event takes too long
    setTimeout(function() {
        if (aagCarousel) {
            aagCarousel.classList.add('loaded');
        }
    }, 5000);
}

function defineTriggerToggle(){
    var openCookie = cookies.getItem('aagFilter');
    if(web503 && !opened503 && !openCookie){
        if(triggerToggle){
            window.clearTimeout(triggerToggle);
        }
        triggerToggle = window.setTimeout(function () {
            opened503 = true;
            if (!aagCarouselContent.isSmall()) {
                filterEvents.toggleFilter(!IS_BTN_CLICK,true);
                closeToggle = window.setTimeout(function () {
                    filterEvents.toggleFilter(false);
                },2000);
            }


        }, 4000);
    }
}

function addEventHandlers() {
    eventToolbox.subscribeCustomEvent(EVENT_SUBMODEL_CHANGED, eventHandler.handleSubmodelChange);

    defineTriggerToggle();

    if(aagCarousel) {

        $(aagCarousel).on('click', function() {
            if(closeToggle){
                window.clearTimeout(closeToggle);
            }
        });

        $(aagCarousel).on('click', '.view-photos', function() {
            $(carouselOwl).trigger('next.owl.carousel');
        });

        $(aagCarousel).on('click', '.filter-btn', function() {
            if(web503){
                window.clearTimeout(triggerToggle);
                opened503 = true;
            }
            filterEvents.fireToggleFilter(IS_BTN_CLICK);
            filterEvents.toggleFilter();
        });

        $(aagCarousel).on('click', '.categories', function(e) {
            eventHandler.handleCategoryChange(e);
            if(web503 && !isMobile.any) {
                filterEvents.toggleFilter();
            }
        });

        $(aagCarousel).on('click', '.filter-close', function() {
            filterEvents.toggleFilter();
        });
    }

    if(isMobile.any) {
        $(document).on('click', filterEvents.closeFilter);
    }


    // Carousel on changed event will handle index switching
    $(carouselOwl).on('changed.owl.carousel', function() {
        ehh.getCurrentDataIndex(function(curIndex) {
            if(OPEN_FILTERS_SLIDE_INDEX === aagCarouselContent.getCurrentSlideIndex() && !aagCarouselContent.isSmall() && !web503) {
                filterEvents.toggleFilter(!IS_BTN_CLICK,true);
            }

            defineTriggerToggle();

            eventHandler.updateIndexes(curIndex, null, null);
            //Update Caption
            eventHandler.populateAltBox(curIndex);
            var indexes = eventHandler.getIndexes();

            // //Append 2 slots before (0, 1, etc - interger scale)
            if (indexes.x - indexes.currentIndex == 1) {
                //console.log('append');
                eventHandler.appendPhotos(indexes.x + 1);
            }
            // Prepend 2 slots before (2 - natural number scale because it's in reverse)
            else if (Math.abs(indexes.y - indexes.currentIndex) == 2) {
                //console.log('prepend');
                eventHandler.appendPhotos(indexes.y - 5, true);
            }
        });
    });

    $(carouselOwl).on('translated.owl.carousel', function(e) {
        var $slide = $(e.target)
            .find('.owl-item')
            .eq(e.item.index);
        dependedOnViewportAd.setSlotIniter(gptSlotIniter);
        dependedOnViewportAd.carouselSlideViewportAdsInView($slide);
    });


    // On carousel load, we want to populate our available categories,
    // this requires a small REST call. We also want to fetch and prepend
    // photos for back button experience.
    window.addEventListener('load', function() {
        // Init some indexes
        if(!categoriesLoaded) {
            loadCategories();
        }

        // backup current slides
        aagCarouselContent.backup('home');
    });

    // START: For AB Test WEB-466
    // We want to auto-open filters after 3 s.
    if($('.image-type-selector')) {
        if($('.image-type-selector').data('abtest') === 'web-466') {
            window.setTimeout(function() {
                if(!aagCarouselContent.isSmall()) {
                    filterEvents.toggleFilter(!IS_BTN_CLICK,true);
                }
            }, 3000);
        }
    }
    // END: For AB Test WEB-466
}

function loadCategories() {
    ehh.getCurrentDataIndex(function(curIndex) {
        eventHandler.updateIndexes(curIndex, 5, null);
    });

    // Initial Prepend some photos in case the user wants to go previous.
    eventHandler.fetchIndexes(function(data) {
        var index = data.totalCounts[0].currentPhotoCount - 5;
        // TODO [FIND-1623] Remove this dataStorage for at-a-glance because
        // we don't want it to fire when it appends photos from the ajax call
        window.EDMDataStorage.aagChangeSlideSkipPixelFire = true;
        categoriesLoaded = true;
        eventHandler.appendPhotos(index, true);
    });
    if (aagCarousel) {
        aagCarousel.classList.add('loaded');
    }
}



init();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(165);

var vehicleMake = window.EDM.PageValues.vehicle.make.niceName;
var isMazda = vehicleMake && vehicleMake === 'mazda';
if (isMazda) {
    var data = __webpack_require__(171);
}

var controller = __webpack_require__(174);
var styleId = window.EDM.PageValues.vehicle.style.id;

var adRefresh = __webpack_require__(175);
var gptSlotIniter = __webpack_require__(122);

$('.core-build-module').each(function(index, component) {
    var $component = $(component),
        $carouselBtnGroup = $component.find('.swatch-outer'),
        $carouselActiveSlides = $component.find('.owl-item'),
        $legacyLinkout = $component.find('.legacy-linkout'),
        $buildOwlCarousel = $component.find('.owl-carousel');

    $carouselBtnGroup.on('click', function(e){
        controller.swatchClickHandler(e, $buildOwlCarousel, $carouselBtnGroup, $component);
        if (isMazda) {
            data.getVehicle(styleId);
        }
    });

    $carouselActiveSlides.on('click', function(e){
        if(!$(e.currentTarget).hasClass('center')) {
            controller.triggerSlide(e.currentTarget, $buildOwlCarousel);
        }
    });

    $buildOwlCarousel.on('changed.owl.carousel', function(e) {
        controller.slideChangeHandler(e, $carouselBtnGroup, $component);
        refreshDeepLinkAd($component);
    });

    $legacyLinkout.on('click', function(){
        controller.fireLinkoutTracking($component);
    });
});

/**
 * Refreshes ad units enclosed in container with class .deep-link-ad (DFP) and .build-deep-link (hard-coded, Mazda)
 * @param $component
 */
function refreshDeepLinkAd($component) {
    var slot = gptSlotIniter.getAdIdToSlot(),
        id = $component.find('.build-deep-link .punit > div').attr('id')
    || $component.find('.deep-link-ad .punit > div').attr('id');
    id && adRefresh.refreshAdSlot(slot[id]);
}

if (isMazda) {
    $(document).ready(function() {
        data.getVehicle(styleId);
    });
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(166);

__webpack_require__(114);

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(172);
__webpack_require__(173);

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(167);
__webpack_require__(130);
__webpack_require__(114);

var eventToolbox = __webpack_require__(1);
var ppMultiLeadForm = __webpack_require__(153);
var vehicle = window.EDM.PageValues.vehicle;
var page = window.EDM.PageValues.page;


// Tracking
var savingRetrieval = window.EDMDataStorage.pricingModuleSavingRetrieval;
if(savingRetrieval) {
    savingRetrieval.event_data.action_category = 'user';
    savingRetrieval.event_data.action_cause = 'page_load';
    savingRetrieval.ads = {
        disable_refresh: true
    };
    eventToolbox.fireAction(savingRetrieval);
}

function processOpts(installedOptions){
    var optString = '';
    if(installedOptions){
        for(var i = 0; i < installedOptions.length; i++){
            optString = optString + installedOptions[i].id;
            if(i < installedOptions.length - 1){
                optString = optString +',';
            }
        }
    }
    return optString;
}

function _clickHandler(e) {
    var $el = $(this);
    var dataEle = $el.closest('#edm-entry-pricing .card-view-price-now');
    var linkClickData = dataEle.data('link-click');
    var modalEle = $($el.attr('data-target'));
    modalEle.modal('show');
    var payLoad = dataEle.data('pricingConfig');
    payLoad.pricingCategory = payLoad.category;
    payLoad.category = undefined;
    payLoad.estimatedSavings = dataEle.data('estimatedSavings');
    var params = {
        make:vehicle.make.niceName,
        model:vehicle.model.niceName,
        year:vehicle.modelYear.year,
        styleId: payLoad.styleId,
        leadSource: 'core',
        callToAction:'purchaseOffer',
        range:50,
        submodel:payLoad.subModels[0],
        trim:payLoad.trim,
        buildData:((payLoad.installedOptions && payLoad.installedOptions.length > 0)?true:false),
        optIds:processOpts(payLoad.installedOptions),
        pageName: page.name,
        pageCat: page.category,
        zipcode: window.EDM.PageValues.region.zipCode
    };
    $('.lead-form-pricing-drawer').one('shown.bs.modal', function(){
        ppMultiLeadForm.loadLeadForm(payLoad, params);
    });
    if(linkClickData) {
        linkClickData.event_category = 'user';
        $.extend(linkClickData.event_data, {
            'creative_id': 'edm-entry-pricing',
            'action_cause': 'button_click'
        });
        eventToolbox.fireAction(linkClickData);
    }
    e.stopPropagation();
}



$('#edm-entry-pricing .card-view-price-now').on('click', _clickHandler);
$('#edm-entry-pricing .btn.view-price-now').on('click', _clickHandler);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(168);

// Always include below because it's non deferred and ALWAYS RENDERED!
__webpack_require__(92); // core page scss is needed because its core page :D
__webpack_require__(101);
__webpack_require__(20);
__webpack_require__(93);
__webpack_require__(27);
__webpack_require__(95);
__webpack_require__(28);
__webpack_require__(19);
__webpack_require__(96);
__webpack_require__(16);
__webpack_require__(10);
__webpack_require__(97);
__webpack_require__(94);
__webpack_require__(21);

__webpack_require__(84);

var trackingMap = __webpack_require__(98),
    trackingHandler = __webpack_require__(48);

trackingHandler.useMap(trackingMap);


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(169);
__webpack_require__(114);


/***/ },
/* 164 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 165 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 166 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 167 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 168 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 169 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var ehh = __webpack_require__(143);
var filterEvents = __webpack_require__(144);
var aagcData = __webpack_require__(182);
var carouselEvents = __webpack_require__(89);
var aagCarouselContent = __webpack_require__(142);
var EventHandlers = function() {
    var aagc, cats, cOwl, captionText;
    var indexesCalculated = false;
    var firstPrepend = false;
    var OFFSET = 5;
    var carouselIndexes = { currentIndex: 0, x: 0, y: 0 };
    var currentFilterCategory = aagcData.CATEGORY_HOME;
    var web503 = ($('.image-type-selector').data('abtest') === 'web-503');

    aagc = document.querySelector('.at-a-glance-carousel-wrapper');
    if (aagc) {
        cats = aagc.querySelector('.categories');
        cOwl = aagc.querySelector('.owl-carousel');
        captionText = aagc.querySelector('.caption-text');
    }

    // Repopulates Image Carousel with given Image Category, IE: exterior, dashboard, etc.
    var updateCarouselWith = function(imageType) {
        var options = {
            imageType: imageType
        };
        aagcData.getSomeData(aagcData.getRestUrl(options), function(data) {
            if (data && data.photos) {
                aagCarouselContent.clear();

                // Get Category Photos
                pushPhotos(data, aagcData.getIndexOfCategory(imageType), false);

            }
        }).then(function() {
            var index = aagcData.getIndexOfCategory(imageType) - OFFSET;
            if(index < 0) {
                index = OFFSET;
            }
            // Prepend (like init, so if user goes back)
            var options = { 'index': index };

            aagcData.getSomeData(aagcData.getRestUrl(options), function(data2) {
                pushPhotos(data2, options.index, true);
            }).then(function() {
                // Reposition to current slide, because prepend/refresh repositions carousel to 0 slot.
                carouselEvents.changeSlide($(cOwl), OFFSET, 85);
                _updateIndexes(null, aagcData.getIndexOfCategory(imageType) + OFFSET - 1, null);
            });
        });
    };

    var applyHomeCategory = function() {
        // move to the initial slide
        if(currentFilterCategory != aagcData.CATEGORY_HOME) {
            aagCarouselContent.restore(aagcData.CATEGORY_HOME);
        } else {
            carouselEvents.changeSlide($(cOwl), OFFSET, 85);
        }
    };

    var changeCategory = function(categoryId) {
        (categoryId === aagcData.CATEGORY_HOME || categoryId === 'all' ) ? applyHomeCategory() : updateCarouselWith(categoryId);
        filterEvents.fireChangeContent(categoryId);
        currentFilterCategory = categoryId;
        aagCarouselContent.isSmall() && filterEvents.toggleFilter(false);
    };

    var pushPhotos = function(data, startIndex, prepend) {
        var indexPlus = startIndex;
        var prependIndex = startIndex + OFFSET;
        var photoCount = 0;
        for (var cat in data.photos) {
            if (data.photos[cat].length) {
                var photosArr = data.photos[cat];
                if (prepend) {
                    photosArr = photosArr.reverse();
                }
                photosArr.forEach(function(el) {
                    var slide;
                    photoCount++;
                    if (prepend) {
                        slide = ehh.createSlide(el, true, --prependIndex);
                        carouselEvents.addSlide($(cOwl), slide, 0);
                    } else {
                        slide = ehh.createSlide(el, true, ++indexPlus);
                        carouselEvents.addSlide($(cOwl), slide);
                    }
                });
            }
        }

        if (prepend) {
            postPrepend(startIndex, photoCount);
        } else {
            _updateIndexes(null, carouselIndexes.x + OFFSET, null);
        }
        // Refreshing the carousl, rebuilds Owl, and settimeout helps removes carousel Jank from refresh.
        // DO NOT REMOVE unless you know what you're doing - Jason.
        setTimeout(function() {
            carouselEvents.refresh($(cOwl));
        }, 800);
    };

    var postPrepend = function(startIndex, photoCount) {
        _updateIndexes(null, null, startIndex);
        // Loser Logic to handle indexes in initial prepend.
        if(!photoCount) {
            photoCount = 0;
        }
        if (!firstPrepend) {
            firstPrepend = true;
            var offset = photoCount < OFFSET ? photoCount : OFFSET;
            var iil = parseInt(aagc.getAttribute('data-initial-image-length'), 10) - 1;
            _updateIndexes(null, iil || offset, null);
            carouselEvents.changeSlide($(cOwl), offset, 100);
        }
    };

    var _updateIndexes = function(idx, x, y) {
        if (typeof idx == 'number') {
            carouselIndexes.currentIndex = idx;
        }
        if (typeof x == 'number') {
            carouselIndexes.x = x;
        }
        if (typeof y == 'number') {
            carouselIndexes.y = y;
        }
    };

    return {
        getIndexes: function() {
            return carouselIndexes;
        },
        updateIndexes: _updateIndexes,
        fetchIndexes: function(cb) {
            if (!indexesCalculated && cats && cats.innerHTML.length < 1) {
                var options = {
                    minimal: true
                };
                indexesCalculated = true;
                aagcData.getSomeData(aagcData.getRestUrl(options), function(data) {
                    if (data) {
                        aagcData.calculateIndexes(data);
                        ehh.populateTypeFilter(aagcData, cats, data.categoryCounts);
                        if (cb) {
                            cb(data);
                        }
                    }
                });
            }
        },

        populateAltBox: function(curIndex) {
            if (curIndex) {
                var el = aagc.querySelector('.item[data-index="' + curIndex + '"] .carousel-image');
                var caption = el.getAttribute('data-alt');
                captionText.innerHTML = caption;
            }
        },
        appendPhotos: function(getIndex, prepend, atIndex) {
            if(getIndex > -1) {
                var options = { index: getIndex };
                aagcData.getSomeData(aagcData.getRestUrl(options), function(data) {
                    if (data && data.photos) {
                        pushPhotos(data, options.index, prepend || false, atIndex);
                    }
                });
            }
        },
        handleSubmodelChange: function(e, data) {
            if (data.submodelDisplayName) {
                aagc.querySelector('.submodel-label').innerHTML = data.submodelDisplayName;
            }
        },
        handleCategoryChange: function(e) {
            var tar = e.target;
            e.preventDefault();
            if(web503){
                var aTag = $(tar).closest('a');
                captionText.innerHTML = '';
                if(aTag.length > 0 && aTag[0].nodeName === 'A'){
                    changeCategory(aTag[0].getAttribute('data-image-type'));
                }
            } else if (tar && tar.nodeName === 'A') {
                captionText.innerHTML = '';
                changeCategory(tar.getAttribute('data-image-type'));
            }
        }
    };

};
module.exports = new EventHandlers();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var responsiveToolkit = __webpack_require__(7);
var utilities = __webpack_require__(190);
var breakpointCheck = utilities.breakpointCheck(responsiveToolkit);

var deepLinkData1 = __webpack_require__(184);
var deepLinkData2 = __webpack_require__(185);
var deepLinkData3 = __webpack_require__(186);
var oem = $.extend(deepLinkData1.oem1, deepLinkData2.oem2, deepLinkData3.oem3);
var $buildDeepLink = $('.core-build-module .build-deep-link');
var vehicle = {};

var findColors = __webpack_require__(183);

function getVehicleByStyleId(styleId){
    return $.getJSON (
        '/api/vehicle/v2/styles/' + styleId + '?view=full'
    );
}

var getVehicle = function(styleId) {
    return getVehicleByStyleId(styleId).then(prettify);
};

var prettify = function(vehicleData) {
    vehicleModel(vehicleData);
    vehicleTrain(vehicleData);
    vehicleTrim(vehicleData);
    vehicleOptions(vehicleData);
    vehicleCode(vehicleData);
    checkYear(vehicleData);

    findColors.vehicleColors(vehicleData);
    $.extend(vehicle, findColors.vehicle);
    makeDeepLink();
};

function vehicleModel(data) {
    vehicle.name = data.make.name;
    vehicle.niceName = data.make.niceName;
    vehicle.model = data.model.niceName;
    vehicle.submodel = data.submodel.niceName;
}
function vehicleCode(data) {
    vehicle.code = data.manufacturerCode || '';
    vehicle.crossover = data.categories.crossover || '';
}
function vehicleTrain(data) {
    vehicle.driveTrain = '';
    vehicle.transmission = data.transmission.transmissionType || '';

    if(data.drivenWheels.indexOf('front') > -1) {
        vehicle.driveTrain = 'FWD';
    }
    if(data.drivenWheels.indexOf('rear') > -1) {
        vehicle.driveTrain = 'RWD';
    }
    if(data.drivenWheels.indexOf('all') > -1) {
        vehicle.driveTrain = 'AWD';
    }
}
function vehicleTrim(data) {
    vehicle.trim = data.trim || '';
    vehicle.id = data.model.id.toLowerCase();
}
function vehicleOptions() {
    vehicle.pageNumber = 2;
    vehicle.package = '';
    vehicle.option = '';
}
function checkYear(data) {
    vehicle.year = data.year.year || null;
    if(vehicle.year == null) {
        if($('.legacy-linkout')[0]) {
            vehicle.year = $('.legacy-linkout')[0].href.split('/')[5];
        }
    }
}

function makeDeepLink() {
    var deepLinkOem = oem[vehicle.niceName.split('-')[0]];
    if(!deepLinkOem) { return; }
    var deepLink = deepLinkOem.build(vehicle);

    if(vehicle.year != '2015' && deepLink &&
      (!breakpointCheck('<=sm') || ['acura','honda','lexus'].includes(vehicle.make.toLowerCase()))) {

        var punitWrapper = document.createElement('div'),
            punit = document.createElement('div');

        punitWrapper.classList.add('punit-wrapper');
        punit.classList.add('punit');
        punit.classList.add('hidden-xs-up');
        punit.setAttribute('data-targeting', 'pos=1;adname=deeplink');

        $buildDeepLink.attr('href', deepLink);

        if(['nv200', 'nv-cargo', 'nv-passenger'].includes(vehicle.model.toLowerCase())) {
            $buildDeepLink.find('.link-message').text(deepLinkOem['message-van']);
        } else {
            $buildDeepLink.find('.link-message').text(deepLinkOem.message);
        }

        $buildDeepLink.removeClass('hidden-xs-up');
        punitWrapper.appendChild(punit);
        $buildDeepLink[0].appendChild(punitWrapper);
        $buildDeepLink.find('.punit').asyncGptTag({});
    }
}

module.exports = {
    getVehicle: getVehicle
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(179);
var stringUtils = __webpack_require__(113);
var dependedOnViewportAd = __webpack_require__(126);
var gptSlotIniter = __webpack_require__(122);



function _initDOM() {
    var _editorialDrawer = $('#editorial-review-drawer'),
        editorialCarouselOwl = $('.editorial-review-carousel-container .owl-carousel');

    function ctaClickHandler(e) {
        var $ele = $(e.target);
        var anchor = $ele.data('targetDiv');
        var $modalContentTarget = $($ele.data('target') + ' .modal-content');
        if (anchor && anchor.length > 0) {
            _editorialDrawer.one('shown.bs.modal', function() {
                var collapsibleEle = $('#' + anchor + ' .panel-collapse');
                if (collapsibleEle) {
                    collapsibleEle.addClass('in');
                    collapsibleEle.attr('aria-expanded', true);
                    collapsibleEle.css('height', 'auto');
                }
                var anchorPosition = $('#' + anchor).position();
                if(anchorPosition) {
                    $modalContentTarget.scrollTop(anchorPosition.top);
                }
            });
        }
        e.preventDefault();
    }

    var CTAbtns = $('.editorial-cta.btn');
    $.each(CTAbtns, function() {
        $(this).on('click', ctaClickHandler);
    });

    $(editorialCarouselOwl).on('translate.owl.carousel', function(e) {
        var $slide = $(e.target)
            .find('.owl-item')
            .eq(e.item.index);
        dependedOnViewportAd.setSlotIniter(gptSlotIniter);
        dependedOnViewportAd.carouselSlideViewportAdsInView($slide);
    });
    
    function getStyleId(ele) {
        return ele.dataset['styleId'];
    }

    function dedupeBasicArray(arr) {
        var newMap = arr.reduce(function(prev, cur){
            prev[cur] = true;
            return prev;
        }, {});
        return Object.getOwnPropertyNames(newMap);
    }

    var similarVehiclesEles = $('.similar-vehicle[data-style-id]');
    var styleIdsWithDupes = Array.prototype.map.call(similarVehiclesEles, getStyleId);
    var styleIds = dedupeBasicArray(styleIdsWithDupes);
    var styleMSRPMap = {};
    if (styleIds.length) {
        $.ajax({
            type: 'GET',
            url: '/api/vehicle/v3/styles?id='+ styleIds.join(',') +'&fields=id,price(baseMSRP)',
            success: function(data) {
                data.results.forEach(function(obj) {
                    styleMSRPMap[obj.id] = stringUtils.formatAsUsPrice(obj.price.baseMSRP, 'N/A');
                });

                $.each(similarVehiclesEles, function(a, ele) {
                    ele.innerText = styleMSRPMap[ele.dataset.styleId];
                });
            },
            error: function() {
                $.each(similarVehiclesEles, function(a, ele) {
                    ele.innerText = '';
                });
            }
        });
    }

}

(function() {
    _initDOM();
})();
module.exports = _initDOM;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(180);
__webpack_require__(99);

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var carouselEvent = __webpack_require__(89);
var eventToolbox = __webpack_require__(1);
var stringUtils =  __webpack_require__(113);
var prevSlideTo = -1;
//var vehicle = window.EDM.PageValues.vehicle;
//var BASE_LINKOUT = '/'+vehicle.make.niceName+'/'+
//    vehicle.model.niceName+'/'+vehicle.modelYear.year+
//    '/options/?legacy=true&sub='+vehicle.subModel.niceName+'&color=';

var any_color = 'any color';

var colorSlideMap = {};
colorSlideMap[any_color] = {val : -1};

var colorSwatchMap = {};

//function updateLinkout(colorText){
//    var color = '';
//    if(colorText !== '(any color)'){
//        color = trimSpaces(colorText);
//    }
//    $('.core-build-module .legacy-linkout')[0].href = BASE_LINKOUT + color;
//}

function changeColorTextByIndex(component, index, btnGroup){
    var colorText = component.find('.color-name-text')[0];
    colorText.textContent = btnGroup.eq(index)[0].dataset['colorName'];
//    updateLinkout(colorText.textContent);
}
function changeColorText(component, text){
    var colorText = component.find('.color-name-text')[0];
    colorText.textContent = text;
//    updateLinkout(text);
}

function totalIncrementer(slideObj, isClonedSlide){
    if(!slideObj.total){
        slideObj.total = 0;
    }
    if(!isClonedSlide){
        slideObj.total += 1;
    }
}

function mapColorSlides(slides){
    for (var i = 0, len = slides.length; i < len; i++){
        colorSlideMap[slides[i].dataset.color] = colorSlideMap[slides[i].dataset.color] ? colorSlideMap[slides[i].dataset.color] : {};
        if((colorSlideMap[slides[i].dataset.color].val !== 0 && !colorSlideMap[slides[i].dataset.color].val)
            || (colorSlideMap[slides[i].dataset.color].val > $(slides[i]).find('.item')[0].dataset.index)){
            colorSlideMap[slides[i].dataset.color] = {val : parseInt($(slides[i]).find('.item')[0].dataset.index)};
        }
        totalIncrementer(colorSlideMap[slides[i].dataset.color], $(slides[i]).closest('.owl-item').hasClass('cloned'));
    }
}

function getCenter(total){
    if(total === 3){
        return 1;
    }
    return 0;
}

function swatchClickHandler(e, carousel, btnGroup, component){
    e.preventDefault();

    if(Object.keys(colorSlideMap).length === 1){
        mapColorSlides($(carousel.find('.slide-container')));
    }
    var swatchOuter = $(e.target).closest('.swatch-outer')[0];
    var slideIndex = colorSlideMap[swatchOuter.dataset['colorName']].val;
    var speed = Math.floor(1500 / Math.abs(slideIndex - prevSlideTo));
    if(slideIndex > -1){
        var center = getCenter(colorSlideMap[swatchOuter.dataset['colorName']].total);
        carouselEvent.changeSlide(carousel, (slideIndex + center), speed);
        if(prevSlideTo === -1){
            changeColorText(component, swatchOuter.dataset['colorName']);
        }
    } else if(slideIndex === -1) {
        changeColorText(component, swatchOuter.dataset['colorName']);
    } else {
        slideIndex = prevSlideTo;
        changeColorText(component, swatchOuter.dataset['colorName']);
    }
    prevSlideTo = slideIndex;
    btnGroup.removeClass('selected');
    swatchOuter.classList.add('selected');
}

function mapSwatches(btnGroup){
    for(var i = 0, len = btnGroup.length;  i < len; i++){
        colorSwatchMap[btnGroup[i].dataset['colorName']] = i;
    }
}

function slideChangeHandler(e, btnGroup, component){
    if(Object.keys(colorSwatchMap ).length < 1){
        mapSwatches(btnGroup);
    }
    var currentColor = $($(e.target).find('.owl-item').not('.cloned')[e.page.index]).children('.slide-container')[0].dataset['color'];
    var pageIndex = colorSwatchMap[currentColor];
    changeColorTextByIndex(component, pageIndex, btnGroup);
    btnGroup.removeClass('selected');
    btnGroup.eq(pageIndex).addClass('selected');
}

function triggerSlide(target, carousel){
    var slideIndex = parseInt($(target).find('.item')[0].dataset.index);
    carouselEvent.changeSlide(carousel, slideIndex, 1000);
}

function fireLinkoutTracking(component){

    var selectedColor = component.find('.swatch-outer.selected')[0].dataset.colorName;
    if(selectedColor === any_color){
        selectedColor = '';
    }
    eventToolbox.fireAction({
        'event_type': 'action_start',
        'ads': {
            'disable_refresh': true
        },
        'event_data': {
            'action_name': 'configure_vehicle',
            'subaction_name': 'select_color',
            'action_cause': 'button_click',
            'value': stringUtils.urlFriendlySpaces(selectedColor)
        }
    });
}

module.exports = {
    swatchClickHandler: swatchClickHandler,
    slideChangeHandler: slideChangeHandler,
    fireLinkoutTracking: fireLinkoutTracking,
    triggerSlide: triggerSlide
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 180 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 181 */,
/* 182 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var constant = __webpack_require__(146);

var Data = function() {
    var CAT_ORDER = ['exterior', 'interior', 'seating', 'dashboard', 'cargo', 'color'];
    var pageValues = window.EDM.PageValues;
    var MINIMAL_PARAMS = '?count=0&photoSize={photoSize}';
    var pv = pageValues.vehicle;
    var imageIndexes;
    var REST_URL = '/api-pg/mobile-rest-media/pp-categorized/v2/media/{make}/{model}/{year}/';
    var STD_PARAMS = '?submodel={submodel}&offset={index}&count=5&photoSize={photoSize}&filterBy=all&excludeOtherSubmodels=false';

    function getPhotoSize() {
        var yearNum = parseInt(pv.modelYear.year, 10);
        return pv.publicationState === 'used' && yearNum <= 2012 ? constant.USED_PHOTO_SIZE : constant.DEFAULT_PHOTO_SIZE;
    }

    function getSubmodel() {
        return pageValues.attributes && pageValues.attributes.submodel ? pv.subModel.identifier : '';
    }

    return {
        CATEGORY_HOME: 'home',
        getRestUrl: function(options) {
            var url = REST_URL + STD_PARAMS;
            var offset = 0;
            if (options.imageType) {
                offset = imageIndexes[options.imageType];
            }
            if (options.index) {
                offset = options.index;
            }
            if (offset < 0) { offset = 0; }
            if (options.minimal) {
                url = REST_URL + MINIMAL_PARAMS;
            }
            url = url
                .replace('{make}', pv.make.niceName)
                .replace('{model}', pv.model.niceName)
                .replace('{year}', pv.modelYear.year)
                .replace('{photoSize}', getPhotoSize())
                .replace('{submodel}', getSubmodel())
                .replace('{index}', offset);
            return url;
        },
        getSomeData: function(url, cb) {
            return $.get(url, cb);
        },
        getIndexOfCategory: function(imageType) {
            return imageIndexes[imageType];
        },
        getMaxIndex: function() {
            return imageIndexes;
        },
        calculateIndexes: function(data) {
            var index = 0;
            var thing = {};
            CAT_ORDER.forEach(function(cat) {
                thing[cat] = index;
                index = index + data.categoryCounts[cat];
            });
            imageIndexes = thing;
        }
    };
};

module.exports = new Data();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var vehicle={};

function vehicleColors(data) {
    var extColor = $('.swatch-outer.selected').data(),
        intColor = $('.swatch-inner.selected').data();
    var extAPIColors = [];

    vehicle.extColor = extColor ? findExtColor(extColor.colorName) : '';
    vehicle.intColor = intColor ? findIntColor(intColor.colorName) : '';
    matchExtColors();

    function findExtColor(colorName) {
        var colorCode;
        data.colors.forEach(function (option) {
            if(option.category == 'Exterior') {
                var extColorArray = option.options;
                extColorArray.forEach(function (color) {
                    if(color.name == colorName) {
                        colorCode = color.manufactureOptionCode;
                    }
                    extAPIColors.push(color.name);
                });
            }
        });
        return colorCode || '';
    }
    function findIntColor(colorName) {
        var colorCode;
        data.colors.forEach(function (option) {
            if(option.category == 'Interior') {
                var extColorArray = option.options;
                extColorArray.forEach(function (color) {
                    if(color.name == colorName) {
                        colorCode = color.manufactureOptionCode;
                    }
                });
            }
        });
        return colorCode || '';
    }
    function matchExtColors() {
        var extColors = window.EDM.PageValues.vehicle.colors || [];
        
        extColors.filter(function (option, index) {
            if(option.color.type == 'EXTERIOR') {
                if(extAPIColors.indexOf(option.color.name) == -1) {
                    $('.swatch-outer').eq(index+1).addClass('hidden');
                } 
            } 
        });
    }
}
module.exports = {
    vehicleColors: vehicleColors,
    vehicle: vehicle
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

var CONSTANTS = __webpack_require__(128),
    CONSTANTS2 = __webpack_require__(147),
    CONSTANTS3 = __webpack_require__(129);
var oem = {
    mazda: {
        link: 'https://www.mazdausa.com/shopping-tools/build-and-price',
        message: 'www.mazdausa.com',
        build: buildMazda
    },
    fiat: {
        link: 'http://www.fiatusa.com/hostc/bmo',
        message: 'www.fiatusa.com',
        build: buildFiat
    },
    alfa: {
        link: 'https://www.alfaromeousa.com',
        message: 'www.alfaromeousa.com',
        build: buildAlfa
    },
    chrysler: {
        link: 'http://www.chrysler.com/bridge/bmo.html',
        message: 'www.chrysler.com',
        build: buildChrysler
    },
    jeep: {
        link: 'http://www.jeep.com/bridge/bmo.html',
        message: 'www.jeep.com',
        build: buildJeep
    },
    ram: {
        link: 'http://www.ramtrucks.com/bridge/bmo.html?app=bmo',
        message: 'www.ramtrucks.com',
        build: buildRam
    },
    acura: {
        link: 'http://www.acura.com',
        message: 'www.acura.com',
        build: buildAcura
    }
};

function buildMazda(data) {
    var model = data.model;
    (model == '3') && (model = 'mazda3-' + data.submodel);
    (model == '6') && (model = 'mazda6');
    var transmission = data.transmission.slice(0,1) + data.transmission.slice(1).toLowerCase();
    var trackingURL = CONSTANTS.TRACKING[data.niceName][data.model][data.submodel].link,
        timestamp = window.EDM.PageValues.page.timestamp;
    return trackingURL.replace('[timestamp]', timestamp) + '&ru=' +
        encodeURI(oem[data.niceName].link + '/' + model +
        '#s=' + data.pageNumber +
        '&tr=' + transmission +
        '&d=' + data.driveTrain +
        '&t=' + data.code +
        '&ex=' + data.extColor +
        '&in=' + data.intColor +
        '&p=' + data.package +
        '&ip=&o=' + data.option + '&io=');
}
function buildFiat (data) {
    var model = 'CUX' + data.year;
    (data.model == '500') && (model += '01');
    (data.model == '500e') && (model += '04');
    switch(data.model) {
    case '500l': model += '05'; break;
    case '500x': model += '06'; break;
    case '124-spider': model += '07'; 
    }
    var fiatLink = oem[data.niceName].link + '/' + model + '/models.do';
    var trackingURL = (CONSTANTS3.TRACKING[data.niceName][data.model]) ? CONSTANTS3.TRACKING[data.niceName][data.model].link + '?' : '';
    return trackingURL + encodeURI(fiatLink);
}
function buildAlfa(data) {
    var modelLink = oem[data.niceName.split('-')[0]].link,
        trackingURL = (CONSTANTS2.TRACKING[data.niceName][data.model]) ? CONSTANTS2.TRACKING[data.niceName][data.model].link + '?' : '';
    if(data.year == '2017') {
        modelLink += '/cars/';
        if(data.model == 'giulia') {
            modelLink += 'alfa-romeo-giulia-quadrifoglio.gotostyle';
        } else {
            modelLink += data.model.toUpperCase() + '-' +  data.submodel;
        }
    } else {
        modelLink += '/build-and-price/' + data.model.toUpperCase() + '-' +  data.submodel + '/' + data.year;
    }
    return trackingURL + encodeURI(modelLink);
}
function buildChrysler(data) {
    var trackingURL,
        chryslerLink = oem[data.niceName].link + '?family=' + data.model + '&year=' +  data.year;
    if(data.year == '2017' || data.year == '2016') {
        trackingURL = (CONSTANTS3.TRACKING[data.niceName][data.model]) ? CONSTANTS3.TRACKING[data.niceName][data.model].link + '?' : '';
    }

    return trackingURL + encodeURI(chryslerLink);
}
function buildJeep(data) {
    var modelLink = oem[data.niceName].link + '?family=' + data.model.replace(/-/g, '_') + '&year=' + data.year;
    if (data.year == '2016' || data.year == '2017') {
        var trackingURL = CONSTANTS2.TRACKING[data.niceName][data.model] ? CONSTANTS2.TRACKING[data.niceName][data.model].link : '';
        if (trackingURL == '' && CONSTANTS2.TRACKING[data.niceName]['']) {
            trackingURL = CONSTANTS2.TRACKING[data.niceName][''].link;
        }
        modelLink = trackingURL + '?' + encodeURI(modelLink);
    }
    return modelLink;
}
function buildRam(data) {
    return oem[data.niceName].link + '&year=' + data.year + '&vehicle=' + data.id;
}
function buildAcura(data) {
    if(data.year == '2016') {
        return null;
    }

    var acuraLink = oem[data.niceName].link,
        trackingURL = (CONSTANTS2.TRACKING[data.niceName][data.model]) ? CONSTANTS2.TRACKING[data.niceName][data.model].link + '?' : '';
    if (data.year == '2017') {
        acuraLink += '/build-price/' + data.model;
    } else {
        acuraLink += '/tools/bap/build.aspx?ProductLineName=' + data.model + '&modelYear=' + data.year;
    }
    if (data.model == 'NSX') {
        acuraLink = 'http://nsx.acura.com/build';
    }
    return trackingURL + encodeURI(acuraLink);
}

module.exports = {
    oem1: oem,
    buildMazda: buildMazda,
    buildFiat: buildFiat,
    buildAlfa: buildAlfa,
    buildChrysler: buildChrysler,
    buildJeep: buildJeep,
    buildRam: buildRam,
    buildAcura: buildAcura
};

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

var CONSTANTS = __webpack_require__(128),
    MODELS = __webpack_require__(148),
    CONSTANTS3 = __webpack_require__(129),
    arrayFind = __webpack_require__(100);
var oem = {
    kia: {
        link: 'http://www.kia.com/us/en/build',
        message: 'www.kia.com',
        build: buildKia
    },
    volvo: {
        link: 'http://www.volvocars.com/us/shopping-tools/build-your-volvo#/driveline/',
        message: 'www.volvocars.com',
        build: buildVolvo
    },
    cadillac: {
        link: 'http://www.cadillac.com/',
        message: 'www.cadillac.com',
        build: buildCadillac
    },
    honda: {
        link: 'http://automobiles.honda.com',
        message: 'automobiles.honda.com',
        build: buildHonda
    },
    hyundai: {
        link: 'https://www.hyundaiusa.com/build-your-hyundai/',
        message: 'www.hyundaiusa.com',
        build: buildHyundai
    },
    smart: {
        link: 'https://www.smart.com/us/us/',
        message: 'www.smart.com',
        build: buildSmart
    },
    maserati: {
        link: 'http://www.configurator.maserati.com/configurator/v2/?currentCountry=1&lang=en',
        message: 'www.maseratiusa.com',
        build: buildMaserati
    }
};

function buildKia(data) {
    var kiaLink = oem[data.niceName].link + '/' + data.model + '/' + data.year + '/colors-packages?trim=' +
        data.trim + '&model=' + data.code + '&exterior=' + data.extColor +
        '&interior=' + data.intColor + '&fabric=2';
    var trackingURL = (CONSTANTS3.TRACKING[data.niceName][data.model]) ? CONSTANTS3.TRACKING[data.niceName][data.model].link + '?' : '';
    return trackingURL + encodeURI(kiaLink);
}
function buildVolvo(data) {
    return oem[data.niceName].link + data.code + '/813-6USGCC-90-x-en-55117916-USD-' + data.code +
        '-x-' + data.id;
}
function buildCadillac(data) {
    if((data.year  == '2016') && (window.location.search.indexOf('story-id=ncas-469') == -1)) {
        return null;
    }
    var cadillacLink = getcadillacLink(data);
    var trackingURL = (CONSTANTS.TRACKING[data.niceName][data.model]) ? CONSTANTS.TRACKING[data.niceName][data.model].link + '?' : '';
    return trackingURL + encodeURI(cadillacLink);
}
function getcadillacLink(data) {
    if(data.year == '2017' && (data.model == 'ats-v' || data.model == 'cts-v') 
        && (window.location.search.indexOf('story-id=ncas-469') == -1)) {
        return null;
    }
    var submodel = data.submodel;
    var model = data.model;

    if(submodel == 'suv') {submodel = 'crossovers-' + submodel;}
    
    checkCadillacModel();
    submodel += 's';

    checkCadillacYear();

    return oem[data.niceName].link + submodel + '/' + model + '/build-your-own.html';
    
    function checkCadillacModel() {
        if(model.length == 3) {
            model = (data.crossover) ? (model + '-crossover') : (model + '-sedan');
        } else {
            if(model.indexOf('escalade') > -1) { model += '-suv'; }
            if(model.indexOf('-v') > 0) {
                model += '-' + submodel;
                submodel = 'v-serie';
            }
        }
    }
    function checkCadillacYear() {
        if(data.year  == '2016') {
            var cadillacLink = oem[data.niceName].link + 'preceding-year/' + model;
            if((model.indexOf('escalade') > -1) || (model.indexOf('ct6') > -1)) {
                return cadillacLink + '/build-your-own.html#/trim';
            } else {
                return cadillacLink + '.html';
            }
        }
    }
}
function buildHyundai(data) {
    return oem[data.niceName].link;
}
function buildHonda(data) {
    if(data.year == '2016') {
        return null;
    }
    
    var hondaLink = oem[data.niceName].link,
        trackingURL = (CONSTANTS3.TRACKING[data.niceName][data.model]) ? CONSTANTS3.TRACKING[data.niceName][data.model].link + '?' : '';
    if (data.year  == '2017') {
        hondaLink += '/' + data.model + '#build-price';
    } else {
        hondaLink += '/tools/build-price/accessories.aspx?ModelName=' + data.model.toUpperCase() + '&ModelYear=' + data.year  +
            '&ModelID=' + data.code;
        if(data.intColor) {
            hondaLink +=  '&EColor=' + data.extColor + '&IColor=' + data.intColor;
        }  else {
            hondaLink = hondaLink.replace('accessories', 'colors');
        }
    }
    return trackingURL + encodeURI(hondaLink);
}
function buildSmart(data) {
    if (data.year == '2016') {
        return null;
    }
    if(data.model == 'electric drive') {
        return oem[data.niceName].link + 'build-your-own/electric-drive-cars.html';
    }
    return oem[data.niceName].link + 'microsites/build-your-own/gas-cars.html';
}
function buildMaserati(data) {
    var idArray = MODELS.model.maserati;
    var trim;

    trim = arrayFind(idArray, function (modelId) {
        return (modelId.niceName.toLowerCase().replace(/ /g,'-') == data.model) && (modelId.trim == data.trim);
    }).id;
    trim = trim || data.code;

    return oem[data.niceName].link + '&modelName=' + trim;
}

module.exports = {
    oem2: oem,
    buildKia: buildKia,
    buildVolvo: buildVolvo,
    buildCadillac: buildCadillac,
    buildHonda: buildHonda,
    buildHyundai: buildHyundai,
    buildSmart: buildSmart,
    buildMaserati: buildMaserati
};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

var CONSTANTS = __webpack_require__(128),
    CONSTANTS2 = __webpack_require__(147),
    CONSTANTS3 = __webpack_require__(129),
    MODELS = __webpack_require__(148),
    MODELS2 = __webpack_require__(187),
    arrayFind = __webpack_require__(100);
var oem = {
    dodge: {
        link: 'http://www.dodge.com/',
        message: 'www.dodge.com',
        build: buildDodge
    },
    lexus: {
        link: 'http://www.lexus.com/build-your-lexus/#!/series/',
        message: 'www.lexus.com',
        build: buildLexus
    },
    nissan: {
        link: 'https://www.nissanusa.com/buildyournissan/modelLine/build/',
        message: 'www.nissan',
        'message-van': 'NissanCommercialVehicles.com',
        build: buildNissan
    },
    chevrolet: {
        link: 'http://www.chevrolet.com/',
        message: 'www.chevrolet.com',
        build: buildChevrolet
    }
};

function buildLexus(data) {
    var model = data.model.split('-')[0].toUpperCase();
    if(data.model.indexOf('h') !== -1) {
        model += 'h';
    }
    var code = data.code;
    code = code.replace(/^9335$/, '9313');
    code = code.replace(/^9225$/, 'v9202F');
    var lexusLink = oem[data.niceName].link + model + '/year/' + data.year + '/trim/' + code + '/buildId/111';
    var trackingURL = (CONSTANTS.TRACKING[data.niceName][data.model]) ? CONSTANTS.TRACKING[data.niceName][data.model].link + '?' : '';

    if(data.intColor) {
        lexusLink += '/interior-colors/my-dream-car/{-x-:-' + data.extColor + '-,-i-:-' + data.intColor + '-,-a-:[],-p-:[],-z-:[]}';
    }

    return trackingURL + encodeURI(lexusLink);
}
function buildNissan(data) {
    var idArray = MODELS.model.nissan;
    var code;

    code = arrayFind(idArray, function (modelId) {
        return (modelId.niceName.toLowerCase().replace(/ /g, '-') == data.model) && (modelId.submodel == data.submodel);
    }).id;
    code = code || data.code;

    var nissanLink = 'http://www.nissancommercialvehicles.com/build/model/' + code,
        trackingURL = (CONSTANTS2.TRACKING[data.niceName][data.model]) ? (CONSTANTS2.TRACKING[data.niceName][data.model].link + '?') : '';

    checkNissanLink(data,code,nissanLink);

    return trackingURL + encodeURI(nissanLink);
}
function checkNissanLink(data,code,nissanLink) {
    if(code.toLowerCase().indexOf('nv') == -1) {
        nissanLink = oem[data.niceName].link + data.year  + '/' + code;
    }
    if(code == 'nv200-taxi') {
        nissanLink = 'http://www.nissancommercialvehicles.com/nv200-taxi';
    }
    return {
        nissanLink: nissanLink
    };
}
function buildChevrolet(data) {
    var chevroletLink = oem[data.niceName].link;
    var idArray = MODELS.model.chevrolet;
    var submodel;

    submodel = arrayFind(idArray, function (modelId) {
        return modelId.niceName.toLowerCase().replace(/ /g, '-') == data.model;
    }).id;

    submodel = submodel || data.submodel;

    if(data.year  == '2016') { chevroletLink += '2016-'; }
    chevroletLink += submodel + '/build-your-own.html#/trim';

    var trackingURL = (CONSTANTS2.TRACKING[data.niceName][data.model]) ? CONSTANTS2.TRACKING[data.niceName][data.model].link + '?' : '';
    return trackingURL + encodeURI(chevroletLink);
}
function buildDodge(data) {
    if(data.model == 'grand-caravan' && data.year == '2016' && window.location.search.indexOf('story-id=ncas-373') == -1) {
        return null;
    }
    if(window.location.search.indexOf('story-id=ncas-373') > -1) {
        var dodgeLink = oem[data.niceName].link + 'hostc/bmo/CUD';
        var idArray = MODELS2.model.dodge;
        var id, code, llp;
        idArray.map(function (val) {
            if(val.niceName == data.model) {
                id = val.id; 
                code = val.code;
                llp = val.llp;
            }
        });
        dodgeLink += data.year + id + '/models.do';
        if(data.year == '2016') {
            return dodgeLink;
        }
        return dodgeLink + '?ccode=CUD' + data.year + id + code + '&llp=' + llp;
    }

    var dodgeInfo = getDodgeInfo(data);
    return dodgeInfo.trackingURL + encodeURI(dodgeInfo.vehicleLink);
}
function getDodgeInfo(data) {
    var vehicleLink = oem[data.niceName].link,
        trackingURL = (CONSTANTS3.TRACKING[data.niceName][data.model]) ? CONSTANTS3.TRACKING[data.niceName][data.model].link + '?' : '';
    if (data.year== '2017') {
        vehicleLink += data.year + '/' + data.model  + '/index.html';
    } else {
        vehicleLink += 'en/' + data.model.replace(/-/g, '_');
    }

    if (data.year == '2017' && data.model == 'grand-caravan') {
        var conquestMake = 'chrysler',
            conquestModel = 'pacifica';
        trackingURL = (CONSTANTS3.TRACKING[conquestMake]['conquest'][data.niceName]) ?
            CONSTANTS3.TRACKING[conquestMake]['conquest'][data.niceName][data.model].link + '?' : '';
        oem[data.niceName].message = oem[conquestMake].message;
        vehicleLink = oem[conquestMake].link + '?family=' + conquestModel + '&year=' +  data.year;
    }

    return {
        trackingURL: trackingURL,
        vehicleLink: vehicleLink
    };
}

module.exports = {
    oem3: oem,
    buildLexus: buildLexus,
    buildNissan: buildNissan,
    buildChevrolet: buildChevrolet,
    buildDodge: buildDodge
};

/***/ },
/* 187 */
/***/ function(module, exports) {

var model = {
    'dodge': [
        { 'niceName': 'charger',       'id': '04', 'code': 'LDDM48A', 'llp': '2DG' },
        { 'niceName': 'challenger',    'id': '03', 'code': 'LADH22A', 'llp': '2DA' },
        { 'niceName': 'dart',          'id': '19', 'code': '', 'llp': '' },
        { 'niceName': 'viper',         'id': '07', 'code': 'ZDDH29A', 'llp': '2DH' },
        { 'niceName': 'journey',       'id': '09', 'code': 'JCDH49A', 'llp': '2DF' },
        { 'niceName': 'durango',       'id': '11', 'code': 'WDDL75A', 'llp': '2TA' },
        { 'niceName': 'grand-caravan', 'id': '05', 'code': 'RTKH53I', 'llp': '2DS' }
    ]
};

module.exports = {
    model: model
};

/***/ },
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */
/***/ function(module, exports) {

window.EDM || (window.EDM = {});
var EDM = window.EDM;
EDM.SentimentWidget || (EDM.SentimentWidget =
{
    smileyData: [
        { name: 'good', value: 1 },
        { name: 'neutral', value: 5 },
        { name: 'bad', value: 9 }
    ]
});

function _makeSmileyPixel(name, ratingIdx) {
    return {
        name: name,
        questionid: 'universal_sentiment_widget',
        score: EDM.SentimentWidget.smileyData[ratingIdx].value,
        rating: EDM.SentimentWidget.smileyData[ratingIdx].name,
        action: 'click',
        action_widget_id: 'sentiment'
    };
}

// function _fireSmileyPixel(/*name, ratingIdx*/) {
//     var vals = _makeSmileyPixel.apply(this, arguments);
//     $(window.document).trigger('action', {
//         event_type: 'sentiment',
//         data: vals
//     });
// }

function _makeFeedbackPixel(name, ratingIdx, comment) {
    return {
        name: name,
        questionid: 'universal_sentiment_widget',
        score: EDM.SentimentWidget.smileyData[ratingIdx].value,
        rating: EDM.SentimentWidget.smileyData[ratingIdx].name,
        comment: comment,
        action: 'click',
        action_widget_id: 'sentiment'
    };
}

// function _fireFeedbackPixel(/*name, ratingIdx, comment*/) {
//     var vals = _makeFeedbackPixel.apply(this, arguments);
//     $(window.document).trigger('action', {
//         event_type: 'sentiment',
//         data: vals
//     });
// }

module.exports = {
    makeSmileyPixel: _makeSmileyPixel,
    makeFeedbackPixel: _makeFeedbackPixel
    //fireSmileyClickPixel: _fireSmileyPixel,
    //fireFeedbackPixel: _fireFeedbackPixel
};


/***/ },
/* 192 */,
/* 193 */,
/* 194 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(228);


/***/ },
/* 195 */,
/* 196 */,
/* 197 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(235);
__webpack_require__(247);
var tracking = __webpack_require__(191);

window.EDM || (window.EDM = {});
var EDM = window.EDM;
EDM.SentimentWidget || (EDM.SentimentWidget =
{
    smileyData: [
        { name: 'good', value: 1 },
        { name: 'neutral', value: 5 },
        { name: 'bad', value: 9 }
    ]
});

EDM.SentimentWidget.WidgetController = {
    initWidget: function(name, ele, initialRating, noDrawer) {
        var _smileyContainer = ele.querySelector('.sentiment-link-area');
        //var _feedbackFormEle = $('#sentimentFeedbackForm');
        var _selectedIndex = -1;
        _smileyContainer.addEventListener('click', _smileyContainerClickHandler);
        var _smileyNames = ['.sentiment-icon.good', '.sentiment-icon.neutral', '.sentiment-icon.bad'];

        _smileyNames.forEach(function(val, idx) {
            _smileyContainer.querySelector(val).setAttribute('data-link-click',
                JSON.stringify(tracking.makeSmileyPixel(name, idx)));
        });

        function _findClickedIndex(target) {
            return Array.prototype.indexOf.call(_smileyContainer.children, target);
        }

        function _toggleIndex(idx) {
            _smileyContainer.classList.toggle(EDM.SentimentWidget.smileyData[idx].name);
        }

        function _smileyContainerClickHandler(e) {
            var target = e.target || e.srcElement;
            if (!target.classList.contains('sentiment-icon')) {
                return;
            }
            var idx = _findClickedIndex(target.parentElement);
            _activateClicked(idx);
            //tracking.fireSmileyClickPixel(name, idx);
            if (!noDrawer) {
                // open up drawer
                EDM.SentimentWidget.FeedbackForm.openForm(name, idx);
            }
        }

        function _activateClicked(idx) {
            if (_selectedIndex !== -1) {
                _toggleIndex(_selectedIndex);
            } else {
                _smileyContainer.classList.remove(_smileyContainer.classList.item(1));
            }
            _selectedIndex = idx;
            _toggleIndex(_selectedIndex);
        }

        if (initialRating) {
            _activateClicked(initialRating);
        }  
    }
};

$(document).ready(function() {
    var _sentimentWidgets = document.querySelectorAll('.sentiment-widget-container');
    [].forEach.call(_sentimentWidgets, function(widget) {
        var parent = widget.parentElement;
        EDM.SentimentWidget.WidgetController.initWidget(parent.getAttribute('data-sentiment-name') || 'sentiment0',
            widget,
            parent.getAttribute('data-initial-rating') || 0,
            !!parent.getAttribute('data-nodrawer'));
    });
});



/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 235 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */
/***/ function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__(234);
var tracking = __webpack_require__(191);

window.EDM || (window.EDM = {});
var EDM = window.EDM;
EDM.SentimentWidget || (EDM.SentimentWidget =
{
    smileyData: [
        { name: 'good', value: 1 },
        { name: 'neutral', value: 5 },
        { name: 'bad', value: 9 }
    ]
});

EDM.SentimentWidget.FeedbackForm = function() {
    var _sentimentName, _feedbackFormEle, _formEle, _sendBtnEle, _textArea,
        _sentimentContainer, _thankYouPageEle, _currentIdx = -1;

    function _userInputHandler() {
        if (_textArea.value.length <= 0) {
            _sendBtnEle.setAttribute('disabled', true);
        } else {
            _sendBtnEle.removeAttribute('disabled');
            _sendBtnEle.setAttribute('data-link-click',
                JSON.stringify(tracking.makeFeedbackPixel(
                    _sentimentName,
                    _currentIdx,
                    _textArea.value)));
        }
    }

    function _sendButtonClickHandler() {
        // if (_textArea.value.length <= 0) {
        //     e.preventDefault();
        //     return;
        // }
        // _sendBtnEle.setAttribute('data-link-click',
        //     JSON.stringify(tracking.makeFeedbackPixel(
        //         _sentimentName,
        //         _currentIdx,
        //         _textArea.value)));
        _showThankYouPage();
    }

    function _sentimentClickHandler(e) {
        var target = e.target || e.srcElement;
        if (!target.classList.contains('sentiment-icon')) {
            return;
        }
        var idx = _findClickedIndex(target.parentElement);
        _updatePlaceholder(idx);
    }

    function _showThankYouPage() {
        _formEle.querySelector('.top-area').classList.add('collapse');
        _formEle.querySelector('.bottom-area').classList.add('collapse');
        _thankYouPageEle.classList.remove('collapse');
    }

    function _findClickedIndex(target) {
        return Array.prototype.indexOf.call(_sentimentContainer.children, target);
    }

    function _generateText(word) {
        return 'You rated your experience on this page as "' + word + '"! Tell us why.';
    }

    
    function _updatePlaceholder(idx) {
        _currentIdx = idx;
        _textArea.setAttribute('placeholder', _generateText(EDM.SentimentWidget.smileyData[idx].name));
    }

    return {
        openForm: function(name, rating){
            _sentimentName = name;

            var _smileyContainer = document.querySelector('.bottom-area .smiley-area .sentiment-link-area');
            try {
                EDM.SentimentWidget.smileyData[rating].value > 0; // try to access out of bounds
            } catch(e) {
                rating = 0;
            }
            _smileyContainer.classList.add(EDM.SentimentWidget.smileyData[rating].name);
            _feedbackFormEle = $('#sentimentFeedbackForm');
            _feedbackFormEle.modal && _feedbackFormEle.modal('show');

            _formEle = _feedbackFormEle[0];

            _sendBtnEle = _formEle.querySelector('.send-btn');
            _textArea = _formEle.querySelector('textarea.user-input');
            _sentimentContainer = _formEle.querySelector('.sentiment-link-area');
            _thankYouPageEle = _formEle.querySelector('.thank-you-page');

            _textArea.addEventListener('keyup', _userInputHandler);
            _sendBtnEle.addEventListener('click', _sendButtonClickHandler);
            _sentimentContainer.addEventListener('click', _sentimentClickHandler);

            _updatePlaceholder(rating);
        }
    };
}();




/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ },
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(92);
__webpack_require__(20);
__webpack_require__(28);
__webpack_require__(93);
__webpack_require__(157);
__webpack_require__(27);
__webpack_require__(96);
__webpack_require__(16);
__webpack_require__(10);
__webpack_require__(97);
__webpack_require__(94);
__webpack_require__(95);

__webpack_require__(197);

__webpack_require__(21);
__webpack_require__(194);
__webpack_require__(19);

__webpack_require__(161);
__webpack_require__(163);
__webpack_require__(162);
__webpack_require__(159);
__webpack_require__(158);
__webpack_require__(84);
__webpack_require__(160);


var trackingMap = __webpack_require__(98),
    trackingHandler = __webpack_require__(48);

trackingHandler.useMap(trackingMap);


/***/ }
],[460]);


// WEBPACK FOOTER //
// webassets/core-page-web-437.f89533bac93f210c94e9.js